export { default as CircularProgress } from '@mui/material/CircularProgress';
import useMediaQuery from '@mui/material/useMediaQuery';
export { default as useMediaQuery } from '@mui/material/useMediaQuery';
import { capitalize } from '@mui/material/utils';
export { capitalize, debounce } from '@mui/material/utils';
import { alpha, darken, lighten, createTheme, StyledEngineProvider, styled as styled$2 } from '@mui/material/styles';
export { darken, lighten } from '@mui/material/styles';
import Divider__default from '@mui/material/Divider';
export * from '@mui/material/Divider';
export { default as Divider } from '@mui/material/Divider';
import Hidden from '@mui/material/Hidden';
export { default as Hidden } from '@mui/material/Hidden';
export * from '@mui/material/Stack';
export { default as Stack } from '@mui/material/Stack';
import styledComponents__default, { css as css$1, createGlobalStyle as createGlobalStyle$1, keyframes as keyframes$1, ThemeProvider as ThemeProvider$1 } from 'styled-components';
import React__default, { createContext, useState, useEffect, useContext, memo, forwardRef, createElement, Fragment, useMemo, useRef, cloneElement, useLayoutEffect } from 'react';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { ThemeProvider as ThemeProvider$2, makeStyles, createStyles } from '@mui/styles';
import CssBaseline from '@mui/material/CssBaseline';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import FontFaceObserver from 'fontfaceobserver';
import nbLocale from 'date-fns/locale/nb';
import nnLocale from 'date-fns/locale/nn';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import merge from 'deepmerge';
import { amber } from '@mui/material/colors';
import MuiButton from '@mui/material/Button';
import { nanoid } from 'nanoid';
import MuiIconButton from '@mui/material/IconButton';
import classNames from 'classnames';
import SvgIcon from '@mui/material/SvgIcon';
import ArrowBack from '@mui/icons-material/ArrowBackRounded';
import ArrowDownward from '@mui/icons-material/ArrowDownwardRounded';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ArrowForward from '@mui/icons-material/ArrowForwardRounded';
import ArrowUpward from '@mui/icons-material/ArrowUpwardRounded';
import ChevronDown from '@mui/icons-material/KeyboardArrowDownRounded';
import ChevronLeft from '@mui/icons-material/KeyboardArrowLeftRounded';
import ChevronRight from '@mui/icons-material/KeyboardArrowRightRounded';
import ChevronUp from '@mui/icons-material/KeyboardArrowUpRounded';
import Close from '@mui/icons-material/CloseRounded';
import Delete from '@mui/icons-material/DeleteRounded';
import Filter from '@mui/icons-material/FilterListRounded';
import HorizontalDots from '@mui/icons-material/MoreHoriz';
import Minus from '@mui/icons-material/RemoveRounded';
import Plus from '@mui/icons-material/AddRounded';
import Reset from '@mui/icons-material/AutorenewRounded';
import VerticalDots from '@mui/icons-material/MoreVert';
import ThumbUp from '@mui/icons-material/ThumbUp';
import Box$1 from '@mui/material/Box';
import Typography$1 from '@mui/material/Typography';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import MuiDrawer from '@mui/material/Drawer';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper$1 from '@mui/material/Paper';
import MuiBadge from '@mui/material/Badge';
import MuiChip from '@mui/material/Chip';
import MuiList from '@mui/material/List';
import MuiListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import MuiTable from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import MuiTableHead from '@mui/material/TableHead';
import TableSortLabel from '@mui/material/TableSortLabel';
import MuiCheckbox from '@mui/material/Checkbox';
import MuiGrid from '@mui/material/Grid';
import MuiDialog from '@mui/material/Dialog';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogTitle from '@mui/material/DialogTitle';
import FormHelperText from '@mui/material/FormHelperText';
import FormLabel from '@mui/material/FormLabel';
import Popover from '@mui/material/Popover';
import Collapse$1 from '@mui/material/Collapse';
import Modal from '@mui/material/Modal';
import MuiAutocomplete, { autocompleteClasses } from '@mui/material/Autocomplete';
import MuiTextField from '@mui/material/TextField';
import { VariableSizeList } from 'react-window';
import Popper from '@mui/material/Popper';
import styled$3 from '@mui/styled-engine';
import FormGroup from '@mui/material/FormGroup';
import Radio$1 from '@mui/material/Radio';
import RadioGroup$1, { useRadioGroup } from '@mui/material/RadioGroup';
import FormControlLabel$1 from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Box$2 from '@mui/system/Box';
import NumberFormat from 'react-number-format';
import InputLabel from '@mui/material/InputLabel';
import MuiDatePicker from '@mui/lab/DatePicker';
import { isBefore, isAfter, format } from 'date-fns';
import InputAdornment from '@mui/material/InputAdornment';
import { Link as Link$1, Pagination as Pagination$1 } from '@mui/material';
import MuiLink from '@mui/material/Link';
import MenuList from '@mui/material/MenuList';
import Grow from '@mui/material/Grow';
import MuiMenuItem from '@mui/material/MenuItem';
import withStyles from '@mui/styles/withStyles';
import createStyles$1 from '@mui/styles/createStyles';
import MuiTabs from '@mui/material/Tabs';
import MuiTab from '@mui/material/Tab';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';

var styled = {
  "default": styledComponents__default,
  css: css$1,
  createGlobalStyle: createGlobalStyle$1,
  keyframes: keyframes$1,
  ThemeProvider: ThemeProvider$1
};
var css = styled.css,
    createGlobalStyle = styled.createGlobalStyle,
    keyframes = styled.keyframes,
    ThemeProvider = styled.ThemeProvider;
var styled$1 = styled["default"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var EnergyGrade;

(function (EnergyGrade) {
  EnergyGrade["A"] = "a";
  EnergyGrade["B"] = "b";
  EnergyGrade["C"] = "c";
  EnergyGrade["D"] = "d";
  EnergyGrade["E"] = "e";
  EnergyGrade["F"] = "f";
  EnergyGrade["G"] = "g";
})(EnergyGrade || (EnergyGrade = {}));

var EnergyGrades = /*#__PURE__*/Object.values(EnergyGrade);
var HeatingGrade;

(function (HeatingGrade) {
  HeatingGrade["Green"] = "green";
  HeatingGrade["Lightgreen"] = "lightgreen";
  HeatingGrade["Yellow"] = "yellow";
  HeatingGrade["Orange"] = "orange";
  HeatingGrade["Red"] = "red";
})(HeatingGrade || (HeatingGrade = {}));

var HeatingGrades = /*#__PURE__*/Object.values(HeatingGrade);

var _EnergyGradeColors, _HeatingGradeColors;
var breakpoints = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1140,
  xl: 1920
}; // Colors from Enova design system 2022
// https://www.figma.com/file/9i4MDKdNG6xqnwrCpOBAUx/Enova-Design-System-Updated?node-id=7%3A154&t=X1SUC55IPBpbVYrS-0

var EnovaThemeColors = {
  // Greens
  mountainGreen: '#324947',
  fjordGreen: '#5ECA9B',
  lightGreen: '#B2E6CF',
  // Yellows
  darkSun: '#F9D006',
  sunYellow: '#EEF979',
  lightSun: '#FCFEE7',
  // Reds / Orange
  red: '#C85E5B',
  powerOrange: '#ED8550',
  lightRed: '#F4D8D7',
  // Blues
  oceanBlue: '#5F8899',
  skyBlue: '#9AFCFF',
  lightOcean: '#EFF3F5',
  // Greys
  black: '#2D2A2B',
  rockGrey: '#8F8F8F',
  winterGrey: '#E5E1DC',
  white: '#FFFFFF'
};
var BrandColor = EnovaThemeColors.mountainGreen;
var BrandColorSecondary = '#ef3340';
var EnergyGradeColors = (_EnergyGradeColors = {}, _EnergyGradeColors[EnergyGrade.A] = '#00A652', _EnergyGradeColors[EnergyGrade.B] = '#4FB849', _EnergyGradeColors[EnergyGrade.C] = '#C0D731', _EnergyGradeColors[EnergyGrade.D] = '#FEF200', _EnergyGradeColors[EnergyGrade.E] = '#FCB914', _EnergyGradeColors[EnergyGrade.F] = '#F37020', _EnergyGradeColors[EnergyGrade.G] = '#ED2324', _EnergyGradeColors);
var HeatingGradeColors = (_HeatingGradeColors = {}, _HeatingGradeColors[HeatingGrade.Green] = '#3F8E50', _HeatingGradeColors[HeatingGrade.Lightgreen] = '#8EBE56', _HeatingGradeColors[HeatingGrade.Yellow] = '#E5CA49', _HeatingGradeColors[HeatingGrade.Orange] = '#E67E3B', _HeatingGradeColors[HeatingGrade.Red] = '#B83633', _HeatingGradeColors);
var Extras = {
  blue: '#00a3e0',
  green: '#00b74f',
  lightPurple: '#9b96c7',
  orange: '#ffa300',
  purple: '#382D8F',
  yellow: '#ffd100'
};
var Greys = {
  grey1: EnovaThemeColors.white,
  grey2: EnovaThemeColors.winterGrey,
  grey3: EnovaThemeColors.rockGrey,
  grey4: EnovaThemeColors.black
};
var BrandError = '#AC1003';
var BrandSuccess = '#00B74F';

var defaultMuiTheme = function defaultMuiTheme(mode) {
  return createTheme({
    palette: {
      mode: mode
    }
  });
}; // Any non-color related theme customizations specified here will be applied to both light and dark themes


var getBaseThemeOptions = function getBaseThemeOptions(mode) {
  var _h, _h2, _h3, _h4, _body;

  var defaultTheme = defaultMuiTheme(mode);
  return {
    breakpoints: {
      values: breakpoints
    },
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true
        }
      },
      MuiButton: {
        variants: [{
          props: {
            size: 'small'
          },
          style: {
            fontSize: '0.925rem',
            lineHeight: 1.25,
            padding: '4px 8px'
          }
        }, {
          props: {
            size: 'medium'
          },
          style: {
            fontSize: '1rem',
            lineHeight: 1.25,
            padding: '8px 16px'
          }
        }, {
          props: {
            size: 'large'
          },
          style: {
            fontSize: '1.125rem',
            lineHeight: 1.5,
            padding: '8px 16px'
          }
        }]
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            '&:hover': {
              background: defaultTheme.palette.action.hover
            },
            '&:focus-visible': {
              boxShadow: "inset 0 0 0 0.15rem " + (mode === 'dark' ? defaultTheme.palette.common.white : defaultTheme.palette.common.black),
              background: defaultTheme.palette.action.focus
            },
            '&:active': {
              background: defaultTheme.palette.action.focus
            }
          }
        }
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            '&.Mui-selected': {
              background: defaultTheme.palette.action.selected,
              '&:hover': {
                background: defaultTheme.palette.action.hover
              },
              '&:focus-visible': {
                background: defaultTheme.palette.action.focus
              },
              '&:active': {
                background: defaultTheme.palette.action.focus
              }
            }
          }
        }
      }
    },
    palette: _extends({
      contrastThreshold: 4.5,
      extras: Extras,
      greys: Greys
    }, EnovaThemeColors),
    shape: {
      borderRadius: 5
    },
    size: {
      inputHeight: 50,
      inputWidth: 300
    },
    spacing: 5,
    typography: {
      fontFamily: ['"National"', 'sans-serif'].join(','),
      h1: (_h = {
        fontSize: '2.25rem',
        fontWeight: 600,
        lineHeight: 1.1
      }, _h["@media (min-width: " + breakpoints.lg + "px)"] = {
        fontSize: '3rem'
      }, _h),
      h2: (_h2 = {
        fontSize: '1.75rem',
        fontWeight: 600,
        lineHeight: 1.1
      }, _h2["@media (min-width: " + breakpoints.lg + "px)"] = {
        fontSize: '2.25rem'
      }, _h2),
      h3: (_h3 = {
        fontSize: '1.5rem',
        fontWeight: 600,
        lineHeight: 1.2
      }, _h3["@media (min-width: " + breakpoints.lg + "px)"] = {
        fontSize: '1.75rem'
      }, _h3),
      h4: (_h4 = {
        fontSize: '1.125rem',
        fontWeight: 600,
        lineHeight: 1.35
      }, _h4["@media (min-width: " + breakpoints.lg + "px)"] = {
        fontSize: '1.25rem'
      }, _h4),
      body1: (_body = {
        fontSize: '1rem',
        fontWeight: 400,
        lineHeight: 1.5
      }, _body["@media (min-width: " + breakpoints.lg + "px)"] = {
        fontSize: '1.125rem'
      }, _body),
      body2: {
        fontSize: '1rem',
        fontWeight: 400,
        lineHeight: 1.25
      },
      button: {
        fontSize: '1.125rem',
        fontWeight: 300,
        lineHeight: 1.5
      }
    }
  };
};
var LightThemeDefaultOptions = /*#__PURE__*/merge( /*#__PURE__*/getBaseThemeOptions('light'), {
  palette: {
    action: {
      disabledBackground: /*#__PURE__*/alpha('#000', 0.08)
    },
    background: {
      "default": '#F6F6F6'
    },
    divider: Greys.grey2,
    energyGrade: EnergyGradeColors,
    heatingGrade: HeatingGradeColors,
    error: {
      main: BrandError,
      background: /*#__PURE__*/alpha(BrandError, 0.09)
    },
    primary: {
      main: BrandColor
    },
    secondary: {
      main: BrandColorSecondary
    },
    success: {
      main: BrandSuccess,
      background: /*#__PURE__*/alpha(BrandSuccess, 0.1)
    },
    warning: {
      main: amber[500],
      background: /*#__PURE__*/alpha(amber[500], 0.1),
      dark: /*#__PURE__*/darken(amber[700], 0.2)
    }
  }
});
var DarkThemeDefaultOptions = /*#__PURE__*/merge( /*#__PURE__*/getBaseThemeOptions('dark'), {
  palette: {
    action: {
      disabledBackground: /*#__PURE__*/alpha('#fff', 0.08)
    },
    background: {
      "default": Greys.grey4
    },
    divider: Greys.grey2,
    energyGrade: EnergyGradeColors,
    heatingGrade: HeatingGradeColors,
    error: {
      background: /*#__PURE__*/alpha( /*#__PURE__*/lighten(BrandError, 0.4), 0.09),
      main: /*#__PURE__*/lighten(BrandError, 0.4)
    },
    primary: {
      main: BrandColor
    },
    secondary: {
      main: BrandColorSecondary
    },
    success: {
      background: /*#__PURE__*/alpha( /*#__PURE__*/lighten(BrandSuccess, 0.4), 0.1),
      main: /*#__PURE__*/lighten(BrandSuccess, 0.4)
    },
    warning: {
      main: /*#__PURE__*/lighten(amber[500], 0.4),
      background: /*#__PURE__*/alpha( /*#__PURE__*/lighten(amber[500], 0.4), 0.1),
      dark: /*#__PURE__*/darken( /*#__PURE__*/lighten(amber[700], 0.4), 0.2)
    }
  }
});

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var efcLighten = function efcLighten(color) {
  return lighten(color, 0.1);
};
var efcDarken = function efcDarken(color) {
  return darken(color, 0.1);
};
var gradient = function gradient(color1, color2, vertical) {
  return "linear-gradient(to " + (vertical ? 'top' : 'right') + ", " + color1 + ", " + color2 + ")";
};
var getGradient = function getGradient(theme) {
  return gradient(theme.palette.primary.main, theme.palette.secondary.main);
};
var getGradientVertical = function getGradientVertical(theme) {
  return gradient(theme.palette.primary.main, theme.palette.secondary.main, true);
};
var getGradientSecondary = function getGradientSecondary(theme) {
  return gradient(theme.palette.secondary.main, theme.palette.extras.orange);
};
var getGradientSecondaryVertical = function getGradientSecondaryVertical(theme) {
  return gradient(theme.palette.secondary.main, theme.palette.extras.orange, true);
};
var bgGradient = /*#__PURE__*/css(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return getGradient(theme);
});
var bgGradientVertical = /*#__PURE__*/css(_templateObject2 || (_templateObject2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return getGradientVertical(theme);
});
var bgGradientSecondary = /*#__PURE__*/css(_templateObject3 || (_templateObject3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: ", ";\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return getGradientSecondary(theme);
});
var bgGradientSecondaryVertical = /*#__PURE__*/css(_templateObject4 || (_templateObject4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: ", ";\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return getGradientSecondaryVertical(theme);
});
var createEnovaTheme = function createEnovaTheme(themeOptions) {
  var _themeOptions$palette;

  return createTheme(merge((themeOptions == null ? void 0 : (_themeOptions$palette = themeOptions.palette) == null ? void 0 : _themeOptions$palette.mode) === 'dark' ? DarkThemeDefaultOptions : LightThemeDefaultOptions, themeOptions || {}));
};

var DefaultTheme = /*#__PURE__*/createEnovaTheme();

var EnovaContext = /*#__PURE__*/createContext({
  mainMenuOpen: false,
  setMainMenuOpen: function setMainMenuOpen() {
    return true;
  },
  setTheme: function setTheme() {
    return true;
  },
  theme: {}
});

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;
var fastTransition = function fastTransition(properties) {
  if (properties === void 0) {
    properties = 'all';
  }

  return css(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n  transition: ", ";\n"])), function (_ref) {
    var theme = _ref.theme;
    return (Array.isArray(properties) ? properties : [properties]).map(function (p) {
      return p + " " + theme.transitions.duration.shorter + "ms " + theme.transitions.easing.easeInOut;
    }).join(' ');
  });
};
var focusSingleBoxShadow = /*#__PURE__*/css(_templateObject2$1 || (_templateObject2$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  outline: 0;\n  box-shadow: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return "0 0 0 0.05rem " + (theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black);
});
var focusInsetBoxShadow = /*#__PURE__*/css(_templateObject3$1 || (_templateObject3$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  outline: 0;\n  box-shadow: ", ";\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return "inset 0 0 0 0.15rem " + (theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black);
});
var focusSingleThickBoxShadow = /*#__PURE__*/css(_templateObject4$1 || (_templateObject4$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  outline: 0;\n  box-shadow: ", ";\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return "0 0 0 0.15rem " + (theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black);
});
var focusDoubleBoxShadow = /*#__PURE__*/css(_templateObject5 || (_templateObject5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  outline: 0;\n  box-shadow: ", ";\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return "0 0 0 0.1rem " + (theme.palette.mode === 'dark' ? theme.palette.common.black : theme.palette.common.white) + ", 0 0 0 0.25rem " + (theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black);
});
var focusInvertedDoubleBoxShadow = /*#__PURE__*/css(_templateObject6 || (_templateObject6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  outline: 0;\n  box-shadow: ", ";\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return "0 0 0 0.1rem " + (theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black) + ", 0 0 0 0.25rem " + (theme.palette.mode === 'dark' ? theme.palette.common.black : theme.palette.common.white);
});
var focusVisibleSingleBoxShadow = /*#__PURE__*/css(_templateObject7 || (_templateObject7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  &:focus-visible {\n    ", "\n  }\n"])), focusSingleBoxShadow);
var focusVisibleInsetBoxShadow = /*#__PURE__*/css(_templateObject8 || (_templateObject8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  &:focus-visible {\n    ", "\n  }\n"])), focusInsetBoxShadow);
var focusVisibleSingleThickBoxShadow = /*#__PURE__*/css(_templateObject9 || (_templateObject9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  &:focus-visible {\n    ", "\n  }\n"])), focusSingleThickBoxShadow);
var focusVisibleBoxShadow = /*#__PURE__*/css(_templateObject10 || (_templateObject10 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  &:focus-visible {\n    ", "\n  }\n"])), focusDoubleBoxShadow);
var focusVisibleBoxShadowRounded = /*#__PURE__*/css(_templateObject11 || (_templateObject11 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  &:focus-visible {\n    ", "\n    border-radius: 1px;\n  }\n"])), focusDoubleBoxShadow);

var generateBgFgPair = function generateBgFgPair(bgColor) {
  return css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  color: ", ";\n"])), bgColor, function (_ref7) {
    var theme = _ref7.theme;
    return theme.palette.getContrastText(bgColor);
  });
};

var GlobalStyle = /*#__PURE__*/createGlobalStyle(_templateObject13 || (_templateObject13 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  body {\n    font-family: ", ";\n    color: ", ";\n    background: ", ";\n    line-height: ", ";\n\n    ul {\n      margin-block-start: 0.25em;\n      margin-block-end: 0.25em;\n      padding-inline-start: 1.5em;\n    }\n\n    * {\n      text-rendering: optimizeLegibility;\n    }\n\n    *::selection {\n       ", "\n    }\n\n    .bg-primary {\n      ", "\n      \n      a {\n        color: inherit;\n      }\n\n      *::selection {\n\n        background: ", ";\n        color: ", ";\n      }\n    }\n\n    .bg-secondary {\n      ", "\n      \n      a {\n        color: inherit;\n      }\n    }\n\n    .w-default {\n      width: ", "px;\n    }\n\n    .w-max-content {\n      width: max-content;\n    }\n\n    .bordered {\n      border: thin solid ", "\n    }\n\n    .rounded {\n      border-radius: ", "px;\n    }\n\n    .fvsbs {\n      ", "\n    }\n\n    .fvibs {\n      ", "\n    }\n\n    .fvstbs {\n      ", "\n    } \n\n    .fvbs {\n      ", "\n    }\n\n    .fvbsr {\n      ", "\n    }\n  }\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.typography.fontFamily;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.palette.text.primary;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.palette.background["default"];
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.typography.body1.lineHeight;
}, function (_ref12) {
  var theme = _ref12.theme;
  return generateBgFgPair(theme.palette.primary.dark);
}, function (_ref13) {
  var theme = _ref13.theme;
  return generateBgFgPair(theme.palette.primary.main);
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.palette.common.white;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.palette.getContrastText(theme.palette.common.white);
}, function (_ref16) {
  var theme = _ref16.theme;
  return generateBgFgPair(theme.palette.secondary.main);
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.size.inputWidth;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.palette.divider;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.shape.borderRadius;
}, focusVisibleSingleBoxShadow, focusVisibleInsetBoxShadow, focusVisibleSingleThickBoxShadow, focusVisibleBoxShadow, focusVisibleBoxShadowRounded);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.a-baseline {\n  vertical-align: baseline !important;\n}\n\n.a-top {\n  vertical-align: top !important;\n}\n\n.a-middle {\n  vertical-align: middle !important;\n}\n\n.a-bottom {\n  vertical-align: bottom !important;\n}\n\n.a-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.a-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.o-auto {\n  overflow: auto !important;\n}\n\n.o-hidden {\n  overflow: hidden !important;\n}\n\n.o-visible {\n  overflow: visible !important;\n}\n\n.o-scroll {\n  overflow: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.p-static {\n  position: static !important;\n}\n\n.p-relative {\n  position: relative !important;\n}\n\n.p-absolute {\n  position: absolute !important;\n}\n\n.p-fixed {\n  position: fixed !important;\n}\n\n.p-sticky {\n  position: -webkit-sticky !important;\n  position: sticky !important;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.w-fit-content {\n  width: fit-content !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.f-fill {\n  flex: 1 1 auto !important;\n}\n\n.f-row {\n  flex-direction: row !important;\n}\n\n.f-column {\n  flex-direction: column !important;\n}\n\n.f-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.f-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.f-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.f-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.f-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.f-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.f-wrap {\n  flex-wrap: wrap !important;\n}\n\n.f-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.f-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.jc-start {\n  justify-content: flex-start !important;\n}\n\n.jc-end {\n  justify-content: flex-end !important;\n}\n\n.jc-center {\n  justify-content: center !important;\n}\n\n.jc-between {\n  justify-content: space-between !important;\n}\n\n.jc-around {\n  justify-content: space-around !important;\n}\n\n.jc-evenly {\n  justify-content: space-evenly !important;\n}\n\n.ai-start {\n  align-items: flex-start !important;\n}\n\n.ai-end {\n  align-items: flex-end !important;\n}\n\n.ai-center {\n  align-items: center !important;\n}\n\n.ai-baseline {\n  align-items: baseline !important;\n}\n\n.ai-stretch {\n  align-items: stretch !important;\n}\n\n.ac-start {\n  align-content: flex-start !important;\n}\n\n.ac-end {\n  align-content: flex-end !important;\n}\n\n.ac-center {\n  align-content: center !important;\n}\n\n.ac-between {\n  align-content: space-between !important;\n}\n\n.ac-around {\n  align-content: space-around !important;\n}\n\n.ac-stretch {\n  align-content: stretch !important;\n}\n\n.as-auto {\n  align-self: auto !important;\n}\n\n.as-start {\n  align-self: flex-start !important;\n}\n\n.as-end {\n  align-self: flex-end !important;\n}\n\n.as-center {\n  align-self: center !important;\n}\n\n.as-baseline {\n  align-self: baseline !important;\n}\n\n.as-stretch {\n  align-self: stretch !important;\n}\n\n.js-auto {\n  justify-self: auto !important;\n}\n\n.js-start {\n  justify-self: flex-start !important;\n}\n\n.js-end {\n  justify-self: flex-end !important;\n}\n\n.js-center {\n  justify-self: center !important;\n}\n\n.js-baseline {\n  justify-self: baseline !important;\n}\n\n.js-stretch {\n  justify-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-last {\n  order: 6 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 1rem !important;\n}\n\n.m-4 {\n  margin: 1.5rem !important;\n}\n\n.m-5 {\n  margin: 3rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.mx-1 {\n  margin-right: 0.25rem !important;\n  margin-left: 0.25rem !important;\n}\n\n.mx-2 {\n  margin-right: 0.5rem !important;\n  margin-left: 0.5rem !important;\n}\n\n.mx-3 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n\n.mx-4 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n\n.mx-5 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.my-1 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.my-2 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n\n.my-3 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.my-4 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-5 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mt-3 {\n  margin-top: 1rem !important;\n}\n\n.mt-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-5 {\n  margin-top: 3rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.mr-0 {\n  margin-right: 0 !important;\n}\n\n.mr-1 {\n  margin-right: 0.25rem !important;\n}\n\n.mr-2 {\n  margin-right: 0.5rem !important;\n}\n\n.mr-3 {\n  margin-right: 1rem !important;\n}\n\n.mr-4 {\n  margin-right: 1.5rem !important;\n}\n\n.mr-5 {\n  margin-right: 3rem !important;\n}\n\n.mr-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 3rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ml-0 {\n  margin-left: 0 !important;\n}\n\n.ml-1 {\n  margin-left: 0.25rem !important;\n}\n\n.ml-2 {\n  margin-left: 0.5rem !important;\n}\n\n.ml-3 {\n  margin-left: 1rem !important;\n}\n\n.ml-4 {\n  margin-left: 1.5rem !important;\n}\n\n.ml-5 {\n  margin-left: 3rem !important;\n}\n\n.ml-auto {\n  margin-left: auto !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n.p-4 {\n  padding: 1.5rem !important;\n}\n\n.p-5 {\n  padding: 3rem !important;\n}\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.px-1 {\n  padding-right: 0.25rem !important;\n  padding-left: 0.25rem !important;\n}\n\n.px-2 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n\n.px-3 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n\n.px-4 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.px-5 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n\n.py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.py-3 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.py-4 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-5 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pt-3 {\n  padding-top: 1rem !important;\n}\n\n.pt-4 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-5 {\n  padding-top: 3rem !important;\n}\n\n.pr-0 {\n  padding-right: 0 !important;\n}\n\n.pr-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pr-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pr-3 {\n  padding-right: 1rem !important;\n}\n\n.pr-4 {\n  padding-right: 1.5rem !important;\n}\n\n.pr-5 {\n  padding-right: 3rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 1rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 3rem !important;\n}\n\n.pl-0 {\n  padding-left: 0 !important;\n}\n\n.pl-1 {\n  padding-left: 0.25rem !important;\n}\n\n.pl-2 {\n  padding-left: 0.5rem !important;\n}\n\n.pl-3 {\n  padding-left: 1rem !important;\n}\n\n.pl-4 {\n  padding-left: 1.5rem !important;\n}\n\n.pl-5 {\n  padding-left: 3rem !important;\n}\n\n.lh-lg {\n  line-height: 2 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n.text-preline {\n  white-space: pre-line !important;\n}\n\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n\n.pr-none {\n  pointer-events: none !important;\n}\n\n.pr-auto {\n  pointer-events: auto !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n.sr-only {\n  width: 1px !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  position: absolute !important;\n}\n";
styleInject(css_248z);

var localeMap = {
  'nb-NO': nbLocale,
  'nn-NO': nnLocale,
  en: undefined
};

var EnovaContextProvider = function EnovaContextProvider(_ref) {
  var children = _ref.children,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'nb-NO' : _ref$locale,
      _ref$maxSnacks = _ref.maxSnacks,
      maxSnacks = _ref$maxSnacks === void 0 ? 3 : _ref$maxSnacks,
      _ref$theme = _ref.theme,
      initTheme = _ref$theme === void 0 ? DefaultTheme : _ref$theme;

  var _useState = useState(initTheme),
      theme = _useState[0],
      setTheme = _useState[1];

  var _useState2 = useState(0),
      rerender = _useState2[1];

  var _useState3 = useState(false),
      mainMenuOpen = _useState3[0],
      setMainMenuOpen = _useState3[1]; // Used to identify small screens to display dense snackbars


  var xsScreen = useMediaQuery(theme.breakpoints.down('xs')); // Rerenders provider when font is loaded to ensure correct tab indicator width

  useEffect(function () {
    new FontFaceObserver('National').load().then(function () {
      return rerender(function (prev) {
        return prev + 1;
      });
    })["catch"](function (err) {
      return console.error('Error loading fonts with FontFaceObserver', err);
    });
  }, []);
  var values = {
    mainMenuOpen: mainMenuOpen,
    setTheme: setTheme,
    theme: theme,
    setMainMenuOpen: setMainMenuOpen
  };
  return React__default.createElement(EnovaContext.Provider, {
    value: values
  }, React__default.createElement(StyledEngineProvider, {
    injectFirst: true
  }, React__default.createElement(LocalizationProvider, {
    dateAdapter: AdapterDateFns,
    locale: localeMap[locale]
  }, React__default.createElement(ThemeProvider$2, {
    theme: theme
  }, React__default.createElement(CssBaseline, null), React__default.createElement(ThemeProvider, {
    theme: theme
  }, React__default.createElement(SnackbarProvider, {
    dense: xsScreen,
    maxSnack: maxSnacks
  }, React__default.createElement(GlobalStyle, null), children))))));
};

var useEnovaContext = function useEnovaContext() {
  return useContext(EnovaContext);
};

var _path;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function SvgCheck(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/createElement("path", {
    d: "M6.92 10.92a.75.75 0 01-.53-.22L4.22 8.53a.75.75 0 011.06-1.06l1.64 1.64 3.8-3.8a.75.75 0 011.06 1.06L7.45 10.7a.75.75 0 01-.53.22z"
  })));
}

var ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
var MemoForwardRef = /*#__PURE__*/memo(ForwardRef);
var CheckIconSVG = "data:image/svg+xml,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20viewBox%3D%220%200%2016%2016%22%3E%3Ctitle%3Eicon_checkbox_active%3C%2Ftitle%3E%3Cpath%20d%3D%22M6.92%2C10.92a.75.75%2C0%2C0%2C1-.53-.22L4.22%2C8.53A.75.75%2C0%2C0%2C1%2C5.28%2C7.47L6.92%2C9.11l3.8-3.8a.75.75%2C0%2C0%2C1%2C1.06%2C1.06L7.45%2C10.7A.75.75%2C0%2C0%2C1%2C6.92%2C10.92Z%22%2F%3E%3C%2Fsvg%3E";

var _path$1, _path2;

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function SvgCheckChecked(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path$1 || (_path$1 = /*#__PURE__*/createElement("path", {
    d: "M12 1a3 3 0 013 3v8a3 3 0 01-3 3H4a3 3 0 01-3-3V4a3 3 0 013-3h8m0-1H4a4 4 0 00-4 4v8a4 4 0 004 4h8a4 4 0 004-4V4a4 4 0 00-4-4z"
  })), _path2 || (_path2 = /*#__PURE__*/createElement("path", {
    d: "M6.92 10.92a.75.75 0 01-.53-.22L4.22 8.53a.75.75 0 011.06-1.06l1.64 1.64 3.8-3.8a.75.75 0 011.06 1.06L7.45 10.7a.75.75 0 01-.53.22z"
  })));
}

var ForwardRef$1 = /*#__PURE__*/forwardRef(SvgCheckChecked);
var MemoForwardRef$1 = /*#__PURE__*/memo(ForwardRef$1);

var _path$2;

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

function SvgCheckUnchecked(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path$2 || (_path$2 = /*#__PURE__*/createElement("path", {
    d: "M12 1a3 3 0 013 3v8a3 3 0 01-3 3H4a3 3 0 01-3-3V4a3 3 0 013-3h8m0-1H4a4 4 0 00-4 4v8a4 4 0 004 4h8a4 4 0 004-4V4a4 4 0 00-4-4z"
  })));
}

var ForwardRef$2 = /*#__PURE__*/forwardRef(SvgCheckUnchecked);
var MemoForwardRef$2 = /*#__PURE__*/memo(ForwardRef$2);

var _path$3, _rect;

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

function SvgCheckIndeterminate(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$4({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path$3 || (_path$3 = /*#__PURE__*/createElement("path", {
    d: "M12 1a3 3 0 013 3v8a3 3 0 01-3 3H4a3 3 0 01-3-3V4a3 3 0 013-3h8m0-1H4a4 4 0 00-4 4v8a4 4 0 004 4h8a4 4 0 004-4V4a4 4 0 00-4-4z"
  })), _rect || (_rect = /*#__PURE__*/createElement("rect", {
    x: 3.962,
    y: 7.408,
    width: 8.076,
    height: 1.185,
    rx: 0.65,
    ry: 0.65
  })));
}

var ForwardRef$3 = /*#__PURE__*/forwardRef(SvgCheckIndeterminate);
var MemoForwardRef$3 = /*#__PURE__*/memo(ForwardRef$3);

var _path$4, _path2$1;

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

function SvgIcon2Xarrow(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$5({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path$4 || (_path$4 = /*#__PURE__*/createElement("path", {
    d: "M8.75 12a.75.75 0 01-.53-1.28L10.94 8 8.22 5.28a.75.75 0 011.06-1.06l3.25 3.25a.75.75 0 010 1.06l-3.25 3.25a.75.75 0 01-.53.22z"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/createElement("path", {
    d: "M4 12a.75.75 0 01-.53-1.28L6.19 8 3.47 5.28a.75.75 0 011.06-1.06l3.25 3.25a.75.75 0 010 1.06l-3.25 3.25A.75.75 0 014 12z"
  })));
}

var ForwardRef$4 = /*#__PURE__*/forwardRef(SvgIcon2Xarrow);
var MemoForwardRef$4 = /*#__PURE__*/memo(ForwardRef$4);

var _path$5, _circle;

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

function SvgRadioChecked(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$6({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path$5 || (_path$5 = /*#__PURE__*/createElement("path", {
    d: "M8 1a7 7 0 11-7 7 7 7 0 017-7m0-1a8 8 0 108 8 8 8 0 00-8-8z"
  })), _circle || (_circle = /*#__PURE__*/createElement("circle", {
    cx: 8,
    cy: 8,
    r: 3
  })));
}

var ForwardRef$5 = /*#__PURE__*/forwardRef(SvgRadioChecked);
var MemoForwardRef$5 = /*#__PURE__*/memo(ForwardRef$5);

var _path$6;

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

function SvgRadioUnchecked(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$7({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path$6 || (_path$6 = /*#__PURE__*/createElement("path", {
    d: "M8 1a7 7 0 11-7 7 7 7 0 017-7m0-1a8 8 0 108 8 8 8 0 00-8-8z"
  })));
}

var ForwardRef$6 = /*#__PURE__*/forwardRef(SvgRadioUnchecked);
var MemoForwardRef$6 = /*#__PURE__*/memo(ForwardRef$6);

var _path$7;

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

function SvgIconSearch(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$8({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$7 || (_path$7 = /*#__PURE__*/createElement("path", {
    d: "M2 6.4C2 3.974 3.974 2 6.4 2s4.4 1.974 4.4 4.4-1.974 4.4-4.4 4.4A4.405 4.405 0 012 6.4m9.604 3.716A6.365 6.365 0 0012.8 6.4a6.4 6.4 0 10-6.4 6.4 6.358 6.358 0 003.464-1.024l3.624 3.624c.8.8.8.8 1.6 0s1-.8.2-1.6l-3.684-3.684z",
    fill: "inherit",
    fillRule: "evenodd"
  })));
}

var ForwardRef$7 = /*#__PURE__*/forwardRef(SvgIconSearch);
var MemoForwardRef$7 = /*#__PURE__*/memo(ForwardRef$7);

var _g, _defs;

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

function SvgIconShare(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$9({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/createElement("g", {
    clipPath: "url(#icon-share_svg__clip0)"
  }, /*#__PURE__*/createElement("path", {
    d: "M18.953 6.503a.462.462 0 00-.128-.183L12.38.167a.607.607 0 00-.429-.17.628.628 0 00-.427.17.572.572 0 00-.174.409c0 .152.062.299.174.408l5.316 5.07a32.422 32.422 0 00-6.703.316C4.677 7.24 1.18 9.638.026 13.296a.513.513 0 00.042.414.544.544 0 00.34.26.59.59 0 00.5-.082.548.548 0 00.206-.277c2.124-6.744 12.683-6.646 15.823-6.459V7.3l-5.413 5.169a.572.572 0 00-.174.408.572.572 0 00.37.535.63.63 0 00.66-.126l6.444-6.153a.402.402 0 00.13-.187.535.535 0 00.046-.222.578.578 0 00-.047-.221z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "icon-share_svg__clip0"
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M0 0h19v14H0z"
  })))));
}

var ForwardRef$8 = /*#__PURE__*/forwardRef(SvgIconShare);
var MemoForwardRef$8 = /*#__PURE__*/memo(ForwardRef$8);

var _path$8, _path2$2;

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

function SvgIconDocument(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$a({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$8 || (_path$8 = /*#__PURE__*/createElement("path", {
    fill: "none",
    clipRule: "evenodd",
    d: "M4.2 1H25a3.2 3.2 0 013.2 3.2V25a3.2 3.2 0 01-3.2 3.2H4.2A3.2 3.2 0 011 25V4.2A3.2 3.2 0 014.2 1z",
    stroke: "currentColor",
    strokeWidth: 1.6
  })), _path2$2 || (_path2$2 = /*#__PURE__*/createElement("path", {
    d: "M5 6.6h19.2M5 12.2h19.2M5 17h19.2M5 22.6h19.2",
    stroke: "currentColor",
    strokeWidth: 1.6
  })));
}

var ForwardRef$9 = /*#__PURE__*/forwardRef(SvgIconDocument);
var MemoForwardRef$9 = /*#__PURE__*/memo(ForwardRef$9);

var _path$9, _path2$3;

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

function SvgIconDownload(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _path$9 || (_path$9 = /*#__PURE__*/createElement("path", {
    d: "M27 0h-2.25a.75.75 0 00-.75.75.75.75 0 00.75.75H27A3.5 3.5 0 0130.5 5v22a3.5 3.5 0 01-3.5 3.5H5A3.5 3.5 0 011.5 27V5A3.5 3.5 0 015 1.5h2.25A.75.75 0 008 .75.75.75 0 007.25 0H5a5 5 0 00-5 5v22a5 5 0 005 5h22a5 5 0 005-5V5a5 5 0 00-5-5z"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/createElement("path", {
    d: "M24.53 16.53l-8 8a.63.63 0 01-.24.16.73.73 0 01-.58 0 .63.63 0 01-.24-.16l-8-8a.75.75 0 011.06-1.06l6.72 6.72V.75a.75.75 0 011.5 0v21.44l6.72-6.72a.75.75 0 011.06 1.06z"
  })));
}

var ForwardRef$a = /*#__PURE__*/forwardRef(SvgIconDownload);
var MemoForwardRef$a = /*#__PURE__*/memo(ForwardRef$a);

var viewBox16 = '0 0 16 16';
var viewBox20 = '-2 -2 20 20';
var EfcIconMap = {
  check_checked: {
    icon: MemoForwardRef$1,
    viewBox: viewBox20
  },
  check_indeterminate: {
    icon: MemoForwardRef$3,
    viewBox: viewBox20
  },
  check_unchecked: {
    icon: MemoForwardRef$2,
    viewBox: viewBox20
  },
  check: {
    icon: MemoForwardRef,
    viewBox: '1 1 14 14'
  },
  document: {
    icon: MemoForwardRef$9,
    viewBox: '0 0 29 29'
  },
  double_arrow: {
    icon: MemoForwardRef$4,
    viewBox: viewBox16
  },
  download: {
    icon: MemoForwardRef$a,
    viewBox: '0 0 32 32'
  },
  radio_checked: {
    icon: MemoForwardRef$5,
    viewBox: viewBox20
  },
  radio_unchecked: {
    icon: MemoForwardRef$6,
    viewBox: viewBox20
  },
  search: {
    icon: MemoForwardRef$7,
    viewBox: viewBox20
  },
  share: {
    icon: MemoForwardRef$8,
    viewBox: '0 0 19 14'
  }
};
var MuiIconMap = {
  thumb_up: ThumbUp,
  arrow_down: ArrowDownward,
  arrow_dropdown: ArrowDropDown,
  arrow_left: ArrowBack,
  arrow_right: ArrowForward,
  arrow_up: ArrowUpward,
  chevron_down: ChevronDown,
  chevron_left: ChevronLeft,
  chevron_right: ChevronRight,
  chevron_up: ChevronUp,
  close: Close,
  "delete": Delete,
  filter: Filter,
  horizontal_dots: HorizontalDots,
  minus: Minus,
  plus: Plus,
  reset: Reset,
  vertical_dots: VerticalDots
};
var EfcIconOptions = /*#__PURE__*/Object.keys(EfcIconMap);
var MuiIconOptions = /*#__PURE__*/Object.keys(MuiIconMap);
var IconOptions = /*#__PURE__*/[].concat(MuiIconOptions, EfcIconOptions).sort(function (a, b) {
  return a < b ? -1 : a > b ? 1 : 0;
});

var _excluded = ["aria-label", "className", "name"];
var useStyles = /*#__PURE__*/makeStyles(function () {
  return createStyles({
    root: {
      pointerEvents: 'none'
    }
  });
});
var Icon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var ariaLabel = _ref['aria-label'],
      className = _ref.className,
      name = _ref.name,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var classes = useStyles();
  var title = capitalize(name).replace('_', ' ');

  if (Object.keys(MuiIconMap).includes(name)) {
    var _Component = MuiIconMap[name];
    return React__default.createElement(_Component, Object.assign({}, rest, {
      "aria-label": ariaLabel || title,
      className: classNames('EfcIcon', classes.root, className),
      ref: ref
    }));
  }

  var Component = EfcIconMap[name].icon;
  return React__default.createElement(SvgIcon, Object.assign({}, rest, {
    component: Component
  }, {
    "aria-label": ariaLabel || title,
    className: classNames('EfcIcon', classes.root, className),
    ref: ref,
    viewBox: EfcIconMap[name].viewBox
  }));
});
Icon.displayName = 'Icon';

var _excluded$1 = ["className", "icon", "size"];

var _templateObject$2, _templateObject2$2;
var IconButtonCSS = /*#__PURE__*/css(_templateObject$2 || (_templateObject$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  &.icon-btn--medium {\n    padding: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing();
});
var StyledIconButton = /*#__PURE__*/styled$1(MuiIconButton)(_templateObject2$2 || (_templateObject2$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), IconButtonCSS);
var IconButton = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
      icon = _ref2.icon,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'medium' : _ref2$size,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded$1);

  return React__default.createElement(StyledIconButton, Object.assign({}, rest, {
    className: classNames(className, "icon-btn--" + size),
    ref: ref,
    size: size !== 'large' ? 'small' : undefined
  }), React__default.createElement(Icon, {
    fontSize: size === 'small' ? 'inherit' : undefined,
    name: icon
  }));
});
IconButton.displayName = 'IconButton';

/**
 * ### useSnack
 *
 * Implements `useSnackbar` from [notistack](https://github.com/iamhosseindhv/notistack).
 *
 * Allows for consistent display of [**Material-UI** snackbars](https://mui.com/components/snackbars/).
 *
 * Use with `EnovaContextProvider` to manage snackbars within your application, without having to handle open/close states.
 *
 * #### To use
 *
 * ```tsx
 * const { addSnack, closeSnack } = useSnack(); // Functions
 * const key = addSnack('This is a message'); // Add snackbar and store key in a variable
 * closeSnack(key); // Use key to close snackbar programmatically
 * ```
 *
 * ##### Function signature
 *
 * ```tsx
 * (message: SnackbarMessage, options?: SnackbarOptions) => string // Returns snackbar key that can be used for reference
 * ```
 *
 * #### Options
 *
 * *Note:* The shape of the options object differs from notistack, as it is customized for applications building on EFC.
 *
 * ```tsx
 * type SnackAction = {
 * 	disabled?: boolean;
 * 	label: string;
 * 	onClick?: MouseEventHandler<HTMLButtonElement>;
 * };

 * type SnackVariant = undefined | 'error' | 'success'
 *
 * type SnackbarOptions = {
 * 	actions?: SnackAction | SnackAction[];
 * 	dismissable?: boolean;
 * 	persist?: boolean;
 * 	variant?: SnackVariant;
 * };
 * ```
 */

var useSnack = function useSnack() {
  var _useSnackbar = useSnackbar(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar,
      closeSnack = _useSnackbar.closeSnackbar;

  var addSnack = function addSnack(message, options) {
    var _ref = options || {},
        actions = _ref.actions,
        _ref$dismissable = _ref.dismissable,
        dismissable = _ref$dismissable === void 0 ? true : _ref$dismissable,
        _ref$persist = _ref.persist,
        persist = _ref$persist === void 0 ? false : _ref$persist,
        variant = _ref.variant;

    var key = nanoid();
    enqueueSnackbar(message, {
      key: key,
      autoHideDuration: 6000,
      action: dismissable || actions ? React__default.createElement("div", null, actions && (Array.isArray(actions) ? actions : [actions]).map(function (_ref2) {
        var disabled = _ref2.disabled,
            label = _ref2.label,
            onClick = _ref2.onClick;
        return React__default.createElement(MuiButton, {
          color: "inherit",
          disabled: disabled,
          className: "fvbs",
          key: label,
          onClick: onClick,
          size: "small"
        }, label);
      }), dismissable && React__default.createElement(IconButton, {
        "aria-label": "dismiss",
        className: "fvbs",
        color: "inherit",
        icon: "close",
        onClick: function onClick() {
          return closeSnack(key);
        },
        size: "small"
      })) : undefined,
      persist: persist,
      preventDuplicate: true,
      variant: variant
    });
    return key;
  };

  return {
    addSnack: addSnack,
    closeSnack: closeSnack
  };
};

// Hook

function useLocalStorage(key, initialValue) {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  var _useState = useState(function () {
    try {
      // Get from local storage by key
      var item = window.localStorage.getItem(key); // Parse stored json or if none return initialValue

      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch (err) {
      // If error also return initialValue
      console.error(err);
      return initialValue;
    }
  }),
      storedValue = _useState[0],
      setStoredValue = _useState[1]; // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.


  var setValue = function setValue(value) {
    try {
      // Allow value to be a function so we have same API as useState
      var valueToStore = value instanceof Function ? value(storedValue) : value; // Save state

      setStoredValue(valueToStore); // Save to local storage

      if (valueToStore === undefined) window.localStorage.removeItem(key);else window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (err) {
      // A more advanced implementation would handle the error case
      console.error(err);
    }
  };

  return [storedValue, setValue];
}
var reservedKeys = {
  lng: {
    app: 'lng.app',
    env: 'lng.env'
  }
};

var _templateObject$3;
var StyledLoader = /*#__PURE__*/styled$1.div(_templateObject$3 || (_templateObject$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  --color: ", ";\n\n  --expansion: 1em;\n  --height: 4em;\n  --heightExpanded: 5em;\n  --spacing: 0.5em;\n  --width: 1em;\n\n  align-items: center;\n  display: flex;\n  font-size: ", ";\n  height: calc(var(--heightExpanded) + var(--expansion));\n  justify-content: center;\n  width: calc(calc(var(--width) * 3) + calc(var(--spacing) * 2));\n\n  span {\n    background: var(--color);\n    animation: load1 1s infinite ease-in-out;\n    width: var(--width);\n    height: var(--height);\n    color: var(--color);\n    position: relative;\n    transform: translateZ(0);\n    animation-delay: -0.15s;\n\n    &:before,\n    &:after {\n      background: var(--color);\n      animation: load1 1s infinite ease-in-out;\n      width: var(--width);\n      height: var(--height);\n      position: absolute;\n      top: 0;\n      content: '';\n    }\n\n    &:before {\n      left: calc(calc(var(--width) + var(--spacing)) * -1);\n      animation-delay: -0.3s;\n    }\n\n    &:after {\n      left: calc(var(--width) + var(--spacing));\n    }\n\n    @keyframes load1 {\n      0%,\n      80%,\n      100% {\n        box-shadow: 0 0;\n        margin-bottom: 0;\n        height: var(--height);\n      }\n      40% {\n        box-shadow: 0 calc(var(--expansion) * -1);\n        margin-bottom: calc(var(--expansion) * -1);\n        height: var(--heightExpanded);\n      }\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme,
      color = _ref.color;
  return color === 'inherit' ? 'currentColor' : theme.palette.primary.main;
}, function (_ref2) {
  var size = _ref2.size;
  return size === 'large' ? '12px' : '5px';
});
var Loader = function Loader(props) {
  return React__default.createElement(StyledLoader, Object.assign({}, props), React__default.createElement("span", null));
};
Loader.defaultProps = {
  color: 'primary',
  size: 'small'
};

var _excluded$2 = ["children", "className", "disabled", "leftIcon", "rightIcon", "loading", "navigation", "variant", "size"];

var _templateObject$4, _templateObject2$3, _templateObject3$2;
var StyledButton = /*#__PURE__*/styled$1(MuiButton)(_templateObject$4 || (_templateObject$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  transition: background 100ms ease-in-out, color 100ms ease-in-out;\n  border-radius: 104px;\n  border: 2px solid transparent;\n\n  &.btn-navigation {\n    display: flex;\n    justify-content: space-between;\n    padding-right: ", ";\n\n    svg {\n      ", "\n      margin-right: ", ";\n    }\n\n    &:hover,\n    &:active,\n    &:focus-visible:not(:disabled) {\n      svg {\n        margin-right: 0;\n        margin-left: ", ";\n      }\n    }\n  }\n\n  &:disabled {\n    background: ", ";\n    color: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(4);
}, /*#__PURE__*/fastTransition('margin'), function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing();
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing();
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.greys.grey2;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.greys.grey3;
});
var PrimaryButton = /*#__PURE__*/styled$1(StyledButton)(_templateObject2$3 || (_templateObject2$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: ", ";\n  color: ", ";\n\n  &:hover,\n  &:focus-visible:not(:disabled) {\n    background: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.primary.main;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.palette.primary.contrastText;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.palette.lightOcean;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.palette.primary.main;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.palette.primary.main;
});
var SecondaryButton = /*#__PURE__*/styled$1(StyledButton)(_templateObject3$2 || (_templateObject3$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  color: ", ";\n  border-color: ", ";\n  border-width: 2px;\n  border-style: solid;\n\n  &:hover,\n  &:focus-visible:not(:disabled) {\n    background: ", ";\n    color: ", ";\n    background: ", ";\n    border-color: ", ";\n    border-width: 2px;\n    border-style: solid;\n  }\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.palette.background.paper;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.palette.primary.main;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.palette.primary.main;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.palette.primary.main;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.palette.primary.main;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.palette.lightOcean;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.palette.primary.main;
});
var Button = /*#__PURE__*/forwardRef(function (_ref18, ref) {
  var children = _ref18.children,
      className = _ref18.className,
      disabled = _ref18.disabled,
      leftIcon = _ref18.leftIcon,
      rightIcon = _ref18.rightIcon,
      loading = _ref18.loading,
      navigation = _ref18.navigation,
      _ref18$variant = _ref18.variant,
      variant = _ref18$variant === void 0 ? 'primary' : _ref18$variant,
      size = _ref18.size,
      rest = _objectWithoutPropertiesLoose(_ref18, _excluded$2);

  var Component;

  switch (variant) {
    case 'primary':
      Component = PrimaryButton;
      break;

    case 'secondary':
      Component = SecondaryButton;
      break;

    default:
      Component = StyledButton;
  }

  return React__default.createElement(Component, Object.assign({}, rest, {
    size: size != null ? size : 'large',
    className: classNames("btn-" + variant, {
      'btn-navigation': navigation
    }, className),
    disabled: disabled || loading,
    disableElevation: true,
    endIcon: navigation ? React__default.createElement(Icon, {
      name: "double_arrow"
    }) : rightIcon && React__default.createElement(Icon, {
      name: rightIcon
    }),
    startIcon: leftIcon && React__default.createElement(Icon, {
      name: leftIcon
    }),
    ref: ref
  }), children, loading && React__default.createElement(Loader, {
    className: "p-absolute"
  }));
});
Button.displayName = 'Button';

var _defs$1, _path$a, _path2$4;

function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

function SvgIconCalendar(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$c({
    id: "icon-calendar_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _defs$1 || (_defs$1 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "icon-calendar_svg__clip-path"
  }, /*#__PURE__*/createElement("path", {
    className: "icon-calendar_svg__cls-1",
    d: "M-519-1100.87h5v20.25a10 10 0 01-10 10h-40v-5.25"
  })), /*#__PURE__*/createElement("clipPath", {
    id: "icon-calendar_svg__clip-path-2"
  }, /*#__PURE__*/createElement("path", {
    className: "icon-calendar_svg__cls-1",
    d: "M-534-1080.75h-40V-1101a10 10 0 0110-10h40v20.25a10 10 0 01-10 10"
  })), /*#__PURE__*/createElement("clipPath", {
    id: "icon-calendar_svg__clip-path-3"
  }, /*#__PURE__*/createElement("path", {
    className: "icon-calendar_svg__cls-1",
    d: "M-552.03-1090.75l-2.7-4.07h-.6v4.07h-2.31v-10h2.31v3.93h.61l2.48-3.93h2.65l-3.16 4.84 3.47 5.16h-2.75z"
  })), /*#__PURE__*/createElement("clipPath", {
    id: "icon-calendar_svg__clip-path-4"
  }, /*#__PURE__*/createElement("path", {
    className: "icon-calendar_svg__cls-1",
    d: "M-542.22-1090.75a1.74 1.74 0 01-.53-1l-.37-1.49c-.2-.85-.59-1-1.36-1h-1v3.53h-2.31v-10h3.94c2.24 0 3.63.82 3.63 3.06a2.3 2.3 0 01-2.19 2.51 1.81 1.81 0 011.66 1.46l.51 1.87a2.26 2.26 0 00.56 1.07zm-3.24-5.43h1.46c.92 0 1.43-.36 1.43-1.31s-.48-1.31-1.43-1.31h-1.48z"
  })), /*#__PURE__*/createElement("style", null, ".icon-calendar_svg__cls-1{fill:none;clip-rule:evenodd}"))), _path$a || (_path$a = /*#__PURE__*/createElement("path", {
    d: "M27 2h-6.25V.75a.75.75 0 00-1.5 0V2h-6.5V.75a.75.75 0 00-1.5 0V2H5a5 5 0 00-5 5v20a5 5 0 005 5h22a5 5 0 005-5V7a5 5 0 00-5-5zm3.5 25a3.5 3.5 0 01-3.5 3.5H5A3.5 3.5 0 011.5 27V9.75h29zm0-18.75h-29V7A3.5 3.5 0 015 3.5h6.25v1.25a.75.75 0 001.5 0V3.5h6.5v1.25a.75.75 0 001.5 0V3.5H27A3.5 3.5 0 0130.5 7z"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/createElement("path", {
    d: "M9 13H7a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2zm.5 4a.5.5 0 01-.5.5H7a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5h2a.5.5 0 01.5.5zM17 13h-2a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2zm.5 4a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5h2a.5.5 0 01.5.5zM25 13h-2a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2zm.5 4a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5h2a.5.5 0 01.5.5zM25 21h-2a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2zm.5 4a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5h2a.5.5 0 01.5.5zM17 21h-2a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2zm.5 4a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5h2a.5.5 0 01.5.5zM9 21H7a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2zm.5 4a.5.5 0 01-.5.5H7a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5h2a.5.5 0 01.5.5z"
  })));
}

var ForwardRef$b = /*#__PURE__*/forwardRef(SvgIconCalendar);
var MemoForwardRef$b = /*#__PURE__*/memo(ForwardRef$b);

var _defs$2, _path$b, _circle$1, _circle2, _circle3;

function _extends$d() { _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

function SvgIconChat(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$d({
    id: "icon-chat_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _defs$2 || (_defs$2 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "icon-chat_svg__clip-path"
  }, /*#__PURE__*/createElement("path", {
    className: "icon-chat_svg__cls-1",
    d: "M-259-1100.87h5v20.25a10 10 0 01-10 10h-40v-5.25"
  })), /*#__PURE__*/createElement("clipPath", {
    id: "icon-chat_svg__clip-path-2"
  }, /*#__PURE__*/createElement("path", {
    className: "icon-chat_svg__cls-1",
    d: "M-274-1080.75h-40V-1101a10 10 0 0110-10h40v20.25a10 10 0 01-10 10"
  })), /*#__PURE__*/createElement("clipPath", {
    id: "icon-chat_svg__clip-path-3"
  }, /*#__PURE__*/createElement("path", {
    className: "icon-chat_svg__cls-1",
    d: "M-292.03-1090.75l-2.7-4.07h-.6v4.07h-2.31v-10h2.31v3.93h.62l2.47-3.93h2.65l-3.16 4.84 3.47 5.16h-2.75z"
  })), /*#__PURE__*/createElement("clipPath", {
    id: "icon-chat_svg__clip-path-4"
  }, /*#__PURE__*/createElement("path", {
    className: "icon-chat_svg__cls-1",
    d: "M-282.22-1090.75a1.74 1.74 0 01-.53-1l-.37-1.49c-.2-.85-.59-1-1.36-1h-1v3.53h-2.31v-10h3.94c2.24 0 3.63.82 3.63 3.06a2.3 2.3 0 01-2.19 2.51 1.81 1.81 0 011.66 1.46l.51 1.87a2.26 2.26 0 00.56 1.07zm-3.24-5.43h1.46c.92 0 1.43-.36 1.43-1.31s-.48-1.31-1.43-1.31h-1.48z"
  })), /*#__PURE__*/createElement("style", null, ".icon-chat_svg__cls-1{fill:none;clip-rule:evenodd}"))), _path$b || (_path$b = /*#__PURE__*/createElement("path", {
    d: "M29 1.5A1.5 1.5 0 0130.5 3v13a6.51 6.51 0 01-6.5 6.5h-7.56a2.51 2.51 0 00-1.85.82L9.5 28.91v-4.66a1.75 1.75 0 00-1.75-1.75H3A1.5 1.5 0 011.5 21V8A6.51 6.51 0 018 1.5h21M29 0H8a8 8 0 00-8 8v13a3 3 0 003 3h4.75a.25.25 0 01.25.25v7.24a.5.5 0 00.5.5.49.49 0 00.37-.16l6.83-7.5a1 1 0 01.74-.33H24a8 8 0 008-8V3a3 3 0 00-3-3z"
  })), _circle$1 || (_circle$1 = /*#__PURE__*/createElement("circle", {
    cx: 9,
    cy: 12,
    r: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/createElement("circle", {
    cx: 16,
    cy: 12,
    r: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/createElement("circle", {
    cx: 23,
    cy: 12,
    r: 1.5
  })));
}

var ForwardRef$c = /*#__PURE__*/forwardRef(SvgIconChat);
var MemoForwardRef$c = /*#__PURE__*/memo(ForwardRef$c);

var _path$c, _path2$5, _path3;

function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

function SvgIconEnergyHouse(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$e({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$c || (_path$c = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.57 28.77a.63.63 0 01-.63-.63V11.97a.63.63 0 011.26 0v15.54h23.52V11.97a.63.63 0 01.63-.63c.348 0 .63 0 .63.63v16.17a.63.63 0 01-.63.63H3.57z",
    fill: "currentColor"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.63 15.33a.63.63 0 01-.426-1.094L15.534.166a.631.631 0 01.852.928l-15.33 14.07a.63.63 0 01-.426.166z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5 15.33a.629.629 0 01-.426-.166l-15.33-14.07a.63.63 0 01.852-.928l15.33 14.07a.63.63 0 01-.426 1.094zM22.26 24.57H7.98a.63.63 0 010-1.26h14.28a.63.63 0 010 1.26zM18.9 20.79H7.98a.63.63 0 010-1.26H18.9a.63.63 0 010 1.26zM15.54 17.01H7.98a.63.63 0 010-1.26h7.56a.63.63 0 010 1.26zM12.18 13.23h-4.2a.63.63 0 010-1.26h4.2a.63.63 0 010 1.26z",
    fill: "currentColor"
  })));
}

var ForwardRef$d = /*#__PURE__*/forwardRef(SvgIconEnergyHouse);
var MemoForwardRef$d = /*#__PURE__*/memo(ForwardRef$d);

var _path$d;

function _extends$f() { _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

function SvgIconEnvelope(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$f({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _path$d || (_path$d = /*#__PURE__*/createElement("path", {
    d: "M27 0H5a5 5 0 00-5 5v22a5 5 0 005 5h22a5 5 0 005-5V5a5 5 0 00-5-5zM1.5 5A3.5 3.5 0 015 1.5h22A3.5 3.5 0 0130.5 5v2.91l-13 6.52a3.22 3.22 0 01-2.9 0L1.5 7.91zm29 22a3.5 3.5 0 01-3.5 3.5H5A3.5 3.5 0 011.5 27V9.59l12.38 6.19a4.83 4.83 0 004.24 0L30.5 9.59z"
  })));
}

var ForwardRef$e = /*#__PURE__*/forwardRef(SvgIconEnvelope);
var MemoForwardRef$e = /*#__PURE__*/memo(ForwardRef$e);

var _path$e;

function _extends$g() { _extends$g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

function SvgIconHouse(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 51,
    ref: svgRef
  }, props), _path$e || (_path$e = /*#__PURE__*/createElement("path", {
    d: "M50 14.6L46 2.9C45.4 1.2 43.8.1 42.1.1H8.3C6.5.1 4.9 1.2 4.4 2.9l-4 11.7c-.4 1.2-.2 2.6.5 3.7.8 1.1 2 1.7 3.4 1.7h.9v28.9c0 .6.5 1.2 1.2 1.2h37.5c.6 0 1.2-.5 1.2-1.2V20h.9c1.3 0 2.6-.6 3.4-1.7.9-1.1 1.1-2.4.6-3.7zM30.3 47.8H20.1v-18c0-1.1.9-2 2-2h8.2v20zm12.5 0H32.6V26.7c0-.6-.5-1.2-1.2-1.2H22c-2.4 0-4.3 1.9-4.3 4.3v18H7.5V20h35.2v27.8h.1zm4.8-30.9c-.3.5-.9.8-1.5.8H4.4c-.6 0-1.1-.3-1.5-.8-.3-.5-.4-1-.2-1.6l4-11.7c.3-.7.9-1.2 1.7-1.2h33.8c.8 0 1.5.5 1.7 1.2l4 11.7c.1.6 0 1.2-.3 1.6z"
  })));
}

var ForwardRef$f = /*#__PURE__*/forwardRef(SvgIconHouse);
var MemoForwardRef$f = /*#__PURE__*/memo(ForwardRef$f);

var _circle$2, _path$f;

function _extends$h() { _extends$h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

function SvgIconInfo(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$h({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle$2 || (_circle$2 = /*#__PURE__*/createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21,
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path$f || (_path$f = /*#__PURE__*/createElement("path", {
    d: "M24.675 17.45H21.65l-1.525 8.65c-.35 1.95.4 3.025 2.4 3.025.55 0 1.15-.1 1.675-.275l.45-2.25c-.3.075-.525.125-.75.125-.725 0-.775-.5-.675-1.075l1.45-8.2zM21.8 13.875c0 1.1.85 1.75 1.85 1.75 1.1 0 1.925-.65 1.925-1.75 0-1.15-.825-1.8-1.925-1.8-1 0-1.85.65-1.85 1.8z",
    fill: "currentColor"
  })));
}

var ForwardRef$g = /*#__PURE__*/forwardRef(SvgIconInfo);
var MemoForwardRef$g = /*#__PURE__*/memo(ForwardRef$g);

var _defs$3, _path$g, _path2$6;

function _extends$i() { _extends$i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

function SvgIconPrivate(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$i({
    id: "icon-private_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _defs$3 || (_defs$3 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "icon-private_svg__clip-path"
  }, /*#__PURE__*/createElement("path", {
    className: "icon-private_svg__cls-1",
    d: "M-311-1200.34h5v20.25a10 10 0 01-10 10h-40v-5.25"
  })), /*#__PURE__*/createElement("clipPath", {
    id: "icon-private_svg__clip-path-2"
  }, /*#__PURE__*/createElement("path", {
    className: "icon-private_svg__cls-1",
    d: "M-326-1180.21h-40v-20.25a10 10 0 0110-10h40v20.25a10 10 0 01-10 10"
  })), /*#__PURE__*/createElement("clipPath", {
    id: "icon-private_svg__clip-path-3"
  }, /*#__PURE__*/createElement("path", {
    className: "icon-private_svg__cls-1",
    d: "M-344.03-1190.21l-2.7-4.08h-.6v4.08h-2.31v-10h2.31v3.92h.62l2.47-3.92h2.65l-3.16 4.84 3.47 5.16h-2.75z"
  })), /*#__PURE__*/createElement("clipPath", {
    id: "icon-private_svg__clip-path-4"
  }, /*#__PURE__*/createElement("path", {
    className: "icon-private_svg__cls-1",
    d: "M-334.22-1190.21a1.74 1.74 0 01-.53-1l-.37-1.49c-.2-.85-.59-1-1.36-1h-1v3.53h-2.31v-10h3.94c2.24 0 3.63.82 3.63 3.06a2.3 2.3 0 01-2.19 2.51 1.81 1.81 0 011.66 1.46l.51 1.87a2.26 2.26 0 00.56 1.07zm-3.24-5.43h1.46c.92 0 1.43-.36 1.43-1.31s-.48-1.31-1.43-1.31h-1.48z"
  })), /*#__PURE__*/createElement("style", null, ".icon-private_svg__cls-1{fill:none;clip-rule:evenodd}"))), _path$g || (_path$g = /*#__PURE__*/createElement("path", {
    d: "M30.93 10.87l-3.36-2.6V.75a.75.75 0 00-.75-.75H23.9a2.75 2.75 0 00-2.75 2.75v.55L17.68.62a2.76 2.76 0 00-3.36 0L1.07 10.87A2.73 2.73 0 000 13.06v17.19A1.75 1.75 0 001.75 32h28.5A1.76 1.76 0 0032 30.25V13.06a2.77 2.77 0 00-1.07-2.19zm-8.28-8.12A1.25 1.25 0 0123.9 1.5h2.17v5.62l-3.42-2.66zm3.6 27.74h-6.86V16a1.25 1.25 0 011.25-1.25h5.61zm4.25-.25a.25.25 0 01-.25.25h-2.5V14a.76.76 0 00-.75-.75h-6.36A2.75 2.75 0 0017.89 16v14.5H1.75a.25.25 0 01-.25-.25V13.06a1.25 1.25 0 01.48-1L15.23 1.81a1.23 1.23 0 01.77-.26 1.19 1.19 0 01.76.26L30 12.06a1.23 1.23 0 01.49 1z"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/createElement("path", {
    d: "M14.34 24.13H5a.75.75 0 01-.75-.75V16A2.75 2.75 0 017 13.29h7.35a.75.75 0 01.75.75v9.35a.75.75 0 01-.76.74zm-8.6-1.5h7.85v-7.84H7A1.25 1.25 0 005.75 16z"
  })));
}

var ForwardRef$h = /*#__PURE__*/forwardRef(SvgIconPrivate);
var MemoForwardRef$h = /*#__PURE__*/memo(ForwardRef$h);

var _defs$4, _path$h;

function _extends$j() { _extends$j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

function SvgIconSupport(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$j({
    id: "icon-support_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _defs$4 || (_defs$4 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "icon-support_svg__clip-path"
  }, /*#__PURE__*/createElement("path", {
    className: "icon-support_svg__cls-1",
    d: "M-311-1152.87h5v20.25a10 10 0 01-10 10h-40v-5.25"
  })), /*#__PURE__*/createElement("clipPath", {
    id: "icon-support_svg__clip-path-2"
  }, /*#__PURE__*/createElement("path", {
    className: "icon-support_svg__cls-1",
    d: "M-326-1132.75h-40V-1153a10 10 0 0110-10h40v20.25a10 10 0 01-10 10"
  })), /*#__PURE__*/createElement("clipPath", {
    id: "icon-support_svg__clip-path-3"
  }, /*#__PURE__*/createElement("path", {
    className: "icon-support_svg__cls-1",
    d: "M-344.03-1142.75l-2.7-4.07h-.6v4.07h-2.31v-10h2.31v3.93h.62l2.47-3.93h2.65l-3.16 4.84 3.47 5.16h-2.75z"
  })), /*#__PURE__*/createElement("clipPath", {
    id: "icon-support_svg__clip-path-4"
  }, /*#__PURE__*/createElement("path", {
    className: "icon-support_svg__cls-1",
    d: "M-334.22-1142.75a1.74 1.74 0 01-.53-1l-.37-1.49c-.2-.85-.59-1-1.36-1h-1v3.53h-2.31v-10h3.94c2.24 0 3.63.82 3.63 3.06a2.3 2.3 0 01-2.19 2.51 1.81 1.81 0 011.66 1.46l.51 1.87a2.26 2.26 0 00.56 1.07zm-3.24-5.43h1.46c.92 0 1.43-.36 1.43-1.31s-.48-1.31-1.43-1.31h-1.48z"
  })), /*#__PURE__*/createElement("style", null, ".icon-support_svg__cls-1{fill:none;clip-rule:evenodd}"))), _path$h || (_path$h = /*#__PURE__*/createElement("path", {
    d: "M29.25 11.25h-2.54v-.5a10.75 10.75 0 10-21.5 0v.5h-2.5A2.75 2.75 0 000 14v8a2.75 2.75 0 002.75 2.75H6a.76.76 0 00.71-.75V10.75a9.25 9.25 0 1118.5 0v14.5A3.26 3.26 0 0122 28.5h-3.39a2.75 2.75 0 100 1.5H22a4.75 4.75 0 004.75-4.75v-.5h2.54A2.75 2.75 0 0032 22v-8a2.75 2.75 0 00-2.75-2.75zm-24 12H2.71A1.25 1.25 0 011.46 22v-8a1.25 1.25 0 011.25-1.25h2.5zM16 30.5a1.25 1.25 0 111.25-1.25A1.25 1.25 0 0116 30.5zM30.5 22a1.25 1.25 0 01-1.25 1.25h-2.54v-10.5h2.54A1.25 1.25 0 0130.5 14z"
  })));
}

var ForwardRef$i = /*#__PURE__*/forwardRef(SvgIconSupport);
var MemoForwardRef$i = /*#__PURE__*/memo(ForwardRef$i);

var viewBox32 = '0 0 32 32';
var LargeIconMap = {
  calendar: {
    icon: MemoForwardRef$b,
    viewBox: viewBox32
  },
  chat: {
    icon: MemoForwardRef$c,
    viewBox: viewBox32
  },
  envelope: {
    icon: MemoForwardRef$e,
    viewBox: viewBox32
  },
  energy_house: {
    icon: MemoForwardRef$d,
    viewBox: viewBox32
  },
  house: {
    icon: MemoForwardRef$f,
    viewBox: '0 0 50 50'
  },
  info: {
    icon: MemoForwardRef$g,
    viewBox: '0 0 44 44'
  },
  "private": {
    icon: MemoForwardRef$h,
    viewBox: viewBox32
  },
  support: {
    icon: MemoForwardRef$i,
    viewBox: viewBox32
  }
};
var LargeIconOptions = /*#__PURE__*/Object.keys(LargeIconMap);

var _excluded$3 = ["aria-label", "className", "name"];
var useStyles$1 = /*#__PURE__*/makeStyles(function () {
  return createStyles({
    root: {
      pointerEvents: 'none',
      fontSize: '2rem'
    }
  });
});
var LargeIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var ariaLabel = _ref['aria-label'],
      className = _ref.className,
      name = _ref.name,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  var classes = useStyles$1();
  var title = capitalize(name).replace('_', ' ');
  var Component = LargeIconMap[name].icon;
  return React__default.createElement(SvgIcon, Object.assign({}, rest, {
    component: Component
  }, {
    "aria-label": ariaLabel || title,
    className: classNames('EfcLargeIcon', classes.root, className),
    ref: ref,
    viewBox: LargeIconMap[name].viewBox
  }));
});
LargeIcon.displayName = 'LargeIcon';

var _excluded$4 = ["className", "bold", "italic", "variant"];

var _templateObject$5, _templateObject2$4, _templateObject3$3;
var TypographyComponents = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'label', 'p', 'span', 'div'];
var extraVariants = ['ingress', 'spotlight'];
var TypographyVariants = /*#__PURE__*/['body1', 'body2', 'h1', 'h2', 'h3', 'h4', 'srOnly'].concat(extraVariants);
var StyledTypography = /*#__PURE__*/styled$1(Typography$1)(_templateObject$5 || (_templateObject$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  &.sr-only {\n    -webkit-clip-path: inset(50%) !important;\n    border: 0 !important;\n    clip-path: inset(50%) !important;\n    clip: rect(1px, 1px, 1px, 1px) !important;\n    height: 1px !important;\n    margin: -1px !important;\n    overflow: hidden !important;\n    padding: 0 !important;\n    position: absolute !important;\n    white-space: nowrap !important;\n    width: 1px !important;\n  }\n\n  .EfcLink {\n    font-size: inherit;\n    font-weight: inherit;\n    letter-spacing: inherit;\n    line-height: inherit;\n  }\n\n  .EfcIcon {\n    font-size: inherit;\n    vertical-align: middle;\n  }\n\n  .EfcLargeIcon {\n    font-size: inherit;\n    vertical-align: baseline;\n  }\n\n  &.bold {\n    font-weight: bold;\n  }\n\n  &.italic {\n    font-style: italic;\n  }\n"])));
var Ingress = /*#__PURE__*/styled$1(StyledTypography)(_templateObject2$4 || (_templateObject2$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-size: 1.5rem;\n  font-weight: 300;\n  line-height: 1.2em;\n\n  ", " {\n    font-weight: 400;\n    font-size: 1.75rem;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up('lg');
});
var Spotlight = /*#__PURE__*/styled$1(StyledTypography)(_templateObject3$3 || (_templateObject3$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  display: inline-block;\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-weight: bold;\n\n  &::selection {\n    -webkit-text-fill-color: initial;\n  }\n"])), bgGradient);
var useStyles$2 = /*#__PURE__*/makeStyles(function () {
  return createStyles({
    gutterBottom: {
      marginBottom: '0.5em'
    }
  });
});
/**
 * #### Accessibility
 *
 * A few key factors to follow for an accessible typography:
 *
 * - **Color**. Provide enough contrast between text and its background, check out the minimum recommended [WCAG 2.0 color contrast ratio](https://www.w3.org/TR/UNDERSTANDING-WCAG20/visual-audio-contrast-contrast.html) (4.5:1).
 * - **Font size**. Use [relative units (rem)](https://mui.com/customization/typography/#font-size) to accommodate the user's settings.
 * - **Heading hierarchy**. [Don't skip](https://www.w3.org/WAI/tutorials/page-structure/headings/) heading levels. In order to solve this problem, you need to [separate the semantics from the style](https://mui.com/components/typography/#changing-the-semantic-element).
 */

var Typography = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
      bold = _ref2.bold,
      italic = _ref2.italic,
      variant = _ref2.variant,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded$4);

  var classes = useStyles$2();
  var Component;

  switch (variant) {
    case 'ingress':
      Component = Ingress;
      break;

    case 'spotlight':
      Component = Spotlight;
      break;

    default:
      Component = StyledTypography;
  }

  return React__default.createElement(Component, Object.assign({
    classes: {
      gutterBottom: classes.gutterBottom
    },
    className: classNames({
      bold: bold,
      italic: italic,
      'sr-only': variant === 'srOnly'
    }, className),
    variant: variant && extraVariants.includes(variant) ? undefined : variant,
    ref: ref
  }, rest));
});
Typography.displayName = 'Typography';

var _excluded$5 = ["className", "description", "fullWidth", "icon", "size", "title"];

var _templateObject$6;
var StyledButton$1 = /*#__PURE__*/styled$1(MuiButton)(_templateObject$6 || (_templateObject$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  background: ", ";\n  border-radius: ", " !important;\n  border: ", " !important;\n  color: ", ";\n  display: flex;\n  justify-content: space-between;\n  overflow: hidden;\n  padding: ", ";\n  position: relative;\n  text-transform: none;\n\n  &:not(.fullwidth) {\n    width: fit-content;\n  }\n\n  &.btn-medium {\n    padding: ", ";\n  }\n\n  &.btn-large {\n    padding: ", ";\n  }\n\n  &::before {\n    background: ", ";\n    bottom: 0;\n    content: '';\n    left: 0;\n    position: absolute;\n    top: 0;\n    transform: rotate(180deg);\n    width: ", ";\n  }\n\n  &:disabled::before {\n    opacity: ", ";\n  }\n\n  &:hover {\n    background: ", ";\n  }\n\n  &:focus-visible {\n    background: ", ";\n  }\n\n  svg.navigation-icon {\n    ", "\n    margin-right: ", ";\n  }\n\n  &:hover,\n  &:active,\n  &:focus-visible:not(:disabled) {\n    svg.navigation-icon {\n      margin-right: 0;\n      margin-left: ", ";\n    }\n  }\n"])), focusVisibleBoxShadow, function (_ref) {
  var theme = _ref.theme;
  return theme.palette.background.paper;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.shape.borderRadius + "px";
}, function (_ref3) {
  var theme = _ref3.theme;
  return "thin solid " + theme.palette.divider;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.text.primary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.spacing(2, 3, 2, 4);
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacing(3, 4, 3, 5);
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacing(4, 5, 4, 6);
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.palette.fjordGreen;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.spacing();
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.palette.action.disabledOpacity;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.palette.action.hover;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.palette.action.focus;
}, /*#__PURE__*/fastTransition('margin'), function (_ref13) {
  var theme = _ref13.theme;
  return theme.spacing();
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.spacing();
});
var StylizedButton = /*#__PURE__*/forwardRef(function (_ref15, ref) {
  var className = _ref15.className,
      description = _ref15.description,
      fullWidth = _ref15.fullWidth,
      icon = _ref15.icon,
      _ref15$size = _ref15.size,
      size = _ref15$size === void 0 ? 'medium' : _ref15$size,
      title = _ref15.title,
      rest = _objectWithoutPropertiesLoose(_ref15, _excluded$5);

  return React__default.createElement(StyledButton$1, Object.assign({}, rest, {
    className: classNames(className, "btn-" + size, {
      fullwidth: fullWidth
    }),
    disableElevation: true,
    endIcon: React__default.createElement(Icon, {
      className: "navigation-icon",
      name: "double_arrow",
      color: "inherit"
    }),
    fullWidth: fullWidth,
    ref: ref
  }), React__default.createElement(Box$1, {
    display: "flex",
    alignItems: "center"
  }, icon ? LargeIconOptions.includes(icon) ? React__default.createElement(LargeIcon, {
    className: "mr-3",
    color: "inherit",
    name: icon
  }) : React__default.createElement(Icon, {
    className: "mr-3",
    name: icon,
    color: "inherit"
  }) : null, React__default.createElement(Box$1, {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    mr: 5
  }, React__default.createElement(Typography, {
    component: "span",
    variant: size === 'large' ? 'h3' : size === 'medium' ? 'h4' : undefined
  }, title), description && React__default.createElement(Typography, {
    component: "span"
  }, description))));
});
StylizedButton.displayName = 'StylizedButton';

var _g$1, _defs$5;

function _extends$k() { _extends$k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

function SvgLogoLight(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$k({
    width: 140,
    height: 40,
    viewBox: "0 0 742 215",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g$1 || (_g$1 = /*#__PURE__*/createElement("g", {
    clipPath: "url(#logo_light_svg__clip0_104_1625)"
  }, /*#__PURE__*/createElement("path", {
    d: "M428.858 62.484c-5.598 0-10.954 1.688-15.667 4.332-4.713 2.643-8.781 6.238-11.797 10.053v-9.758c0-.792-.321-1.51-.835-2.026a2.835 2.835 0 00-2.019-.839h-6.441a2.857 2.857 0 00-2.854 2.865v81.372c0 .792.321 1.51.835 2.026.514.516 1.23.839 2.019.839h6.441a2.856 2.856 0 002.854-2.865V99.709c0-7.165 2.707-13.55 7.145-18.15 4.439-4.596 10.603-7.403 17.52-7.403 3.805 0 7.265.563 10.297 1.654 3.031 1.09 5.629 2.717 7.714 4.84 2.029 2.065 3.541 4.557 4.535 7.453.994 2.896 1.469 6.2 1.415 9.89v50.49c0 .792.321 1.51.835 2.026.519.52 1.23.839 2.019.839h6.616a2.856 2.856 0 002.853-2.865V96.585c0-10.038-3.441-18.567-9.349-24.58-5.909-6.016-14.28-9.521-24.14-9.521h.004zM522.001 62.484c-12.52 0-23.32 4.763-30.995 12.81-7.671 8.046-12.214 19.373-12.214 32.501 0 13.128 4.543 24.455 12.214 32.502 7.671 8.046 18.475 12.809 30.995 12.809s23.319-4.763 30.994-12.809c7.672-8.047 12.215-19.374 12.215-32.502 0-13.128-4.543-24.455-12.215-32.502-7.671-8.046-18.474-12.81-30.994-12.81zm30.882 45.311c0 9.747-3.248 18.155-8.731 24.129-5.482 5.974-13.204 9.51-22.151 9.51-8.948 0-16.669-3.536-22.152-9.51-5.483-5.974-8.731-14.382-8.731-24.129 0-9.747 3.175-18.314 8.623-24.249 5.448-5.935 13.169-9.394 22.26-9.394 9.09 0 16.812 3.459 22.26 9.394 5.448 5.935 8.622 14.343 8.622 24.249zM610.639 135.557l-27.998-69.521a2.848 2.848 0 00-2.649-1.794h-7.258c-1.02 0-1.875.52-2.378 1.277a2.863 2.863 0 00-.259 2.694l33.88 81.373c.22.531.591.974 1.051 1.28.46.307 1.006.482 1.582.482h8.205c.576 0 1.125-.175 1.581-.482a2.881 2.881 0 001.052-1.28l33.879-81.373a2.85 2.85 0 00-.259-2.694 2.832 2.832 0 00-2.378-1.277h-7.258a2.85 2.85 0 00-2.644 1.79l-28.165 69.529.016-.004zM730.055 67.107v11.866c-3.465-4.712-8.209-8.834-13.661-11.78-5.456-2.947-11.619-4.713-17.922-4.713-12.017 0-22.558 4.872-30.09 12.969-7.536 8.097-12.067 19.428-12.067 32.342 0 12.915 4.396 24.455 11.82 32.502 7.424 8.046 17.875 12.809 29.989 12.809 6.399 0 12.551-1.731 18.019-4.689 5.467-2.958 10.25-7.138 13.915-12.033v12.099a2.862 2.862 0 002.854 2.865h6.616a2.84 2.84 0 002.018-.839 2.866 2.866 0 00.835-2.026V67.107c0-.792-.321-1.51-.835-2.026a2.842 2.842 0 00-2.018-.839h-6.616c-.789 0-1.504.322-2.018.839a2.864 2.864 0 00-.836 2.026h-.003zm.348 40.688c0 9.747-3.283 18.155-8.832 24.129-5.544 5.974-13.355 9.51-22.403 9.51-9.048 0-16.479-3.536-21.9-9.51-5.421-5.974-8.63-14.382-8.63-24.129 0-9.747 3.247-18.155 8.73-24.129 5.483-5.974 13.205-9.51 22.152-9.51 8.947 0 16.812 3.459 22.26 9.394 5.448 5.935 8.623 14.343 8.623 24.249v-.004zM373.23 106.914c0-12.666-4.644-23.776-12.37-31.714-7.721-7.942-18.525-12.716-30.843-12.716-12.319 0-23.119 4.871-30.84 12.969-7.722 8.097-12.366 19.427-12.366 32.342 0 12.914 4.644 24.245 12.366 32.342 7.721 8.098 18.524 12.969 30.84 12.969 11.549 0 20.419-3.897 26.88-9.021 6.457-5.124 10.506-11.478 12.404-16.389a2.834 2.834 0 00-.313-2.647 2.848 2.848 0 00-2.359-1.242h-7.269c-.518 0-1.021.14-1.454.392a2.746 2.746 0 00-1.04 1.083c-2.726 5.155-6.492 9.192-11.051 11.94-4.558 2.748-9.906 4.208-15.791 4.208-8.197 0-15.389-2.954-20.756-8.051-5.367-5.096-8.912-12.332-9.813-20.895h70.851c.758 0 1.45-.295 1.965-.784a2.839 2.839 0 00.885-1.922c.023-.419.043-.873.054-1.354.016-.482.023-.99.023-1.514l-.003.004zm-73.528-5.749c1.234-7.996 4.911-14.75 10.231-19.506 5.321-4.755 12.285-7.51 20.087-7.51 7.803 0 15.2 2.814 20.544 7.6 5.343 4.786 8.881 11.536 9.72 19.412h-60.578l-.004.004zM107.047 63.99l-2.792-30.41-2.792-30.409a2.833 2.833 0 01.731-2.181 2.84 2.84 0 012.104-.928h5.138a2.859 2.859 0 012.854 3.11l-2.618 30.409-2.618 30.409h-.007zM65.728 93.992l-29.656-6.723-29.657-6.724a2.867 2.867 0 01-2.092-3.672l.789-2.457.788-2.457a2.85 2.85 0 013.828-1.762l27.998 11.897 27.998 11.898h.004zM81.384 142.711l-15.536 26.236-15.536 26.237a2.862 2.862 0 01-1.875 1.343 2.825 2.825 0 01-2.25-.481l-2.085-1.51-2.084-1.51a2.859 2.859 0 01-1.164-1.996 2.864 2.864 0 01.681-2.208l19.925-23.054 19.924-23.053v-.004zM132.377 142.82l20.056 22.941 20.056 22.94c.553.633.777 1.437.692 2.205a2.857 2.857 0 01-1.152 1.999l-2.073 1.522-2.072 1.522a2.839 2.839 0 01-2.247.496 2.841 2.841 0 01-1.883-1.331l-15.683-26.147-15.683-26.147h-.011zM94.302 89.908L67.808 58.136l-26.49-31.772a2.864 2.864 0 01-.645-2.189 2.85 2.85 0 011.152-1.968l2.13-1.56 2.131-1.56a2.826 2.826 0 012.215-.501 2.843 2.843 0 011.88 1.284L72.24 54.891l22.059 35.021.003-.004zM148.234 94.166l27.928-12.06 27.929-12.06a2.823 2.823 0 012.3.019c.7.318 1.276.92 1.539 1.72l.801 2.449.8 2.45c.263.799.155 1.626-.224 2.297a2.854 2.854 0 01-1.841 1.386l-29.618 6.894-29.618 6.894.004.011zM86.345 114.169l-38.287 15.476L9.77 145.122c-.766.31-1.582.26-2.27-.063a2.851 2.851 0 01-1.508-1.708l-.82-2.519-.82-2.519a2.866 2.866 0 012.011-3.668l39.993-10.24 39.992-10.24-.004.004zM106.865 129.265l2.83 41.336 2.831 41.336a2.86 2.86 0 01-2.842 3.063h-5.278a2.84 2.84 0 01-2.088-.908 2.893 2.893 0 01-.77-2.155l2.657-41.336 2.656-41.336h.004zM127.509 114.336l40.035 10.073 40.034 10.073a2.869 2.869 0 012.023 3.66l-.812 2.523-.812 2.523a2.848 2.848 0 01-1.501 1.712 2.84 2.84 0 01-2.269.07l-38.349-15.313-38.349-15.314v-.007zM119.745 90.013l21.912-35.114 21.912-35.114a2.844 2.844 0 014.09-.803l2.139 1.552 2.138 1.553a2.86 2.86 0 011.16 1.964 2.854 2.854 0 01-.634 2.19l-26.359 31.884-26.358 31.884v.004zM115.368 81.233l9.214-37.354 9.214-37.354a2.853 2.853 0 013.654-2.038l2.494.815 2.494.816a2.84 2.84 0 011.705 1.517c.321.695.367 1.518.058 2.287l-14.419 35.657-14.418 35.657.004-.004zM98.447 133.515l-9.214 37.354-9.214 37.354a2.851 2.851 0 01-1.384 1.816 2.831 2.831 0 01-2.27.221l-2.494-.815-2.494-.815a2.876 2.876 0 01-1.763-3.804l14.419-35.657 14.418-35.658-.004.004zM98.447 81.233L84.03 45.575 69.614 9.918a2.86 2.86 0 01.058-2.287 2.85 2.85 0 011.705-1.517l2.494-.815 2.494-.816a2.838 2.838 0 012.27.222 2.841 2.841 0 011.384 1.816l9.214 37.354 9.214 37.354v.004zM115.368 133.515l14.418 35.658 14.419 35.657a2.86 2.86 0 01-.058 2.286 2.852 2.852 0 01-1.705 1.518l-2.494.815-2.494.815a2.834 2.834 0 01-2.27-.221 2.84 2.84 0 01-1.384-1.817l-9.214-37.353-9.214-37.354-.004-.004zM84.756 91.216l-32.541-20.34-32.542-20.34a2.842 2.842 0 01-1.291-1.883c-.143-.749.004-1.56.49-2.232l1.544-2.13 1.542-2.132a2.848 2.848 0 014.15-.508L55.43 66.435 84.757 91.22v-.004zM129.059 123.531l32.542 20.341 32.541 20.34a2.838 2.838 0 011.291 1.882 2.871 2.871 0 01-.491 2.232l-1.543 2.131-1.542 2.131a2.849 2.849 0 01-4.149.509l-29.324-24.785-29.325-24.784v.003zM79.528 107.372l-38.233 2.748-38.233 2.748a2.848 2.848 0 01-2.15-.76 2.849 2.849 0 01-.908-2.097v-5.267a2.86 2.86 0 013.058-2.857l38.233 2.748 38.233 2.749v-.012zM134.287 107.372l38.233-2.748 38.233-2.749a2.854 2.854 0 013.058 2.857V110c0 .831-.352 1.576-.908 2.096a2.849 2.849 0 01-2.15.761l-38.233-2.748-38.233-2.749v.012zM84.756 123.531L55.43 148.316l-29.324 24.785a2.846 2.846 0 01-4.149-.509l-1.542-2.131-1.543-2.131a2.856 2.856 0 01-.491-2.232 2.866 2.866 0 011.291-1.882l32.541-20.34 32.542-20.341v-.004zM129.059 91.216l29.325-24.784 29.324-24.785a2.85 2.85 0 014.149.508l1.542 2.131 1.543 2.131c.487.672.638 1.483.491 2.232a2.867 2.867 0 01-1.291 1.883l-32.541 20.34-32.542 20.34v.004z"
  }))), _defs$5 || (_defs$5 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "logo_light_svg__clip0_104_1625"
  }, /*#__PURE__*/createElement("path", {
    d: "M0 0h742v215H0z"
  })))));
}

var ForwardRef$j = /*#__PURE__*/forwardRef(SvgLogoLight);
var MemoForwardRef$j = /*#__PURE__*/memo(ForwardRef$j);

var Logo = function Logo(props) {
  return React__default.createElement(MemoForwardRef$j, Object.assign({}, props));
};
Logo.displayName = 'Logo';

var _excluded$6 = ["children", "className", "component"];

var _templateObject$7;
var StyledButtonWrapper = /*#__PURE__*/styled$1.div(_templateObject$7 || (_templateObject$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  & > button {\n    ", ";\n    align-items: center;\n    background: none;\n    border-radius: 0;\n    border: none;\n    box-shadow: none;\n    color: ", ";\n    display: block;\n    height: ", "px;\n    padding: ", ";\n\n    ", "\n    &:hover {\n      background: ", ";\n      color: ", ";\n    }\n  }\n"])), focusVisibleInsetBoxShadow, function (_ref) {
  var theme = _ref.theme;
  return theme.palette.background.paper;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.mixins.toolbar.minHeight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing(0, 3);
}, function (_ref4) {
  var theme = _ref4.theme;
  return Object.entries(theme.mixins.toolbar).filter(function (_ref5) {
    var obj = _ref5[1];
    return typeof obj === 'object';
  }).map(function (_ref6) {
    var key = _ref6[0],
        value = _ref6[1];
    return key + " {\n          height: " + value.minHeight + "px;\n      }";
  });
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.palette.mountainGreen;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.palette.white;
});
var AppBarButton = function AppBarButton(_ref9) {
  var children = _ref9.children,
      className = _ref9.className,
      _ref9$component = _ref9.component,
      Component = _ref9$component === void 0 ? Button : _ref9$component,
      rest = _objectWithoutPropertiesLoose(_ref9, _excluded$6);

  return React__default.createElement(StyledButtonWrapper, null, React__default.createElement(Component, Object.assign({}, rest, {
    className: classNames('app-bar--button', className)
  }), React__default.createElement(Typography, {
    className: "app-bar--button-label",
    component: "p",
    variant: "h4"
  }, React__default.createElement("strong", {
    className: "d-flex ai-center"
  }, children))));
};
AppBarButton.displayName = 'AppBarButton';

var _excluded$7 = ["shadow", "outlined"];
var PaperElevationMap = {
  none: 0,
  small: 2,
  large: 8
};
/**
 * Implements [Paper](https://mui.com/component/paper/) from **Material-UI**.
 */

var Paper = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$shadow = _ref.shadow,
      shadow = _ref$shadow === void 0 ? 'small' : _ref$shadow,
      outlined = _ref.outlined,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$7);

  return React__default.createElement(Paper$1, Object.assign({}, rest, {
    elevation: outlined ? undefined : PaperElevationMap[shadow],
    variant: outlined ? 'outlined' : undefined,
    ref: ref
  }));
});
Paper.displayName = 'Paper';

var _templateObject$8, _templateObject2$5;
var DrawerSizingCSS = /*#__PURE__*/css(_templateObject$8 || (_templateObject$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  width: 100vw;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n\n  ", " {\n    width: 320px;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up('sm');
});
var StyledPaper = /*#__PURE__*/styled$1(Paper)(_templateObject2$5 || (_templateObject2$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  border-radius: 0;\n"])), DrawerSizingCSS);
var Drawer = function Drawer(props) {
  return React__default.createElement(MuiDrawer, Object.assign({}, props, {
    anchor: "left",
    variant: "temporary",
    PaperProps: {
      component: StyledPaper
    }
  }));
};
Drawer.displayName = 'Drawer';

var _excluded$8 = ["aria-label", "className", "label"];

var _templateObject$9, _templateObject2$6, _templateObject3$4;
var StyledDrawer = /*#__PURE__*/styled$1(MuiDrawer)(_templateObject$9 || (_templateObject$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  z-index: ", " !important;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.zIndex.appBar - 1;
});
var OuterDrawerContentWrapper = /*#__PURE__*/styled$1.div(_templateObject2$6 || (_templateObject2$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  padding-top: ", "px;\n  position: relative;\n\n  ", "\n"])), DrawerSizingCSS, function (_ref2) {
  var theme = _ref2.theme;
  return theme.mixins.toolbar.minHeight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return Object.entries(theme.mixins.toolbar).filter(function (_ref4) {
    var obj = _ref4[1];
    return typeof obj === 'object';
  }).map(function (_ref5) {
    var key = _ref5[0],
        value = _ref5[1];
    return key + " {\n          padding-top: " + value.minHeight + "px;\n      }";
  });
});
var InnerDrawerContentWrapper = /*#__PURE__*/styled$1.div(_templateObject3$4 || (_templateObject3$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow-y: auto;\n  width: 100%;\n"])));
var AppBarMenu = function AppBarMenu(_ref6) {
  var children = _ref6.children,
      _ref6$ToggleButtonPro = _ref6.ToggleButtonProps;
  _ref6$ToggleButtonPro = _ref6$ToggleButtonPro === void 0 ? {} : _ref6$ToggleButtonPro;

  var toggleButtonAriaLabel = _ref6$ToggleButtonPro['aria-label'],
      toggleButtonLabel = _ref6$ToggleButtonPro.label,
      ToggleButtonProps = _objectWithoutPropertiesLoose(_ref6$ToggleButtonPro, _excluded$8);

  var _useEnovaContext = useEnovaContext(),
      mainMenuOpen = _useEnovaContext.mainMenuOpen,
      setMainMenuOpen = _useEnovaContext.setMainMenuOpen,
      theme = _useEnovaContext.theme;

  var collapse = useMediaQuery(theme.breakpoints.down('md')) || !toggleButtonLabel;
  return React__default.createElement(Fragment, null, React__default.createElement(ToggleButton, Object.assign({}, ToggleButtonProps, {
    "aria-label": toggleButtonAriaLabel != null ? toggleButtonAriaLabel : mainMenuOpen ? 'close menu' : 'open menu',
    className: classNames({
      'ml-2': collapse
    }),
    label: collapse ? undefined : toggleButtonLabel,
    onClick: function onClick() {
      return setMainMenuOpen(function (prev) {
        return !prev;
      });
    },
    open: mainMenuOpen
  })), React__default.createElement(StyledDrawer, {
    anchor: "left",
    onClose: function onClose() {
      return setMainMenuOpen(false);
    },
    open: mainMenuOpen,
    variant: "temporary"
  }, React__default.createElement(ClickAwayListener, {
    onClickAway: function onClickAway() {
      return setMainMenuOpen(false);
    }
  }, React__default.createElement(OuterDrawerContentWrapper, null, React__default.createElement(InnerDrawerContentWrapper, null, children)))));
};
AppBarMenu.displayName = 'AppBarMenu';

var _excluded$9 = ["aria-label", "children", "component", "href"],
    _excluded2 = ["logoProps", "leftContent", "rightContent"];

var _templateObject$a, _templateObject2$7;
var StyledAppBar = /*#__PURE__*/styled$1(MuiAppBar)(_templateObject$a || (_templateObject$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: ", " !important;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.primary.main;
});
var LogoWrapper = /*#__PURE__*/styled$1.div(_templateObject2$7 || (_templateObject2$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  a {\n    ", ";\n    align-items: center;\n    border-radius: ", "px;\n    display: flex;\n    left: 50%;\n    padding: ", ";\n    position: absolute;\n    text-decoration: none;\n    top: 50%;\n    transform: translate(-50%, -50%);\n  }\n"])), focusVisibleInsetBoxShadow, function (_ref2) {
  var theme = _ref2.theme;
  return theme.shape.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing();
});
var AppBar = function AppBar(_ref4) {
  var _ref4$logoProps = _ref4.logoProps;
  _ref4$logoProps = _ref4$logoProps === void 0 ? {} : _ref4$logoProps;

  var _ref4$logoProps$aria = _ref4$logoProps['aria-label'],
      logoAriaLabel = _ref4$logoProps$aria === void 0 ? 'logo' : _ref4$logoProps$aria,
      _ref4$logoProps$child = _ref4$logoProps.children,
      logo = _ref4$logoProps$child === void 0 ? React__default.createElement(Logo, null) : _ref4$logoProps$child,
      _ref4$logoProps$compo = _ref4$logoProps.component,
      LogoComponent = _ref4$logoProps$compo === void 0 ? 'a' : _ref4$logoProps$compo,
      _ref4$logoProps$href = _ref4$logoProps.href,
      href = _ref4$logoProps$href === void 0 ? '/' : _ref4$logoProps$href,
      logoProps = _objectWithoutPropertiesLoose(_ref4$logoProps, _excluded$9),
      leftContent = _ref4.leftContent,
      rightContent = _ref4.rightContent,
      rest = _objectWithoutPropertiesLoose(_ref4, _excluded2);

  return React__default.createElement(StyledAppBar, Object.assign({
    color: "transparent",
    elevation: 1
  }, rest), React__default.createElement(Toolbar, {
    className: "d-flex ai-center jc-between p-relative p-0"
  }, leftContent, React__default.createElement(LogoWrapper, null, React__default.createElement(LogoComponent, Object.assign({}, logoProps, {
    "aria-label": logoAriaLabel,
    href: href
  }), logo)), rightContent && React__default.createElement("div", {
    className: "d-flex ai-center"
  }, rightContent)));
};
AppBar.Button = AppBarButton;
AppBar.Menu = AppBarMenu;
AppBar.displayName = 'AppBar';

var _excluded$a = ["className", "inline"];

var _templateObject$b;
var StyledBadge = /*#__PURE__*/styled$1(MuiBadge)(_templateObject$b || (_templateObject$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  .badge {\n    color: ", ";\n    background: ", ";\n    padding-bottom: 3px;\n  }\n\n  &.inline .badge {\n    position: initial;\n    top: initial;\n    right: initial;\n    transform: initial;\n    transform-origin: initial;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.getContrastText(theme.palette.extras.blue);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.extras.blue;
});
var Badge = function Badge(_ref3) {
  var className = _ref3.className,
      inline = _ref3.inline,
      rest = _objectWithoutPropertiesLoose(_ref3, _excluded$a);

  return React__default.createElement(StyledBadge, Object.assign({}, rest, {
    classes: {
      badge: 'badge',
      root: 'badge--root'
    },
    className: classNames({
      inline: inline
    }, className)
  }));
};
Badge.displayName = 'Badge';

var _excluded$b = ["badgeContent", "className", "label", "open"];

var _templateObject$c, _templateObject2$8, _templateObject3$5, _templateObject4$2;
var StyleCSS = /*#__PURE__*/css(_templateObject$c || (_templateObject$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  align-items: center;\n  display: flex;\n  height: 48px;\n  padding: 12px;\n  position: relative;\n  transform: rotate(0deg);\n  width: 48px;\n\n  .badge--root {\n    height: 100%;\n    width: 100%;\n  }\n\n  & > span {\n    position: relative;\n    height: 100%;\n  }\n\n  .bar {\n    background-color: ", ";\n    border-radius: 2px;\n    display: block;\n    height: 4px;\n    left: 0;\n    opacity: 1;\n    position: absolute;\n    transform: rotate(0deg);\n    transition: 0.25s ease-in-out;\n    width: 100%;\n\n    &--1 {\n      top: 2px;\n    }\n\n    &--2,\n    &--3 {\n      top: calc(50% - 2px);\n      z-index: 1;\n    }\n\n    &--4 {\n      top: calc(100% - 6px);\n    }\n  }\n\n  &.open .bar {\n    &--1 {\n      top: calc(50% - 2px);\n      width: 0;\n      left: 50%;\n    }\n\n    &--2 {\n      transform: rotate(45deg);\n    }\n\n    &--3 {\n      transform: rotate(-45deg);\n    }\n\n    &--4 {\n      top: calc(50% - 2px);\n      width: 0;\n      left: 50%;\n    }\n  }\n"])), focusVisibleSingleThickBoxShadow, function (_ref) {
  var theme = _ref.theme;
  return theme.palette.background.paper;
});
var StyledWrapper = /*#__PURE__*/styled$1.span(_templateObject2$8 || (_templateObject2$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), StyleCSS);
var StyledIconButton$1 = /*#__PURE__*/styled$1(MuiIconButton)(_templateObject3$5 || (_templateObject3$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), StyleCSS);
var StyledButton$2 = /*#__PURE__*/styled$1(AppBarButton)(_templateObject4$2 || (_templateObject4$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  border-radius: ", "px;\n  cursor: pointer;\n  display: flex;\n  padding: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.shape.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing(1, 3, 1, 1);
});

var Bars = function Bars(props) {
  return React__default.createElement(Badge, Object.assign({
    "aria-hidden": true
  }, props), React__default.createElement("span", {
    className: "bar bar--1"
  }), React__default.createElement("span", {
    className: "bar bar--2"
  }), React__default.createElement("span", {
    className: "bar bar--3"
  }), React__default.createElement("span", {
    className: "bar bar--4"
  }));
};

var ToggleButton = /*#__PURE__*/forwardRef(function (_ref4, ref) {
  var badgeContent = _ref4.badgeContent,
      className = _ref4.className,
      label = _ref4.label,
      open = _ref4.open,
      rest = _objectWithoutPropertiesLoose(_ref4, _excluded$b);

  return label ? React__default.createElement(StyledButton$2, Object.assign({}, rest, {
    ref: ref,
    className: classNames(className, 'toggle-btn')
  }), React__default.createElement(StyledWrapper, {
    className: classNames({
      open: open
    })
  }, React__default.createElement(Bars, {
    badgeContent: badgeContent
  })), React__default.createElement("span", {
    className: "pl-4"
  }, label)) : React__default.createElement(StyledIconButton$1, Object.assign({}, rest, {
    className: classNames({
      open: open
    }, className, 'toggle-btn'),
    ref: ref
  }), React__default.createElement(Bars, {
    badgeContent: badgeContent
  }));
});
ToggleButton.displayName = 'ToggleButton';

var _excluded$c = ["className", "variant"];
var Chip = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$c);

  return React__default.createElement(MuiChip, Object.assign({}, rest, {
    ref: ref,
    className: classNames(className, 'fvbs'),
    color: variant === 'primary' ? 'primary' : 'default',
    size: "small",
    variant: variant === 'primary' ? undefined : 'outlined'
  }));
});
Chip.displayName = 'Chip';

var _excluded$d = ["currentGrade", "currentGradeDesc", "desc", "potentialGrade", "potentialGradeDesc", "screenReaderCaption"];

var _templateObject$d, _templateObject2$9, _templateObject3$6, _templateObject4$3, _templateObject5$1;
var Wrapper = /*#__PURE__*/styled$1.div(_templateObject$d || (_templateObject$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: grid;\n  grid-template-columns: ", ";\n  column-gap: ", ";\n\n  ", " {\n    grid-template-columns: ", ";\n    column-gap: ", ";\n  }\n"])), function (_ref) {
  var columns = _ref.columns;
  return ['minmax(100px, 260px)'].concat(Array.from(Array(columns - 1 || 0)).map(function () {
    return 'min-content';
  })).join(' ');
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(2);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up('sm');
}, function (_ref4) {
  var columns = _ref4.columns;
  return [].concat(Array.from(Array(columns)).map(function () {
    return 'min-content';
  })).join(' ');
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.spacing(2);
});
var eneryGradeBarHeight = 30; // px

var EnergyGradeBar = /*#__PURE__*/styled$1.div(_templateObject2$9 || (_templateObject2$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  align-items: center;\n  background: ", ";\n  color: ", ";\n  display: flex;\n  grid-column: 1;\n  height: ", "px;\n  margin: ", ";\n  padding: ", ";\n  position: relative;\n  text-transform: uppercase;\n\n  ", " {\n    margin-right: ", "px;\n    width: ", ";\n  }\n\n  &:after {\n    border-color: ", ";\n    border-style: solid;\n    border-width: ", "px;\n    content: '';\n    height: 0;\n    position: absolute;\n    right: ", "px;\n    top: 0;\n    width: 0;\n  }\n"])), function (_ref6) {
  var level = _ref6.level,
      theme = _ref6.theme;
  return theme.palette.energyGrade[level];
}, function (_ref7) {
  var level = _ref7.level,
      theme = _ref7.theme;
  return theme.palette.getContrastText(theme.palette.energyGrade[level]);
}, eneryGradeBarHeight, function (_ref8) {
  var level = _ref8.level,
      theme = _ref8.theme;
  return theme.spacing(0.5) + " " + (EnergyGrades.length - EnergyGrades.indexOf(level) + 1) + "ch " + theme.spacing(0.5) + " 0";
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.spacing(0.25, 0, 0.25, 2);
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.up('sm');
}, eneryGradeBarHeight / 2, function (_ref11) {
  var level = _ref11.level;
  return "calc(150px + " + EnergyGrades.indexOf(level) * 1.75 + "ch)";
}, function (_ref12) {
  var level = _ref12.level,
      theme = _ref12.theme;
  return "transparent transparent transparent " + theme.palette.energyGrade[level];
}, eneryGradeBarHeight / 2, eneryGradeBarHeight * -1);
var EnergyGradeIndicatorMargin = -0.5; // Spacer parameter

var EnergyGradeIndicator = /*#__PURE__*/styled$1.div(_templateObject3$6 || (_templateObject3$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: ", ";\n  color: ", ";\n  grid-column: 2;\n  grid-row: ", ";\n  padding-left: ", ";\n  position: relative;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  width: 40px;\n  margin: ", ";\n  ", " {\n    width: 50px;\n  }\n\n  &:before {\n    border-color: transparent;\n    border-right-color: ", ";\n    border-style: solid;\n    border-width: ", ";\n    content: '';\n    height: 0;\n    position: absolute;\n    left: ", ";\n    top: 0;\n    width: 0;\n  }\n\n  span {\n    margin-top: ", ";\n  }\n\n  &.potential {\n    background: ", ";\n    grid-column: 4;\n\n    &:before {\n      border-right-color: ", ";\n    }\n  }\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.palette.text.primary;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.palette.getContrastText(theme.palette.text.primary);
}, function (_ref15) {
  var level = _ref15.level;
  return EnergyGrades.indexOf(level) + 1;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.spacing(2);
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.spacing(EnergyGradeIndicatorMargin) + " 0 " + theme.spacing(EnergyGradeIndicatorMargin) + " calc(" + eneryGradeBarHeight / 2 + "px +\n      " + theme.spacing(0.5 + EnergyGradeIndicatorMargin * -1) + ")";
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.breakpoints.up('sm');
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.palette.text.primary;
}, function (_ref20) {
  var theme = _ref20.theme;
  return "calc(" + eneryGradeBarHeight / 2 + "px +\n      " + theme.spacing(0.5 + EnergyGradeIndicatorMargin * -1) + ")";
}, function (_ref21) {
  var theme = _ref21.theme;
  return "calc(" + -1 * eneryGradeBarHeight + "px - " + theme.spacing(1 + EnergyGradeIndicatorMargin * -2) + ")";
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.spacing(-0.5);
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.palette.text.secondary;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.palette.text.secondary;
});
var GridDivider = /*#__PURE__*/styled$1(Divider__default)(_templateObject4$3 || (_templateObject4$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  grid-column: 3;\n  grid-row: 1 / ", ";\n\n  &.edge-bottom {\n    margin-bottom: ", ";\n  }\n\n  &.edge-top {\n    margin-top: ", ";\n  }\n"])), EnergyGrades.length + 1, function (_ref25) {
  var theme = _ref25.theme;
  return theme.spacing(EnergyGradeIndicatorMargin * -1);
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.spacing(EnergyGradeIndicatorMargin * -1);
});
var Description = /*#__PURE__*/styled$1.div(_templateObject5$1 || (_templateObject5$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  grid-column: ", ";\n  grid-row: ", ";\n  margin-top: ", ";\n  margin-left: ", ";\n"])), function (_ref27) {
  var column = _ref27.column;
  return column;
}, EnergyGrades.length + 1, function (_ref28) {
  var theme = _ref28.theme;
  return theme.spacing(2);
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.spacing(2);
});
var EnergyRating = function EnergyRating(_ref30) {
  var currentGrade = _ref30.currentGrade,
      currentGradeDesc = _ref30.currentGradeDesc,
      desc = _ref30.desc,
      potentialGrade = _ref30.potentialGrade,
      potentialGradeDesc = _ref30.potentialGradeDesc,
      screenReaderCaption = _ref30.screenReaderCaption,
      rest = _objectWithoutPropertiesLoose(_ref30, _excluded$d);

  var srCaptionId = useMemo(function () {
    return nanoid();
  }, []);
  return React__default.createElement("section", {
    "aria-describedby": srCaptionId
  }, React__default.createElement(Typography, {
    id: srCaptionId,
    variant: "srOnly"
  }, screenReaderCaption), React__default.createElement(Wrapper, Object.assign({
    "aria-hidden": true,
    columns: 1 + (currentGrade ? 1 : 0) + (potentialGrade || potentialGradeDesc ? 2 : 0)
  }, rest), EnergyGrades.map(function (level) {
    return React__default.createElement(EnergyGradeBar, {
      key: level,
      level: level
    }, React__default.createElement(Typography, {
      variant: "h4",
      component: "span"
    }, level));
  }), desc && React__default.createElement(Description, {
    column: 1,
    className: "ml-0"
  }, React__default.createElement(Typography, null, desc)), currentGrade && React__default.createElement(EnergyGradeIndicator, {
    level: currentGrade
  }, React__default.createElement(Typography, {
    color: "inherit",
    variant: "h3",
    component: "span"
  }, currentGrade)), currentGradeDesc && React__default.createElement(Description, {
    column: 2
  }, React__default.createElement(Typography, null, currentGradeDesc)), (potentialGrade || potentialGradeDesc) && React__default.createElement(GridDivider, {
    className: classNames({
      'edge-top': currentGrade === EnergyGrade.A || potentialGrade === EnergyGrade.A,
      'edge-bottom': currentGrade === EnergyGrade.G || potentialGrade === EnergyGrade.G
    }),
    orientation: "vertical",
    flexItem: true
  }), potentialGrade && React__default.createElement(EnergyGradeIndicator, {
    className: "potential",
    level: potentialGrade
  }, React__default.createElement(Typography, {
    color: "inherit",
    variant: "h3",
    component: "span"
  }, potentialGrade)), potentialGradeDesc && React__default.createElement(Description, {
    column: 4
  }, potentialGradeDesc)));
};
EnergyRating.displayName = 'EnergyRating';

var reverseHeatingKeys = /*#__PURE__*/Array.from(HeatingGrades.keys()).reverse();
var getReverseHGIndex = function getReverseHGIndex(hg) {
  return reverseHeatingKeys.indexOf(HeatingGrades.indexOf(hg));
};

var _excluded$e = ["energyGrade", "heatingGrade"];

var _templateObject$e;
var roofSize = 12;
var houseWidth = 40;
var houseHeight = 35;
var Wrapper$1 = /*#__PURE__*/styled$1.div(_templateObject$e || (_templateObject$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  --bgColor: ", ";\n\n  align-items: center;\n  background: var(--bgColor);\n  color: ", ";\n  display: flex;\n  height: ", "px;\n  justify-content: center;\n  margin-top: ", "px;\n  position: relative;\n  width: ", "px;\n  overflow-x: clip;\n\n  ", "\n\n  ", "\n\n\n  &::after {\n    content: '';\n    height: 0;\n    position: absolute;\n    top: ", "px;\n    bottom: 100%;\n    width: 0;\n    border-bottom: ", "px solid var(--bgColor);\n    border-left: ", "px solid transparent;\n    border-right: ", "px solid transparent;\n  }\n"])), function (_ref) {
  var theme = _ref.theme,
      heatingGrade = _ref.heatingGrade;
  return heatingGrade ? theme.palette.heatingGrade[heatingGrade] : theme.palette.greys.grey2;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.getContrastText(theme.palette.greys.grey2);
}, houseHeight, roofSize, houseWidth, function (_ref3) {
  var theme = _ref3.theme,
      heatingGrade = _ref3.heatingGrade;
  if (heatingGrade) return "\n  color: " + theme.palette.getContrastText(theme.palette.heatingGrade[heatingGrade]) + ";\n  grid-column: " + (getReverseHGIndex(heatingGrade) + 3) + ";\n  ";
  return undefined;
}, function (_ref4) {
  var energyGrade = _ref4.energyGrade;
  if (energyGrade) return "\n  grid-row: " + (EnergyGrades.indexOf(energyGrade) + 1) + ";\n  ";
  return undefined;
}, (roofSize - 1) * -1, roofSize, houseWidth / 2 + 2, houseWidth / 2 + 2);
var EnergyRatingIndicator = function EnergyRatingIndicator(_ref5) {
  var energyGrade = _ref5.energyGrade,
      heatingGrade = _ref5.heatingGrade,
      rest = _objectWithoutPropertiesLoose(_ref5, _excluded$e);

  return React__default.createElement(Wrapper$1, Object.assign({
    heatingGrade: heatingGrade,
    energyGrade: energyGrade
  }, rest), energyGrade && React__default.createElement(Typography, {
    color: "inherit",
    variant: "h3",
    component: "span"
  }, energyGrade == null ? void 0 : energyGrade.toUpperCase()));
};
EnergyRatingIndicator.displayName = 'EnergyRatingIndicator';

var _excluded$f = ["energyGrade", "heatingGrade", "energyAxisLabel", "heatingAxisLabel", "screenReaderCaption"];

var _templateObject$f, _templateObject2$a, _templateObject3$7, _templateObject4$4, _templateObject5$2, _templateObject6$1, _templateObject7$1;
var Wrapper$2 = /*#__PURE__*/styled$1.div(_templateObject$f || (_templateObject$f = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: grid;\n  grid-template-columns:\n    min-content min-content minmax(30px, 100%) minmax(30px, 100%)\n    minmax(30px, 100%) minmax(30px, 100%) minmax(30px, 100%);\n\n  ", " {\n    grid-template-columns: min-content min-content 60px 60px 60px 60px 60px;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up('sm');
});
var eneryGradeBarHeight$1 = 30; // px

var energyGradeArrowWidth = 8; // px

var EnergyLevelBar = /*#__PURE__*/styled$1.div(_templateObject2$a || (_templateObject2$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  align-items: center;\n  background: ", ";\n  color: ", ";\n  display: flex;\n  grid-column: 2;\n  height: ", "px;\n  margin: ", ";\n  padding: ", ";\n  position: relative;\n  text-transform: uppercase;\n  width: ", "ch;\n\n  ", " {\n    width: ", "ch;\n    margin-right: ", "px;\n  }\n\n  &:after {\n    content: '';\n    height: 0;\n    position: absolute;\n    right: ", "px;\n    top: 0;\n    width: 0;\n    border-top: ", "px solid transparent;\n    border-bottom: ", "px solid transparent;\n    border-left: ", ";\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.greys.grey3;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.getContrastText(theme.palette.greys.grey3);
}, eneryGradeBarHeight$1, function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacing(0.5, '2ch', 0.5, 0);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.spacing(0.25, 0, 0.25, 2);
}, function (_ref6) {
  var grade = _ref6.grade;
  return 3 + EnergyGrades.indexOf(grade) * 0.35;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.up('sm');
}, function (_ref8) {
  var grade = _ref8.grade;
  return 3 + EnergyGrades.indexOf(grade) * 0.6;
}, eneryGradeBarHeight$1 / 2, energyGradeArrowWidth * -1, eneryGradeBarHeight$1 / 2, eneryGradeBarHeight$1 / 2, function (_ref9) {
  var theme = _ref9.theme;
  return energyGradeArrowWidth + "px solid " + theme.palette.greys.grey3;
});
var HeatingGradeIndicator = /*#__PURE__*/styled$1.div(_templateObject3$7 || (_templateObject3$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: ", ";\n  grid-column: ", ";\n  grid-row: ", ";\n  height: 25px;\n  margin-top: ", ";\n"])), function (_ref10) {
  var theme = _ref10.theme,
      heatinggrade = _ref10.heatinggrade;
  return theme.palette.heatingGrade[heatinggrade];
}, function (_ref11) {
  var heatinggrade = _ref11.heatinggrade;
  return getReverseHGIndex(heatinggrade) + 3;
}, EnergyGrades.length + 2, function (_ref12) {
  var theme = _ref12.theme;
  return theme.spacing(2);
});
var houseWidthXs = 30;
var StyledEnergyRatingIndicator = /*#__PURE__*/styled$1(EnergyRatingIndicator)(_templateObject4$4 || (_templateObject4$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  grid-row: ", ";\n  grid-column: ", ";\n  margin: ", ";\n\n  ", " {\n    width: ", "px;\n    height: ", "px;\n\n    &::after {\n      border-left-width: ", "px;\n      border-right-width: ", "px;\n      top: ", "px;\n    }\n  }\n\n  ", " {\n    margin: ", ";\n  }\n"])), function (_ref13) {
  var energyGrade = _ref13.energyGrade;
  return EnergyGrades.indexOf(energyGrade) + 1;
}, function (_ref14) {
  var heatingGrade = _ref14.heatingGrade;
  return getReverseHGIndex(heatingGrade) + 3;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.spacing(1, 'auto', 0);
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.breakpoints.only('xs');
}, houseWidthXs, houseWidthXs, houseWidthXs / 2, houseWidthXs / 2, roofSize * -1, function (_ref17) {
  var theme = _ref17.theme;
  return theme.breakpoints.up('sm');
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.spacing(0.5, 'auto', -0.5);
});
var AxisLabel = /*#__PURE__*/styled$1(function (props) {
  return React__default.createElement(Typography, Object.assign({}, props, {
    variant: "h4",
    component: "span"
  }));
})(_templateObject5$2 || (_templateObject5$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  align-self: center;\n  justify-self: center;\n  text-align: center;\n\n  ", " {\n    font-size: ", ";\n  }\n"])), function (_ref19) {
  var theme = _ref19.theme;
  return theme.breakpoints.up('sm');
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.typography.h3.fontSize;
});
var EnergyAxisLabel = /*#__PURE__*/styled$1(AxisLabel)(_templateObject6$1 || (_templateObject6$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  grid-row: 1 / span ", ";\n  max-height: fit-content;\n  padding-left: ", ";\n  transform: rotate(180deg);\n  writing-mode: vertical-rl;\n\n  ", " {\n    padding-left: ", ";\n  }\n"])), EnergyGrades.length, function (_ref21) {
  var theme = _ref21.theme;
  return theme.spacing(1);
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.breakpoints.up('sm');
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.spacing(4);
});
var HeatingAxisLabel = /*#__PURE__*/styled$1(AxisLabel)(_templateObject7$1 || (_templateObject7$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  grid-column: 3 / span ", ";\n  grid-row: ", ";\n  max-width: fit-content;\n  padding-top: ", ";\n\n  ", " {\n    padding-left: ", ";\n  }\n"])), HeatingGrades.length, EnergyGrades.length + 3, function (_ref24) {
  var theme = _ref24.theme;
  return theme.spacing(2);
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.breakpoints.up('sm');
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.spacing(3);
});
var EnergyRating2D = function EnergyRating2D(_ref27) {
  var energyGrade = _ref27.energyGrade,
      heatingGrade = _ref27.heatingGrade,
      energyAxisLabel = _ref27.energyAxisLabel,
      heatingAxisLabel = _ref27.heatingAxisLabel,
      screenReaderCaption = _ref27.screenReaderCaption,
      rest = _objectWithoutPropertiesLoose(_ref27, _excluded$f);

  var srCaptionId = useMemo(function () {
    return nanoid();
  }, []);
  return React__default.createElement("section", {
    "aria-describedby": srCaptionId
  }, React__default.createElement(Typography, {
    id: srCaptionId,
    variant: "srOnly"
  }, screenReaderCaption), React__default.createElement(Wrapper$2, Object.assign({
    "aria-hidden": true
  }, rest), React__default.createElement(EnergyAxisLabel, null, energyAxisLabel), EnergyGrades.map(function (level) {
    return React__default.createElement(EnergyLevelBar, {
      key: level,
      grade: level
    }, React__default.createElement(Typography, {
      variant: "h4",
      component: "span"
    }, level));
  }), energyGrade && heatingGrade && React__default.createElement(StyledEnergyRatingIndicator, {
    heatingGrade: heatingGrade,
    energyGrade: energyGrade
  }), HeatingGrades.map(function (hg) {
    return React__default.createElement(HeatingGradeIndicator, {
      key: hg,
      heatinggrade: hg
    });
  }), React__default.createElement(HeatingAxisLabel, null, heatingAxisLabel)));
};
EnergyRating2D.displayName = 'EnergyRating2D';

var _g$2, _defs$6;

function _extends$l() { _extends$l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

function SvgLineArtHouse(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$l({
    width: 72,
    height: 35,
    viewBox: "0 0 72 35",
    xmlns: "http://www.w3.org/2000/svg",
    className: "line-art-house_svg__MuiSvgIcon-root-fgfBqb line-art-house_svg__eCBEOm line-art-house_svg__MuiSvgIcon-root line-art-house_svg__MuiSvgIcon-fontSizeMedium line-art-house_svg__EfcLineArt line-art-house_svg__makeStyles-root-80",
    "aria-hidden": "true",
    "aria-label": "House",
    ref: svgRef
  }, props), _g$2 || (_g$2 = /*#__PURE__*/createElement("g", {
    clipPath: "url(#line-art-house_svg__line-art-house_svg__clip0)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }, /*#__PURE__*/createElement("path", {
    d: "M33.957 34.462h37.511m-37.511 0H.532M49.79 15.313v19.135H23.253V15.312h-3.547a.753.753 0 01-.712-.512.776.776 0 01.237-.85L35.298.954a1.874 1.874 0 012.362 0L53.727 13.95a.768.768 0 01.238.847.753.753 0 01-.706.515h-3.47z"
  }), /*#__PURE__*/createElement("path", {
    d: "M40.575 19.142h5.448v15.284h-7.576V21.294c0-.57.224-1.118.624-1.521.399-.404.94-.63 1.504-.63v0zm-11.363 0h5.448v7.66h-7.576v-5.508c0-.57.224-1.118.623-1.521.399-.404.94-.63 1.505-.63v0zM36.404 7.66h2.42v4.597h-4.548V9.811c0-.57.225-1.117.624-1.521.399-.404.94-.63 1.504-.63v0z"
  }))), _defs$6 || (_defs$6 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "line-art-house_svg__line-art-house_svg__clip0"
  }, /*#__PURE__*/createElement("path", {
    d: "M0 0h72v35H0z"
  })))));
}

var ForwardRef$k = /*#__PURE__*/forwardRef(SvgLineArtHouse);
var MemoForwardRef$k = /*#__PURE__*/memo(ForwardRef$k);

var LineArtMap = {
  house: {
    icon: MemoForwardRef$k,
    viewBox: '0 0 72 35'
  }
};
var LineArtOptions = /*#__PURE__*/Object.keys(LineArtMap);

var _excluded$g = ["aria-label", "className", "name"];
var useStyles$3 = /*#__PURE__*/makeStyles(function () {
  return createStyles({
    root: {
      pointerEvents: 'none',
      fontSize: '5rem',
      height: 'auto',
      fill: 'none',
      stroke: 'currentColor'
    }
  });
});
var LineArt = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var ariaLabel = _ref['aria-label'],
      className = _ref.className,
      name = _ref.name,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$g);

  var classes = useStyles$3();
  var title = capitalize(name).replace('_', ' ');
  var Component = LineArtMap[name].icon;
  return React__default.createElement(SvgIcon, Object.assign({}, rest, {
    component: Component
  }, {
    "aria-label": ariaLabel || title,
    className: classNames('EfcLineArt', classes.root, className),
    ref: ref,
    viewBox: LineArtMap[name].viewBox
  }));
});
LineArt.displayName = 'LineArt';

var _excluded$h = ["button", "children", "divider", "leftIcon", "rightIcon", "subheading"];

var _templateObject$g, _templateObject2$b;
var StyledListItemText = /*#__PURE__*/styled$1(ListItemText)(_templateObject$g || (_templateObject$g = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  margin: 0;\n  padding-bottom: ", ";\n  padding-top: ", ";\n\n  .primary {\n    font-weight: 600;\n  }\n\n  .secondary {\n    color: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing();
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing();
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.text.primary;
});
var ButtonListItem = /*#__PURE__*/styled$1(MuiListItem)(_templateObject2$b || (_templateObject2$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n\n  &:active {\n    background: ", ";\n  }\n"])), focusVisibleInsetBoxShadow, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.action.focus;
});
var ListItem = /*#__PURE__*/forwardRef(function (_ref5, ref) {
  var button = _ref5.button,
      children = _ref5.children,
      divider = _ref5.divider,
      leftIcon = _ref5.leftIcon,
      rightIcon = _ref5.rightIcon,
      subheading = _ref5.subheading,
      rest = _objectWithoutPropertiesLoose(_ref5, _excluded$h);

  var Content = function Content() {
    return React__default.createElement(Fragment, null, leftIcon && (typeof leftIcon === 'string' ? React__default.createElement(Icon, {
      name: leftIcon
    }) : leftIcon), React__default.createElement(StyledListItemText, {
      classes: {
        primary: 'primary',
        secondary: 'secondary'
      },
      primary: children,
      secondary: subheading
    }), rightIcon && (typeof rightIcon === 'string' ? React__default.createElement(Icon, {
      name: rightIcon
    }) : rightIcon));
  };

  return React__default.createElement(Fragment, null, button ? React__default.createElement(ButtonListItem, Object.assign({}, rest, {
    button: true,
    classes: {
      selected: 'selected'
    },
    ref: ref
  }), React__default.createElement(Content, null)) : React__default.createElement(MuiListItem, Object.assign({}, rest, {
    classes: {
      selected: 'selected'
    },
    ref: ref
  }), React__default.createElement(Content, null)), divider && React__default.createElement(Divider__default, {
    className: "m-0"
  }));
});
ListItem.displayName = 'ListItem';

/**
 * Wrapper component for `ListItems`
 */

var List = function List(props) {
  return React__default.createElement(MuiList, Object.assign({
    disablePadding: true
  }, props));
};
List.Item = ListItem;
List.displayName = 'List';

var _path$i;

function _extends$m() { _extends$m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

function SvgAtrium(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$m({
    width: 85,
    height: 77,
    viewBox: "0 0 85 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$i || (_path$i = /*#__PURE__*/createElement("path", {
    d: "M57.5 25v-1.5h-30v30h30V25zm-56 50.5v-74h82v74h-82z",
    fill: "#DADADA",
    stroke: "#021946",
    strokeWidth: 3
  })));
}

var ForwardRef$l = /*#__PURE__*/forwardRef(SvgAtrium);
var MemoForwardRef$l = /*#__PURE__*/memo(ForwardRef$l);

var _path$j;

function _extends$n() { _extends$n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

function SvgLShape(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$n({
    width: 99,
    height: 69,
    viewBox: "0 0 99 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$j || (_path$j = /*#__PURE__*/createElement("path", {
    d: "M1.5 1.5h95.796v33.068H34.569V67.5H1.5v-66z",
    fill: "#DADADA",
    stroke: "#021946",
    strokeWidth: 3
  })));
}

var ForwardRef$m = /*#__PURE__*/forwardRef(SvgLShape);
var MemoForwardRef$m = /*#__PURE__*/memo(ForwardRef$m);

var _path$k;

function _extends$o() { _extends$o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

function SvgLShapeMirrored(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$o({
    width: 99,
    height: 69,
    viewBox: "0 0 99 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$k || (_path$k = /*#__PURE__*/createElement("path", {
    d: "M64.227 36.068v-1.5H1.5V1.5h95.795v66H64.227V36.068z",
    fill: "#DADADA",
    stroke: "#021946",
    strokeWidth: 3
  })));
}

var ForwardRef$n = /*#__PURE__*/forwardRef(SvgLShapeMirrored);
var MemoForwardRef$n = /*#__PURE__*/memo(ForwardRef$n);

var _path$l;

function _extends$p() { _extends$p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }

function SvgRectangular(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$p({
    width: 132,
    height: 69,
    viewBox: "0 0 132 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$l || (_path$l = /*#__PURE__*/createElement("path", {
    d: "M1.5 1.5h128.821v66H1.5v-66z",
    fill: "#DADADA",
    stroke: "#021946",
    strokeWidth: 3
  })));
}

var ForwardRef$o = /*#__PURE__*/forwardRef(SvgRectangular);
var MemoForwardRef$o = /*#__PURE__*/memo(ForwardRef$o);

var _path$m;

function _extends$q() { _extends$q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

function SvgTShape(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$q({
    width: 99,
    height: 69,
    viewBox: "0 0 99 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$m || (_path$m = /*#__PURE__*/createElement("path", {
    d: "M31.364 34.568H1.5V1.5h95.796v33.068H65.931V67.5H32.864V34.568h-1.5z",
    fill: "#DADADA",
    stroke: "#021946",
    strokeWidth: 3
  })));
}

var ForwardRef$p = /*#__PURE__*/forwardRef(SvgTShape);
var MemoForwardRef$p = /*#__PURE__*/memo(ForwardRef$p);

var _path$n;

function _extends$r() { _extends$r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

function SvgUShape(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$r({
    width: 100,
    height: 70,
    viewBox: "0 0 100 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$n || (_path$n = /*#__PURE__*/createElement("path", {
    d: "M1.503 67.568V67.5H1.5v-66h33.068v33H64.5v-33h33.068v66h-.27v.068H1.504z",
    fill: "#DADADA",
    stroke: "#021946",
    strokeWidth: 3
  })));
}

var ForwardRef$q = /*#__PURE__*/forwardRef(SvgUShape);
var MemoForwardRef$q = /*#__PURE__*/memo(ForwardRef$q);

var _path$o;

function _extends$s() { _extends$s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

function SvgXShape(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$s({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$o || (_path$o = /*#__PURE__*/createElement("path", {
    d: "M26.556 51.945v-1.5H1.5V26.556h25.056V1.5h23.89v25.056H75.5v23.89H50.445V75.5H26.556V51.945z",
    fill: "#DADADA",
    stroke: "#021946",
    strokeWidth: 3
  })));
}

var ForwardRef$r = /*#__PURE__*/forwardRef(SvgXShape);
var MemoForwardRef$r = /*#__PURE__*/memo(ForwardRef$r);

var _path$p;

function _extends$t() { _extends$t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

function SvgYShape(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$t({
    width: 99,
    height: 77,
    viewBox: "0 0 99 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$p || (_path$p = /*#__PURE__*/createElement("path", {
    d: "M31.429 50.661H1.5V1.5h31.572v24.838H65.927V1.502H97.5v49.161H64.5V75.5H32.93V50.661h-1.5z",
    fill: "#DADADA",
    stroke: "#021946",
    strokeWidth: 3
  })));
}

var ForwardRef$s = /*#__PURE__*/forwardRef(SvgYShape);
var MemoForwardRef$s = /*#__PURE__*/memo(ForwardRef$s);

var _path$q;

function _extends$u() { _extends$u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

function SvgZShape(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$u({
    width: 86,
    height: 67,
    viewBox: "0 0 86 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$q || (_path$q = /*#__PURE__*/createElement("path", {
    d: "M31.754 45.195h-1.5v20.304H1.5V21.804h.002v-2.032h54.244V1.5H84.5v43.696l-52.746-.001z",
    fill: "#DADADA",
    stroke: "#021946",
    strokeWidth: 3
  })));
}

var ForwardRef$t = /*#__PURE__*/forwardRef(SvgZShape);
var MemoForwardRef$t = /*#__PURE__*/memo(ForwardRef$t);

var _path$r;

function _extends$v() { _extends$v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

function SvgZShapeMirrored(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$v({
    width: 86,
    height: 70,
    viewBox: "0 0 86 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$r || (_path$r = /*#__PURE__*/createElement("path", {
    d: "M31.754 22.41H84.5v45.091H55.746V48.684H1.502V46.59H1.5V1.5h28.754v20.91h1.5z",
    fill: "#DADADA",
    stroke: "#021946",
    strokeWidth: 3
  })));
}

var ForwardRef$u = /*#__PURE__*/forwardRef(SvgZShapeMirrored);
var MemoForwardRef$u = /*#__PURE__*/memo(ForwardRef$u);

var _path$s;

function _extends$w() { _extends$w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

function SvgGulvEnsartet(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$w({
    width: 132,
    height: 69,
    viewBox: "0 0 132 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$s || (_path$s = /*#__PURE__*/createElement("path", {
    fill: "#DADADA",
    stroke: "#021946",
    strokeWidth: 3,
    d: "M1.5 1.5h128.821v66H1.5z"
  })));
}

var ForwardRef$v = /*#__PURE__*/forwardRef(SvgGulvEnsartet);
var MemoForwardRef$v = /*#__PURE__*/memo(ForwardRef$v);

var _path$t;

function _extends$x() { _extends$x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

function SvgGulvEnsartetInverted(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$x({
    width: 132,
    height: 69,
    viewBox: "0 0 132 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$t || (_path$t = /*#__PURE__*/createElement("path", {
    fill: "#021946",
    stroke: "#fff",
    strokeWidth: 3,
    d: "M1.5 1.5h128.821v66H1.5z"
  })));
}

var ForwardRef$w = /*#__PURE__*/forwardRef(SvgGulvEnsartetInverted);
var MemoForwardRef$w = /*#__PURE__*/memo(ForwardRef$w);

var _path$u;

function _extends$y() { _extends$y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

function SvgGulvSone(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$y({
    width: 132,
    height: 69,
    viewBox: "0 0 132 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$u || (_path$u = /*#__PURE__*/createElement("path", {
    d: "M41 1.5V67h3V1.5h40V35h17v32h3V35h25v-3H87V1.5h43.321v66H1.5v-66H41z",
    fill: "#DADADA",
    stroke: "#021946",
    strokeWidth: 3
  })));
}

var ForwardRef$x = /*#__PURE__*/forwardRef(SvgGulvSone);
var MemoForwardRef$x = /*#__PURE__*/memo(ForwardRef$x);

var _path$v;

function _extends$z() { _extends$z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

function SvgGulvSoneInverted(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$z({
    width: 132,
    height: 69,
    viewBox: "0 0 132 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$v || (_path$v = /*#__PURE__*/createElement("path", {
    d: "M41 1.5V67h3V1.5h40V35h17v32h3V35h25v-3H87V1.5h43.321v66H1.5v-66H41z",
    fill: "#021946",
    stroke: "#fff",
    strokeWidth: 3
  })));
}

var ForwardRef$y = /*#__PURE__*/forwardRef(SvgGulvSoneInverted);
var MemoForwardRef$y = /*#__PURE__*/memo(ForwardRef$y);

var _path$w;

function _extends$A() { _extends$A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

function SvgVeggEnsartet(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$A({
    width: 132,
    height: 69,
    viewBox: "0 0 132 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$w || (_path$w = /*#__PURE__*/createElement("path", {
    fill: "#DADADA",
    stroke: "#021946",
    strokeWidth: 3,
    d: "M1.5 1.5h128.821v66H1.5z"
  })));
}

var ForwardRef$z = /*#__PURE__*/forwardRef(SvgVeggEnsartet);
var MemoForwardRef$z = /*#__PURE__*/memo(ForwardRef$z);

var _path$x;

function _extends$B() { _extends$B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

function SvgVeggEnsartetInverted(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$B({
    width: 132,
    height: 69,
    viewBox: "0 0 132 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$x || (_path$x = /*#__PURE__*/createElement("path", {
    fill: "#021946",
    stroke: "#fff",
    strokeWidth: 3,
    d: "M1.5 1.5h128.821v66H1.5z"
  })));
}

var ForwardRef$A = /*#__PURE__*/forwardRef(SvgVeggEnsartetInverted);
var MemoForwardRef$A = /*#__PURE__*/memo(ForwardRef$A);

var _path$y;

function _extends$C() { _extends$C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }

function SvgVeggSoner(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$C({
    width: 132,
    height: 69,
    viewBox: "0 0 132 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$y || (_path$y = /*#__PURE__*/createElement("path", {
    d: "M41 1.5V67h3V1.5h86.321v66H1.5v-66H41zM101 3v64h3V3h-3z",
    fill: "#DADADA",
    stroke: "#021946",
    strokeWidth: 3
  })));
}

var ForwardRef$B = /*#__PURE__*/forwardRef(SvgVeggSoner);
var MemoForwardRef$B = /*#__PURE__*/memo(ForwardRef$B);

var _path$z;

function _extends$D() { _extends$D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }

function SvgVeggSonerInverted(props, svgRef) {
  return /*#__PURE__*/createElement("svg", _extends$D({
    width: 132,
    height: 69,
    viewBox: "0 0 132 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path$z || (_path$z = /*#__PURE__*/createElement("path", {
    d: "M41 1.5V67h3V1.5h85.821a.5.5 0 01.5.5v65a.5.5 0 01-.5.5H2a.5.5 0 01-.5-.5V2a.5.5 0 01.5-.5h39zM101 3v64h3V3h-3z",
    fill: "#021946",
    stroke: "#fff",
    strokeWidth: 3
  })));
}

var ForwardRef$C = /*#__PURE__*/forwardRef(SvgVeggSonerInverted);
var MemoForwardRef$C = /*#__PURE__*/memo(ForwardRef$C);

var ShapeMap = {
  atrium: MemoForwardRef$l,
  floor_multizoned: MemoForwardRef$x,
  floor: MemoForwardRef$v,
  l_shape_mirrored: MemoForwardRef$n,
  l_shape: MemoForwardRef$m,
  rectangle: MemoForwardRef$o,
  t_shape: MemoForwardRef$p,
  u_shape: MemoForwardRef$q,
  wall_multizoned: MemoForwardRef$B,
  wall: MemoForwardRef$z,
  x_shape: MemoForwardRef$r,
  y_shape: MemoForwardRef$s,
  z_shape_mirrored: MemoForwardRef$u,
  z_shape: MemoForwardRef$t
};
var ShapeOptions = /*#__PURE__*/Object.keys(ShapeMap);
var InvertedShapeMap = {
  floor_multizoned: MemoForwardRef$y,
  floor: MemoForwardRef$w,
  wall_multizoned: MemoForwardRef$C,
  wall: MemoForwardRef$A
};

var _excluded$i = ["aria-label", "className", "inverted", "name"];

var useStyles$4 = function useStyles(color) {
  return makeStyles(function (theme) {
    return createStyles({
      root: {
        pointerEvents: 'none',
        fontSize: '4rem',
        width: '100%',
        height: '100%',
        '& > path:first-child': {
          fill: theme.palette.action.selected,
          stroke: 'currentColor'
        },
        '& > path:not(:last-child)': {
          fill: theme.palette.action.selected
        },
        '& > path:last-child:not(:first-child)': {
          fill: 'currentColor'
        },
        '&.inverted': {
          '& > path:first-child': {
            fill: 'currentColor',
            stroke: 'transparent'
          },
          '& > path:not(:last-child)': {
            fill: 'currentColor'
          },
          '& > path:last-child:not(:first-child)': {
            fill: 'transparent'
          },
          '&.multi_zoned_wall > path:last-child': {
            stroke: theme.palette.getContrastText(color || theme.palette.text.primary)
          },
          '&.multi_zoned_floor > path:last-child': {
            stroke: theme.palette.getContrastText(color || theme.palette.text.primary)
          }
        }
      }
    });
  });
};

var Shape = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _window$getComputedSt, _classNames;

  var ariaLabel = _ref['aria-label'],
      className = _ref.className,
      inverted = _ref.inverted,
      name = _ref.name,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$i);

  var id = useMemo(function () {
    return nanoid();
  }, []);
  var el = document.getElementById(id);
  var color = el ? (_window$getComputedSt = window.getComputedStyle(el)) == null ? void 0 : _window$getComputedSt.color : undefined;
  var classes = useStyles$4(color)();
  var title = capitalize(name).replace('_', ' ');
  var Component = ShapeMap[name];
  var hasInvertedShape = false;

  if (inverted) {
    hasInvertedShape = !!InvertedShapeMap[name];
    if (hasInvertedShape) Component = InvertedShapeMap[name];
  }

  return React__default.createElement(Box$1, {
    alignItems: "center",
    display: "flex",
    height: "3rem",
    id: id,
    justifyContent: "center",
    width: "4rem"
  }, React__default.createElement(Component, Object.assign({}, rest, {
    "aria-label": ariaLabel || title,
    className: classNames(name, 'EfcShape', (_classNames = {}, _classNames[classes.root] = inverted && !hasInvertedShape, _classNames), {
      inverted: inverted && !hasInvertedShape
    }, className),
    ref: ref
  })));
});
Shape.displayName = 'Shape';

var descendingComparator = function descendingComparator(a, b, orderBy) {
  return b[orderBy] < a[orderBy] ? -1 : b[orderBy] > a[orderBy] ? 1 : 0;
};

function getComparator(order, orderBy) {
  return order === 'desc' ? function (a, b) {
    return descendingComparator(a, b, orderBy);
  } : function (a, b) {
    return -descendingComparator(a, b, orderBy);
  };
} // This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly

var stableSort = function stableSort(array, comparator) {
  var stabilizedThis = array.map(function (el, index) {
    return [el, index];
  });
  stabilizedThis.sort(function (a, b) {
    var order = comparator(a[0], b[0]);

    if (order !== 0) {
      return order;
    }

    return a[1] - b[1];
  });
  return stabilizedThis.map(function (el) {
    return el[0];
  });
};
var RowsPerPage = [10, 25, 100];

var _excluded$j = ["checked"];

var _templateObject$h;
var StyledCheckbox = /*#__PURE__*/styled$1(MuiCheckbox)(_templateObject$h || (_templateObject$h = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  &:hover,\n  &.focus {\n    border-radius: 8px;\n    outline-offset: -4px;\n    outline: 2px solid rgba(0, 0, 0, 0.87);\n  }\n"])));
var TableCheckbox = function TableCheckbox(_ref) {
  var checked = _ref.checked,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$j);

  var _useState = useState(false),
      focus = _useState[0],
      setFocus = _useState[1];

  return React__default.createElement(StyledCheckbox, Object.assign({}, rest, {
    checked: checked,
    checkedIcon: React__default.createElement(Icon, {
      name: "check_checked"
    }),
    className: classNames({
      focus: focus
    }),
    icon: React__default.createElement(Icon, {
      name: "check_unchecked"
    }),
    indeterminateIcon: React__default.createElement(Icon, {
      name: "check_indeterminate"
    }),
    onBlur: function onBlur() {
      return setFocus(false);
    },
    onFocusVisible: function onFocusVisible() {
      return !focus && setFocus(true);
    }
  }));
};

var _templateObject$i;
var StyledTableHead = /*#__PURE__*/styled$1(MuiTableHead)(_templateObject$i || (_templateObject$i = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  &.hidden {\n    position: absolute;\n    left: -999999em;\n  }\n"])));
var TableHead = function TableHead(_ref) {
  var headCells = _ref.headCells,
      hideHeader = _ref.hideHeader,
      numSelected = _ref.numSelected,
      onRequestSort = _ref.onRequestSort,
      onSelectAllClick = _ref.onSelectAllClick,
      order = _ref.order,
      orderBy = _ref.orderBy,
      rowCount = _ref.rowCount,
      selectable = _ref.selectable;

  var createSortHandler = function createSortHandler(property) {
    return function (event) {
      return onRequestSort(event, property);
    };
  };

  return React__default.createElement(StyledTableHead, {
    className: classNames({
      hidden: hideHeader
    })
  }, React__default.createElement(TableRow, null, selectable && React__default.createElement(TableCell, {
    padding: "checkbox",
    className: "pr-0"
  }, React__default.createElement(TableCheckbox, {
    checked: rowCount > 0 && numSelected === rowCount,
    indeterminate: numSelected > 0 && numSelected < rowCount,
    onChange: onSelectAllClick,
    inputProps: {
      'aria-label': 'select all'
    }
  })), headCells.map(function (_ref2) {
    var id = _ref2.id,
        label = _ref2.label,
        align = _ref2.align,
        disableSort = _ref2.disableSort,
        numeric = _ref2.numeric;
    return disableSort ? React__default.createElement(TableCell, {
      key: String(id),
      align: align || numeric ? 'right' : 'left'
    }, label) : React__default.createElement(TableCell, {
      key: String(id),
      align: align || numeric ? 'right' : 'left',
      sortDirection: orderBy === id ? order : false
    }, React__default.createElement(TableSortLabel, {
      className: "fvbsr",
      active: orderBy === id,
      direction: orderBy === id ? order : 'asc',
      onClick: createSortHandler(id)
    }, label, orderBy === id ? React__default.createElement(Typography, {
      variant: "srOnly"
    }, order === 'desc' ? 'sorted descending' : 'sorted ascending') : null));
  })));
};

function TableToolbar(_ref) {
  var actions = _ref.actions,
      labelSelectedItems = _ref.labelSelectedItems,
      numSelected = _ref.numSelected,
      selectedItemsActions = _ref.selectedItemsActions,
      tableTitle = _ref.tableTitle,
      titleId = _ref.titleId;
  return React__default.createElement(Toolbar, {
    sx: _extends({
      pl: {
        sm: 2
      },
      pr: {
        xs: 1,
        sm: 1
      }
    }, numSelected > 0 && {
      bgcolor: function bgcolor(theme) {
        return alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity);
      }
    })
  }, numSelected > 0 ? React__default.createElement(Typography, {
    color: "inherit",
    variant: "subtitle1",
    component: "div"
  }, labelSelectedItems ? labelSelectedItems(numSelected) : numSelected + " selected") : tableTitle ? React__default.createElement(Typography, {
    variant: "h6",
    id: titleId,
    component: "div"
  }, tableTitle) : null, React__default.createElement(Box$1, {
    ml: "auto"
  }, numSelected > 0 ? selectedItemsActions : actions));
}

var _excluded$k = ["actions", "alternating", "dense", "disablePagination", "hideHeader", "headCells", "hideToolbar", "initOrder", "initOrderBy", "initPage", "labelDisplayedRows", "labelRowsPerPage", "labelSelectedItems", "outlined", "rows", "rowsPerPage", "selectedIds", "selectedItemsActions", "setSelectedIds", "TableProps", "tableTitle", "titleBackButton", "titleNextButton"];

var _templateObject$j, _templateObject2$c;
var StyledTableRow = /*#__PURE__*/styled$1(TableRow)(_templateObject$j || (_templateObject$j = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  &.alternating:nth-of-type(odd) {\n    background: ", ";\n\n    &:hover {\n      background: ", ";\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.action.disabledBackground;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.action.focus;
});
var StyledTablePagination = /*#__PURE__*/styled$1(TablePagination)(_templateObject2$c || (_templateObject2$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  .icon-button {\n    ", "\n  }\n"])), IconButtonCSS);
function Table(_ref3) {
  var actions = _ref3.actions,
      alternating = _ref3.alternating,
      dense = _ref3.dense,
      disablePagination = _ref3.disablePagination,
      hideHeader = _ref3.hideHeader,
      headCells = _ref3.headCells,
      hideToolbar = _ref3.hideToolbar,
      _ref3$initOrder = _ref3.initOrder,
      initOrder = _ref3$initOrder === void 0 ? 'desc' : _ref3$initOrder,
      initOrderBy = _ref3.initOrderBy,
      _ref3$initPage = _ref3.initPage,
      initPage = _ref3$initPage === void 0 ? 0 : _ref3$initPage,
      labelDisplayedRows = _ref3.labelDisplayedRows,
      labelRowsPerPage = _ref3.labelRowsPerPage,
      labelSelectedItems = _ref3.labelSelectedItems,
      rows = _ref3.rows,
      _ref3$rowsPerPage = _ref3.rowsPerPage,
      initRowsPerPage = _ref3$rowsPerPage === void 0 ? 10 : _ref3$rowsPerPage,
      selectedIds = _ref3.selectedIds,
      selectedItemsActions = _ref3.selectedItemsActions,
      setSelectedIds = _ref3.setSelectedIds,
      tableTitle = _ref3.tableTitle,
      titleBackButton = _ref3.titleBackButton,
      titleNextButton = _ref3.titleNextButton,
      rest = _objectWithoutPropertiesLoose(_ref3, _excluded$k);

  var _useState = useState(initOrder),
      order = _useState[0],
      setOrder = _useState[1];

  var _useState2 = useState(initOrderBy),
      orderBy = _useState2[0],
      setOrderBy = _useState2[1];

  var _useState3 = useState(initPage),
      page = _useState3[0],
      setPage = _useState3[1];

  var _useState4 = useState(initRowsPerPage),
      rowsPerPage = _useState4[0],
      setRowsPerPage = _useState4[1];

  var titleId = useMemo(function () {
    return nanoid();
  }, []);
  var selectable = !!(selectedIds && setSelectedIds);
  if (!!selectedIds && !setSelectedIds) console.error('Selected table items were provided, but no selection handler. Please provide both or none.');
  if (!selectedIds && !!setSelectedIds) console.error('Selection handler was provided, but no list of selected table items. Please provide both or none.');

  var handleRequestSort = function handleRequestSort(_, property) {
    if (orderBy !== property) {
      setOrder('desc');
      setOrderBy(property);
    } else if (order === 'desc') setOrder('asc');else setOrderBy(undefined);
  };

  var handleSelectAllClick = function handleSelectAllClick(event) {
    if (setSelectedIds) {
      if (event.target.checked) {
        var newSelecteds = rows == null ? void 0 : rows.map(function (n) {
          return n.id;
        });
        setSelectedIds(newSelecteds);
      } else setSelectedIds([]);
    }
  };

  var handleSelect = function handleSelect(_, id) {
    if (selectedIds && setSelectedIds) {
      var selectedIndex = selectedIds.indexOf(id);
      var newSelectedIds = [];
      if (selectedIndex === -1) newSelectedIds = newSelectedIds.concat(selectedIds, id);else if (selectedIndex === 0) newSelectedIds = newSelectedIds.concat(selectedIds.slice(1));else if (selectedIndex === selectedIds.length - 1) newSelectedIds = newSelectedIds.concat(selectedIds.slice(0, -1));else if (selectedIndex > 0) {
        newSelectedIds = newSelectedIds.concat(selectedIds.slice(0, selectedIndex), selectedIds.slice(selectedIndex + 1));
      }
      setSelectedIds(newSelectedIds);
    }
  };

  var handleChangePage = function handleChangePage(_, newPage) {
    return setPage(newPage);
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  var isSelected = function isSelected(id) {
    return selectable && (selectedIds == null ? void 0 : selectedIds.indexOf(id)) !== -1;
  }; // Avoid a layout jump when reaching the last page with empty rows.


  var emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;
  var sortedRows = orderBy ? rows.length > 0 && stableSort(rows, getComparator(order, orderBy)) || [] : rows;
  var paginatedRows = disablePagination ? sortedRows : sortedRows && sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) || [];
  return React__default.createElement(Paper, Object.assign({
    sx: {
      width: '100%'
    }
  }, rest), (tableTitle || selectable || actions || selectedItemsActions) && !hideToolbar && React__default.createElement(TableToolbar, {
    actions: actions,
    labelSelectedItems: labelSelectedItems,
    numSelected: (selectedIds == null ? void 0 : selectedIds.length) || 0,
    selectedItemsActions: selectedItemsActions,
    tableTitle: tableTitle,
    titleId: titleId
  }), hideToolbar && tableTitle && React__default.createElement(Typography, {
    variant: "srOnly",
    id: titleId
  }, tableTitle), React__default.createElement(TableContainer, null, React__default.createElement(MuiTable, {
    "aria-labelledby": titleId,
    size: dense ? 'small' : 'medium'
  }, React__default.createElement(TableHead, {
    headCells: headCells,
    hideHeader: hideHeader,
    numSelected: (selectedIds == null ? void 0 : selectedIds.length) || 0,
    onRequestSort: handleRequestSort,
    onSelectAllClick: handleSelectAllClick,
    order: order,
    orderBy: orderBy,
    rowCount: rows.length,
    selectable: selectable
  }), React__default.createElement(TableBody, null, paginatedRows.map(function (row) {
    var _TableCellPropMap$mai, _TableCellPropMap$mai2;

    var TableCellPropMap = row.TableCellPropMap,
        TableRowProps = row.TableRowProps,
        _row$TableRowProps = row.TableRowProps;
    _row$TableRowProps = _row$TableRowProps === void 0 ? {} : _row$TableRowProps;
    var className = _row$TableRowProps.className;
    var isItemSelected = isSelected(row.id);
    var main = headCells.find(function (isMainProperty) {
      return isMainProperty;
    });
    var labelId = main ? (_TableCellPropMap$mai = TableCellPropMap == null ? void 0 : (_TableCellPropMap$mai2 = TableCellPropMap[main.id]) == null ? void 0 : _TableCellPropMap$mai2.id) != null ? _TableCellPropMap$mai : '' : '';
    labelId = labelId || "table-checkbox-label-" + nanoid();
    return React__default.createElement(StyledTableRow, Object.assign({}, TableRowProps, {
      className: classNames(className, {
        alternating: alternating
      }),
      hover: true,
      key: row.id
    }, selectable ? {
      'aria-checked': isItemSelected,
      onClick: function onClick(e) {
        return handleSelect(e, row.id);
      },
      role: 'checkbox',
      selected: isItemSelected,
      tabIndex: -1,
      sx: {
        cursor: 'pointer'
      }
    } : {}), selectable && React__default.createElement(TableCell, {
      padding: "checkbox"
    }, React__default.createElement(TableCheckbox, {
      checked: isItemSelected,
      inputProps: {
        'aria-labelledby': labelId
      }
    })), headCells.map(function (_ref4) {
      var align = _ref4.align,
          id = _ref4.id,
          numeric = _ref4.numeric;
      return React__default.createElement(TableCell, Object.assign({}, TableCellPropMap == null ? void 0 : TableCellPropMap[id], {
        align: align || numeric ? 'right' : 'left',
        key: String(id)
      }), row[id]);
    }));
  }), emptyRows > 0 && React__default.createElement(TableRow, {
    style: {
      height: (dense ? 30 : 50) * emptyRows
    }
  }, React__default.createElement(TableCell, {
    colSpan: headCells.length + (selectable ? 1 : 0)
  }))))), !disablePagination && React__default.createElement(StyledTablePagination, {
    backIconButtonProps: {
      className: 'mr-2 icon-button',
      size: 'small',
      title: titleBackButton
    },
    component: "div",
    count: rows.length,
    labelDisplayedRows: labelDisplayedRows,
    labelRowsPerPage: labelRowsPerPage,
    nextIconButtonProps: {
      className: 'mr-2 icon-button',
      size: 'small',
      title: titleNextButton
    },
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage,
    page: page,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [].concat(RowsPerPage)
  }));
}

var GridSpacingOptions = [undefined, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var Grid = /*#__PURE__*/forwardRef(function (props, ref) {
  return React__default.createElement(MuiGrid, Object.assign({}, props, {
    ref: ref
  }));
});
Grid.displayName = 'Grid';

var UserBox = function UserBox(_ref) {
  var action = _ref.action,
      subheading = _ref.subheading,
      title = _ref.title;
  return React__default.createElement(Paper, null, React__default.createElement(Box$1, {
    padding: 3
  }, React__default.createElement(Grid, {
    container: true,
    spacing: 4
  }, React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: true,
    className: "d-flex f-column jc-center"
  }, React__default.createElement(Typography, {
    variant: "h4",
    component: "span"
  }, title), subheading && React__default.createElement(Typography, null, subheading)), action && React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: "auto"
  }, action))));
};

var _excluded$l = ["children", "className"];
/**
 * Implements [DialogContent](https://mui.com/api/dialog-content/) from **Material-UI**.
 */

var DialogContent = function DialogContent(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$l);

  return React__default.createElement(MuiDialogContent, Object.assign({
    className: classNames('dialog-content', 'pb-4', 'pt-0', 'o-visible', className)
  }, rest), typeof children === 'string' ? React__default.createElement(Typography, null, children) : children);
};

var _templateObject$k;
var StyledDialogActions = /*#__PURE__*/styled$1.div(_templateObject$k || (_templateObject$k = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  align-items: baseline;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n\n  & > * {\n    margin: ", " !important;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(3);
});
/**
 * Wrapper component for `Dialog` actions
 */

var DialogActions = function DialogActions(props) {
  return React__default.createElement(StyledDialogActions, Object.assign({}, props));
};

var _excluded$m = ["id"];
var DialogTitleId = 'dialog-title';
/**
 * Implements [DialogTitle](https://mui.com/api/dialog-title/) from **Material-UI**.
 */

var DialogTitle = function DialogTitle(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? DialogTitleId : _ref$id,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$m);

  return React__default.createElement(MuiDialogTitle, Object.assign({}, rest, {
    id: id
  }));
};

var _excluded$n = ["aria-labelledby", "children", "className", "fullScreen", "size"];

var _templateObject$l;
var StyledDialog = /*#__PURE__*/styled$2(MuiDialog)(_templateObject$l || (_templateObject$l = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  &.fs .paper {\n    display: inline-flex;\n    flex-direction: column;\n\n    .dialog-content {\n      flex: 1;\n    }\n  }\n"])));
/**
 * Implements [Dialog](https://mui.com/components/dialogs/) from **Material-UI**.
 */

var Dialog = function Dialog(_ref) {
  var _ref$ariaLabelledby = _ref['aria-labelledby'],
      ariaLabelledby = _ref$ariaLabelledby === void 0 ? DialogTitleId : _ref$ariaLabelledby,
      children = _ref.children,
      className = _ref.className,
      fullScreen = _ref.fullScreen,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'sm' : _ref$size,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$n);

  var _useEnovaContext = useEnovaContext(),
      theme = _useEnovaContext.theme;

  var fs = useMediaQuery(theme.breakpoints.down(typeof fullScreen === 'string' ? fullScreen : fullScreen ? 'xl' : 0));
  return React__default.createElement(StyledDialog, Object.assign({}, rest, {
    "aria-labelledby": ariaLabelledby,
    classes: {
      paper: 'paper'
    },
    className: classNames(className, {
      fs: fs
    }),
    fullScreen: fs,
    fullWidth: true,
    maxWidth: size,
    scroll: "body"
  }), children);
};
Dialog.Actions = DialogActions;
Dialog.Content = DialogContent;
Dialog.Title = DialogTitle;

var _templateObject$m, _templateObject2$d, _templateObject3$8, _templateObject4$5;
var helperTextCSS = /*#__PURE__*/css(_templateObject$m || (_templateObject$m = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  color: inherit;\n  font-size: ", ";\n  font-weight: ", ";\n  margin: 0;\n\n  &.disabled,\n  &.disabled * {\n    opacity: ", ";\n  }\n\n  &.error,\n  &.error * {\n    color: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.body2.fontSize;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.body2.fontWeight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.action.disabledOpacity;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.error.main;
});
var labelCSS = /*#__PURE__*/css(_templateObject2$d || (_templateObject2$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  color: inherit;\n  font-size: ", ";\n  font-weight: ", ";\n  margin-bottom: 0.5rem;\n  overflow: visible;\n  pointer-events: all;\n  position: relative;\n  transform: none;\n  white-space: normal;\n\n  &.disabled {\n    opacity: ", ";\n  }\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.h4.fontSize;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.typography.h4.fontWeight;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.palette.action.disabledOpacity;
});
var getMarginClasses = function getMarginClasses(_ref8) {
  var marginBottom = _ref8.marginBottom,
      marginTop = _ref8.marginTop,
      marginY = _ref8.marginY;
  return {
    'mb-3': marginBottom,
    'mt-3': marginTop,
    'my-3': marginY
  };
};
var defaultWidth = 'default';
var getWidthClasses = function getWidthClasses(_ref9) {
  var _ref9$width = _ref9.width,
      width = _ref9$width === void 0 ? defaultWidth : _ref9$width;
  return {
    'w-100': width === 'fullWidth',
    'w-fit-content': width === 'auto',
    'w-default': width === 'default'
  };
};
var StyledLabel = /*#__PURE__*/styled$1(function (props) {
  return React__default.createElement(FormLabel, Object.assign({
    classes: {
      asterisk: 'asterisk',
      disabled: 'disabled',
      root: 'label'
    }
  }, props));
})(_templateObject3$8 || (_templateObject3$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  &.label,\n  &.label .asterisk {\n    ", "\n  }\n"])), labelCSS);
var StyledHelperText = /*#__PURE__*/styled$1(function (props) {
  return React__default.createElement(FormHelperText, Object.assign({
    classes: {
      root: 'helper',
      error: 'error'
    }
  }, props));
})(_templateObject4$5 || (_templateObject4$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), helperTextCSS);

var _excluded$o = ["children", "className", "fullWidth", "marginBottom", "marginTop", "marginY", "title", "variant"];

var _templateObject$n;
var StyledBox = /*#__PURE__*/styled$1(Box$1)(_templateObject$n || (_templateObject$n = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: ", ";\n  border: ", ";\n  border-radius: ", "px;\n\n  &.warning {\n    background: ", ";\n    border: ", ";\n  }\n\n  &.fullwidth {\n    width: 100%;\n  }\n\n  &.default-width {\n    width: ", "px;\n  }\n\n  .form-message--content {\n    font-size: ", ";\n    font-weight: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.error.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return "2px solid " + theme.palette.error.main;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.shape.borderRadius;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.warning.background;
}, function (_ref5) {
  var theme = _ref5.theme;
  return "2px solid " + theme.palette.warning.dark;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.size.inputWidth;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.body2.fontSize;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.typography.body2.fontWeight;
});
var FormMessage = function FormMessage(_ref9) {
  var children = _ref9.children,
      className = _ref9.className,
      fullWidth = _ref9.fullWidth,
      marginBottom = _ref9.marginBottom,
      marginTop = _ref9.marginTop,
      marginY = _ref9.marginY,
      title = _ref9.title,
      _ref9$variant = _ref9.variant,
      variant = _ref9$variant === void 0 ? 'error' : _ref9$variant,
      rest = _objectWithoutPropertiesLoose(_ref9, _excluded$o);

  return React__default.createElement(StyledBox, Object.assign({
    className: classNames(variant, getMarginClasses({
      marginBottom: marginBottom,
      marginTop: marginTop,
      marginY: marginY
    }), {
      fullwidth: fullWidth,
      'default-width': !fullWidth
    }, className),
    paddingX: 4,
    paddingY: 3
  }, rest), React__default.createElement(Typography, null, React__default.createElement("strong", null, title)), typeof children === 'string' ? React__default.createElement(Typography, {
    variant: "body2"
  }, children) : React__default.createElement("div", {
    className: "form-message--content"
  }, children));
};
FormMessage.displayName = 'FormMessage';

var _excluded$p = ["aria-label", "size", "icon", "className"],
    _excluded2$1 = ["aria-label", "children", "CloseButtonProps"];

var _templateObject$o, _templateObject2$e;
var ContentWrapper = /*#__PURE__*/styled$1.div(_templateObject$o || (_templateObject$o = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  font-weight: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.body1.fontSize;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.body1.fontWeight;
});
var StyledBadge$1 = /*#__PURE__*/styled$1(MuiBadge)(_templateObject2$e || (_templateObject2$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding: 0;\n  border: 1px solid ", ";\n  border-radius: 50%;\n  background: none;\n\n  .badge {\n    color: ", ";\n    background: ", ";\n    padding-bottom: 3px;\n    position: initial;\n    top: initial;\n    cursor: pointer;\n    right: initial;\n    transform: initial;\n    transform-origin: initial;\n  }\n\n  &:hover,\n  &:active,\n  &:focus-visible {\n    .badge {\n      background: ", ";\n      color: ", ";\n    }\n  }\n\n  &:focus-visible {\n    outline: none;\n\n    .badge {\n      ", "\n    }\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.black;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.getContrastText(theme.palette.background.paper);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.background.paper;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.lightOcean;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.palette.getContrastText(theme.palette.lightOcean);
}, focusSingleThickBoxShadow);
var HelperBox = function HelperBox(_ref8) {
  var _rest$title;

  var _ref8$ariaLabel = _ref8['aria-label'],
      ariaLabel = _ref8$ariaLabel === void 0 ? 'information' : _ref8$ariaLabel,
      children = _ref8.children,
      _ref8$CloseButtonProp = _ref8.CloseButtonProps;
  _ref8$CloseButtonProp = _ref8$CloseButtonProp === void 0 ? {} : _ref8$CloseButtonProp;

  var _ref8$CloseButtonProp2 = _ref8$CloseButtonProp['aria-label'],
      closeButtonAriaLabel = _ref8$CloseButtonProp2 === void 0 ? 'close' : _ref8$CloseButtonProp2,
      _ref8$CloseButtonProp3 = _ref8$CloseButtonProp.size,
      closeButtonSize = _ref8$CloseButtonProp3 === void 0 ? 'small' : _ref8$CloseButtonProp3,
      _ref8$CloseButtonProp4 = _ref8$CloseButtonProp.icon,
      closeButtonIcon = _ref8$CloseButtonProp4 === void 0 ? 'close' : _ref8$CloseButtonProp4,
      closeButtonClassName = _ref8$CloseButtonProp.className,
      CloseButtonProps = _objectWithoutPropertiesLoose(_ref8$CloseButtonProp, _excluded$p),
      rest = _objectWithoutPropertiesLoose(_ref8, _excluded2$1);

  var _useState = useState(null),
      anchorEl = _useState[0],
      setAnchorEl = _useState[1];

  var onClose = function onClose() {
    anchorEl == null ? void 0 : anchorEl.focus();
    setAnchorEl(null);
  };

  var toggle = function toggle(target) {
    return setAnchorEl(function (prev) {
      return !!prev ? null : target;
    });
  };

  return React__default.createElement(Fragment, null, React__default.createElement(StyledBadge$1, Object.assign({}, rest, {
    component: 'button',
    type: 'button',
    'aria-label': ariaLabel
  }, {
    badgeContent: "?",
    classes: {
      badge: 'badge'
    },
    onClick: function onClick(e) {
      e.preventDefault();
      toggle(e.currentTarget);
    },
    title: (_rest$title = rest.title) != null ? _rest$title : ariaLabel
  })), React__default.createElement(Popover, {
    anchorEl: anchorEl,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    onClose: onClose,
    open: !!anchorEl
  }, React__default.createElement(Box$1, {
    alignItems: "flex-start",
    display: "flex",
    justifyContent: "space-between",
    marginTop: 1,
    maxWidth: 600,
    minWidth: 260,
    paddingX: 4,
    paddingY: 3
  }, React__default.createElement(Box$1, {
    className: "f-fill",
    marginTop: -0.5
  }, typeof children === 'string' ? React__default.createElement(Typography, {
    className: "text-preline"
  }, children) : React__default.createElement(ContentWrapper, null, children)), React__default.createElement(IconButton, Object.assign({}, CloseButtonProps, {
    "aria-label": closeButtonAriaLabel,
    className: classNames('ml-2', closeButtonClassName),
    icon: closeButtonIcon,
    onClick: onClose,
    size: closeButtonSize
  })))));
};
HelperBox.displayName = 'HelperBox';

var _excluded$q = ["aria-label", "size", "icon", "className"],
    _excluded2$2 = ["children", "control", "className", "CloseButtonProps", "dismissable", "inline", "title"];

var _templateObject$p;
var ContentWrapper$1 = /*#__PURE__*/styled$1.div(_templateObject$p || (_templateObject$p = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  font-weight: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.body1.fontSize;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.body1.fontWeight;
});
var InfoBox = function InfoBox(_ref3) {
  var children = _ref3.children,
      _ref3$control = _ref3.control;
  _ref3$control = _ref3$control === void 0 ? {} : _ref3$control;
  var onClose = _ref3$control.onClose,
      _ref3$control$open = _ref3$control.open,
      initOpen = _ref3$control$open === void 0 ? true : _ref3$control$open,
      className = _ref3.className,
      _ref3$CloseButtonProp = _ref3.CloseButtonProps;
  _ref3$CloseButtonProp = _ref3$CloseButtonProp === void 0 ? {} : _ref3$CloseButtonProp;

  var _ref3$CloseButtonProp2 = _ref3$CloseButtonProp['aria-label'],
      closeButtonAriaLabel = _ref3$CloseButtonProp2 === void 0 ? 'close' : _ref3$CloseButtonProp2,
      _ref3$CloseButtonProp3 = _ref3$CloseButtonProp.size,
      closeButtonSize = _ref3$CloseButtonProp3 === void 0 ? 'small' : _ref3$CloseButtonProp3,
      _ref3$CloseButtonProp4 = _ref3$CloseButtonProp.icon,
      closeButtonIcon = _ref3$CloseButtonProp4 === void 0 ? 'close' : _ref3$CloseButtonProp4,
      closeButtonClassName = _ref3$CloseButtonProp.className,
      CloseButtonProps = _objectWithoutPropertiesLoose(_ref3$CloseButtonProp, _excluded$q),
      _ref3$dismissable = _ref3.dismissable,
      dismissable = _ref3$dismissable === void 0 ? true : _ref3$dismissable,
      inline = _ref3.inline,
      title = _ref3.title,
      rest = _objectWithoutPropertiesLoose(_ref3, _excluded2$2);

  var _useState = useState(initOpen),
      open = _useState[0],
      setOpen = _useState[1];

  var handleClose = function handleClose() {
    onClose && onClose();
    setOpen(false);
  };

  useEffect(function () {
    return setOpen(initOpen);
  }, [initOpen]);
  var padTop = !!title !== !!children;
  return React__default.createElement(Collapse$1, {
    "in": open
  }, React__default.createElement(Box$1, Object.assign({
    className: classNames(className, {
      'd-inline-flex': inline
    })
  }, rest), React__default.createElement(Paper$1, {
    square: true,
    elevation: 1
  }, React__default.createElement(Box$1, {
    paddingX: 4,
    paddingY: 3,
    alignItems: "flex-start",
    display: "flex",
    justifyContent: "space-between",
    margin: "auto"
  }, React__default.createElement(LargeIcon, {
    className: "mr-3",
    name: "info",
    color: "primary"
  }), React__default.createElement(Box$1, {
    className: "f-fill",
    marginTop: padTop ? 0.5 : undefined
  }, title && React__default.createElement(Typography, {
    variant: "h4",
    component: "p"
  }, title), typeof children === 'string' ? React__default.createElement(Typography, null, children) : React__default.createElement(ContentWrapper$1, null, children)), dismissable && React__default.createElement(IconButton, Object.assign({}, CloseButtonProps, {
    "aria-label": closeButtonAriaLabel,
    className: classNames('ml-2', {
      'mt-1': padTop
    }, closeButtonClassName),
    icon: closeButtonIcon,
    onClick: handleClose,
    size: closeButtonSize
  }))))));
};
InfoBox.displayName = 'InfoBox';

var _excluded$r = ["children"];
var FullScreenLoader = function FullScreenLoader(_ref) {
  var children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$r);

  return React__default.createElement(Modal, Object.assign({}, rest, {
    sx: {
      color: function color(theme) {
        return theme.palette.common.white;
      },
      zIndex: function zIndex(theme) {
        return theme.zIndex.drawer + 1;
      },
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }), React__default.createElement(Box$1, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 4,
    style: {
      outline: 'none'
    },
    tabIndex: -1
  }, React__default.createElement(Loader, {
    color: "inherit",
    size: "large"
  }), children && React__default.createElement(Box$1, null, children)));
};
FullScreenLoader.displayName = 'FullScreenLoader';

var _excluded$s = ["children", "className", "contentWidth", "control", "title", "variant"];

var _templateObject$q;
var Wrapper$3 = /*#__PURE__*/styled$1.div(_templateObject$q || (_templateObject$q = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding: ", ";\n\n  &.error {\n    background: ", ";\n  }\n\n  &.success {\n    background: ", ";\n  }\n\n  .form-message--content {\n    font-size: ", ";\n    font-weight: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(3, 4);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.error.background;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.success.background;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.body1.fontSize;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.body1.fontWeight;
});
var Notification = function Notification(_ref6) {
  var children = _ref6.children,
      className = _ref6.className,
      contentWidth = _ref6.contentWidth,
      _ref6$control = _ref6.control;
  _ref6$control = _ref6$control === void 0 ? {} : _ref6$control;

  var onClose = _ref6$control.onClose,
      _ref6$control$open = _ref6$control.open,
      initOpen = _ref6$control$open === void 0 ? true : _ref6$control$open,
      title = _ref6.title,
      _ref6$variant = _ref6.variant,
      variant = _ref6$variant === void 0 ? 'success' : _ref6$variant,
      rest = _objectWithoutPropertiesLoose(_ref6, _excluded$s);

  var _useState = useState(initOpen),
      open = _useState[0],
      setOpen = _useState[1];

  var handleClose = function handleClose() {
    onClose && onClose();
    setOpen(false);
  };

  useEffect(function () {
    return setOpen(initOpen);
  }, [initOpen]);
  return React__default.createElement(Collapse$1, {
    "in": open
  }, React__default.createElement(Wrapper$3, Object.assign({}, rest, {
    className: classNames(variant, className),
    role: "alert"
  }), React__default.createElement(Box$1, {
    alignItems: "flex-start",
    display: "flex",
    justifyContent: "space-between",
    margin: "auto",
    maxWidth: 1,
    width: contentWidth
  }, React__default.createElement("div", null, React__default.createElement(Typography, {
    variant: "h4",
    component: "p"
  }, title), typeof children === 'string' ? React__default.createElement(Typography, null, children) : React__default.createElement("div", {
    className: "form-message--content"
  }, children)), React__default.createElement(IconButton, {
    "aria-label": "Dismiss",
    className: "ml-2",
    icon: "close",
    onClick: handleClose,
    size: "small"
  }))));
};
Notification.displayName = 'Notification';

var _templateObject$r;
var StyledTextField = /*#__PURE__*/styled$1(MuiTextField)(_templateObject$r || (_templateObject$r = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  max-width: 100%;\n\n  &.default-width {\n    width: ", "px;\n  }\n\n  &.no-label fieldset {\n    top: 0;\n  }\n\n  fieldset legend * {\n    display: none;\n  }\n\n  .input-root {\n    background: ", ";\n    min-height: ", "px;\n\n    &.disabled {\n      background: ", ";\n      cursor: not-allowed;\n    }\n\n    &.focus {\n      background: ", ";\n    }\n\n    &.focus fieldset {\n      border-color: ", ";\n    }\n\n    .input {\n      padding: ", ";\n      background: transparent;\n\n      &:not(textarea) {\n        height: ", ";\n      }\n    }\n  }\n\n  &.narrow .input-root {\n    width: ", "px;\n  }\n\n  &.high-viz .focus fieldset {\n    ", "\n    border-color: transparent;\n  }\n\n  &.number-field input {\n    text-align: right;\n  }\n\n  .label,\n  .label .asterisk {\n    ", "\n  }\n\n  .helper {\n    ", "\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.size.inputWidth;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.background.paper;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.size.inputHeight;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.action.disabledBackground;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.background.paper;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacing(2.4, 2);
}, function (_ref8) {
  var theme = _ref8.theme;
  return "calc(" + theme.size.inputHeight + "px - " + theme.spacing(2.4 * 2) + ")";
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.size.inputWidth / 3;
}, focusInvertedDoubleBoxShadow, labelCSS, helperTextCSS);

var _excluded$t = ["autoComplete", "className", "HelperBoxProps", "highVizFocus", "id", "InputProps", "label", "marginBottom", "marginTop", "marginY", "narrow", "required", "inputRef"];
var TextFieldBase = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$autoComplete = _ref.autoComplete,
      autoComplete = _ref$autoComplete === void 0 ? false : _ref$autoComplete,
      className = _ref.className,
      HelperBoxProps = _ref.HelperBoxProps,
      highVizFocus = _ref.highVizFocus,
      customId = _ref.id,
      InputProps = _ref.InputProps,
      label = _ref.label,
      marginBottom = _ref.marginBottom,
      marginTop = _ref.marginTop,
      marginY = _ref.marginY,
      narrow = _ref.narrow,
      required = _ref.required,
      inputRef = _ref.inputRef,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$t);

  var id = useMemo(function () {
    return customId || nanoid();
  }, [customId]);
  return React__default.createElement(StyledTextField, Object.assign({}, rest, {
    autoComplete: autoComplete ? undefined : 'off',
    className: classNames(getMarginClasses({
      marginBottom: marginBottom,
      marginTop: marginTop,
      marginY: marginY
    }), {
      'default-width': !rest.fullWidth && !narrow,
      'high-viz': highVizFocus,
      'no-label': !label,
      narrow: narrow
    }, className),
    color: "primary",
    id: id,
    InputLabelProps: {
      classes: {
        asterisk: 'asterisk',
        disabled: 'disabled',
        focused: 'focus',
        root: 'label'
      },
      htmlFor: id,
      shrink: true
    },
    InputProps: _extends({}, InputProps, {
      required: required,
      classes: {
        disabled: 'disabled',
        focused: 'focus',
        input: 'input',
        multiline: 'p-0',
        root: 'input-root'
      }
    }),
    inputRef: inputRef != null ? inputRef : ref,
    FormHelperTextProps: {
      classes: {
        root: 'helper',
        error: 'error',
        disabled: 'disabled'
      }
    },
    label: (label || HelperBoxProps) && React__default.createElement(Box$1, {
      display: "flex",
      alignItems: "baseline"
    }, label && React__default.createElement("label", {
      htmlFor: id
    }, label), required && React__default.createElement("div", null, "\xA0*"), HelperBoxProps && React__default.createElement(HelperBox, Object.assign({
      className: "ml-2"
    }, HelperBoxProps))),
    variant: "outlined"
  }));
});
TextFieldBase.displayName = 'TextFieldBase';

var _styled;

var _excluded$u = ["children"];
var LISTBOX_PADDING = 8; // px

var renderRow = function renderRow(_ref) {
  var data = _ref.data,
      index = _ref.index,
      style = _ref.style;
  var dataSet = data[index];

  var inlineStyle = _extends({}, style, {
    top: style.top + LISTBOX_PADDING
  });

  return React__default.createElement(Typography, Object.assign({
    component: "li"
  }, dataSet[0], {
    noWrap: true,
    style: inlineStyle
  }), dataSet[1].label);
};

var OuterElementContext = /*#__PURE__*/createContext({});
var OuterElementType = /*#__PURE__*/forwardRef(function (props, ref) {
  var outerProps = useContext(OuterElementContext);
  return React__default.createElement("div", Object.assign({
    ref: ref
  }, props, outerProps));
});

var useResetCache = function useResetCache(data) {
  var ref = useRef(null);
  useEffect(function () {
    var _ref$current;

    (_ref$current = ref.current) == null ? void 0 : _ref$current.resetAfterIndex(0, true);
  }, [data]);
  return ref;
}; // Adapter for react-window


var ListboxComponent = /*#__PURE__*/forwardRef(function ListboxComponent(props, ref) {
  var children = props.children,
      other = _objectWithoutPropertiesLoose(props, _excluded$u);

  var itemData = [];
  children.forEach(function (item) {
    itemData.push(item);
    itemData.push.apply(itemData, item.children || []);
  });

  var _useEnovaContext = useEnovaContext(),
      theme = _useEnovaContext.theme;

  var smUp = useMediaQuery(theme.breakpoints.up('sm'), {
    noSsr: true
  });
  var itemCount = itemData.length;
  var itemSize = smUp ? 36 : 48;

  var getChildSize = function getChildSize(child) {
    return child.hasOwnProperty('group') ? 48 : itemSize;
  };

  var getHeight = function getHeight() {
    return itemCount > 8 ? 8 * itemSize : itemData.map(getChildSize).reduce(function (a, b) {
      return a + b;
    }, 0);
  };

  var gridRef = useResetCache(itemCount);
  return React__default.createElement("div", {
    ref: ref
  }, React__default.createElement(OuterElementContext.Provider, {
    value: other
  }, React__default.createElement(VariableSizeList, {
    height: getHeight() + 2 * LISTBOX_PADDING,
    innerElementType: "ul",
    itemCount: itemCount,
    itemData: itemData,
    itemSize: function itemSize(index) {
      return getChildSize(itemData[index]);
    },
    outerElementType: OuterElementType,
    overscanCount: 5,
    ref: gridRef,
    width: "100%"
  }, renderRow)));
});
var StyledPopper = /*#__PURE__*/styled$3(Popper)((_styled = {}, _styled["& ." + autocompleteClasses.listbox] = {
  boxSizing: 'border-box',
  '& ul': {
    padding: 0,
    margin: 0
  }
}, _styled));

var _excluded$v = ["autoFocus", "error", "helperText", "HelperBoxProps", "label", "options", "fullWidth", "loadingText", "marginBottom", "marginTop", "marginY", "loading", "required", "value", "placeholder"];
var Autocomplete = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var autoFocus = _ref.autoFocus,
      error = _ref.error,
      helperText = _ref.helperText,
      HelperBoxProps = _ref.HelperBoxProps,
      label = _ref.label,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      fullWidth = _ref.fullWidth,
      loadingText = _ref.loadingText,
      marginBottom = _ref.marginBottom,
      marginTop = _ref.marginTop,
      marginY = _ref.marginY,
      loading = _ref.loading,
      required = _ref.required,
      value = _ref.value,
      placeholder = _ref.placeholder,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$v);

  var renderInput = function renderInput(params) {
    return React__default.createElement(TextFieldBase, Object.assign({}, params, {
      autoFocus: autoFocus,
      error: error,
      fullWidth: fullWidth,
      HelperBoxProps: HelperBoxProps,
      helperText: helperText,
      label: label,
      marginBottom: marginBottom,
      marginTop: marginTop,
      marginY: marginY,
      ref: ref,
      placeholder: placeholder,
      required: required
    }));
  };

  return React__default.createElement(MuiAutocomplete, Object.assign({}, rest, {
    fullWidth: fullWidth,
    autoComplete: true,
    autoHighlight: true,
    classes: {
      inputRoot: 'pt-0 pb-0 pl-0'
    },
    clearIcon: React__default.createElement(Icon, {
      name: "close",
      color: "inherit",
      fontSize: "small"
    }),
    disableListWrap: true,
    getOptionDisabled: function getOptionDisabled(option) {
      return !!option.disabled;
    },
    getOptionLabel: function getOptionLabel(option) {
      return String(option.label);
    },
    ListboxComponent: ListboxComponent,
    loading: loading,
    loadingText: React__default.createElement(Box$1, {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }, React__default.createElement(Loader, {
      color: "inherit"
    }), loadingText),
    options: options,
    PopperComponent: StyledPopper,
    popupIcon: React__default.createElement(Icon, {
      name: "chevron_down",
      color: undefined
    }),
    renderInput: renderInput,
    renderOption: function renderOption(props, option) {
      return [props, option];
    },
    value: options.find(function (item) {
      return item.value === value;
    }) || null
  }));
});
Autocomplete.displayName = 'Autocomplete';

var _templateObject$s, _templateObject2$f, _templateObject3$9, _templateObject4$6, _templateObject5$3, _templateObject6$2, _templateObject7$2, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1;
var marginFactor = 2;
var formGroupStyles = /*#__PURE__*/css(_templateObject$s || (_templateObject$s = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  gap: ", ";\n\n  &.dense-top {\n    margin-top: ", ";\n  }\n\n  &.dense-bottom {\n    margin-bottom: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(marginFactor);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(-1);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing(-1);
});
var controlElementStyles = /*#__PURE__*/css(_templateObject2$f || (_templateObject2$f = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding: 0;\n  margin-left: ", ";\n\n  &:hover {\n    background: none;\n  }\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacing(4);
});
var StyledCheckGroup = /*#__PURE__*/styled$1(FormGroup)(_templateObject3$9 || (_templateObject3$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), formGroupStyles);
var StyledRadioGroup = /*#__PURE__*/styled$1(RadioGroup$1)(_templateObject4$6 || (_templateObject4$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), formGroupStyles);
var StyledCheckbox$1 = /*#__PURE__*/styled$1(MuiCheckbox)(_templateObject5$3 || (_templateObject5$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), controlElementStyles);
var StyledRadio = /*#__PURE__*/styled$1(Radio$1)(_templateObject6$2 || (_templateObject6$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), controlElementStyles);
var StyledHelperText$1 = /*#__PURE__*/styled$1(FormHelperText)(_templateObject7$2 || (_templateObject7$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), helperTextCSS);
var StyledDescWrapper = /*#__PURE__*/styled$1.div(_templateObject8$1 || (_templateObject8$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  font-weight: ", ";\n  margin-bottom: ", ";\n\n  &.disabled,\n  &.disabled * {\n    color: ", ";\n  }\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.body2.fontSize;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.typography.body2.fontWeight;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacing(2);
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.palette.text.disabled;
});
var fromControlLabelBaseCSS = /*#__PURE__*/css(_templateObject9$1 || (_templateObject9$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: ", ";\n  border-radius: ", "px;\n  border: thin solid\n    ", ";\n  display: flex;\n  margin: 0;\n  max-width: 100%;\n  min-height: ", "px;\n  padding: ", ";\n  width: ", "px;\n\n  &.fullwidth {\n    width: 100%;\n  }\n\n  &.autowidth {\n    width: auto;\n  }\n\n  &.error:not(.disabled):not(.focus) {\n    border-color: ", ";\n  }\n\n  &.focus {\n    ", "\n    border-color: ", ";\n  }\n\n  &:not(.disabled):not(.error):hover {\n    border-color: ", ";\n  }\n\n  .label,\n  .label *:not(svg:not(.check-indicator)) {\n    font-size: ", ";\n    font-weight: ", ";\n  }\n\n  .check-indicator {\n    color: ", ";\n    margin: -2px;\n  }\n\n  &.disabled .check-indicator {\n    color: ", ";\n  }\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.palette.background.paper;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.shape.borderRadius;
}, function (_ref11) {
  var theme = _ref11.theme;
  return alpha(theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black, 0.23);
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.size.inputHeight;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.spacing(2.8, 4);
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.size.inputWidth;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.palette.error.main;
}, focusSingleBoxShadow, function (_ref16) {
  var theme = _ref16.theme;
  return theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.palette.text.primary;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.typography.body2.fontSize;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.typography.body2.fontWeight;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.palette.text.primary;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.palette.action.disabled;
}); // Only used for checkbox and radio.

var StyledFormControlLabel = /*#__PURE__*/styled$1(FormControlLabel$1)(_templateObject10$1 || (_templateObject10$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), fromControlLabelBaseCSS);
var StyledButtonFormControlLabel = /*#__PURE__*/styled$1(FormControlLabel$1)(_templateObject11$1 || (_templateObject11$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  align-items: center;\n  min-height: ", "px;\n  padding: ", ";\n  text-align: center;\n  justify-content: center;\n  width: ", "px;\n\n  &.disabled.checked {\n    opacity: 65%;\n\n    .label {\n      color: inherit;\n    }\n  }\n\n  &.shape {\n    padding: ", ";\n    min-height: ", "px;\n  }\n\n  &.checked.focus {\n    ", "\n  }\n\n  .checkbox::before {\n    background-color: currentColor;\n    clip-path: padding-box;\n    content: '';\n    mask-image: url(", ");\n    mask-position: 0 1px;\n    mask-repeat: no-repeat;\n    padding: 0;\n  }\n\n  .checkbox.checked::before {\n    padding: 0 0.7em;\n  }\n"])), fromControlLabelBaseCSS, function (_ref22) {
  var theme = _ref22.theme;
  return theme.size.inputHeight * 2;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.spacing(2.8, 4);
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.size.inputWidth / 2;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.spacing(1, 3, 2);
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.size.inputHeight * 2.5;
}, focusDoubleBoxShadow, CheckIconSVG);

var _excluded$w = ["className", "error", "focus", "label", "width"];

var _templateObject$t;
var StyledTypography$1 = /*#__PURE__*/styled$1(Typography)(_templateObject$t || (_templateObject$t = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  line-height: normal;\n"])));
/**
 * Common wrapper component form `Checkboxes` and `Radios`
 */

var FormControlLabel = function FormControlLabel(_ref) {
  var className = _ref.className,
      error = _ref.error,
      focus = _ref.focus,
      label = _ref.label,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? defaultWidth : _ref$width,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$w);

  return React__default.createElement(StyledFormControlLabel, Object.assign({}, rest, {
    className: classNames(getWidthClasses({
      width: width
    }), {
      error: error,
      focus: focus
    }, className),
    classes: {
      root: 'selection-control',
      disabled: 'disabled',
      label: 'label'
    },
    label: typeof label === 'string' ? React__default.createElement(StyledTypography$1, {
      variant: "body2"
    }, label) : label
  }));
};
FormControlLabel.displayName = 'FormControlLabel';

var _excluded$x = ["className", "error", "helperText", "checked", "label", "marginBottom", "marginTop", "marginY", "onBlur", "indeterminate", "onFocus", "width"];
/**
 * Demos:
 *
 * - [Checkboxes](https://mui.com/components/checkboxes/)
 *
 * API:
 *
 * - [Checkbox API](https://mui.com/api/checkbox/)
 * - inherits [IconButton API](https://mui.com/api/icon-button/)
 */

var Checkbox = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
      error = _ref.error,
      helperText = _ref.helperText,
      checked = _ref.checked,
      label = _ref.label,
      marginBottom = _ref.marginBottom,
      marginTop = _ref.marginTop,
      marginY = _ref.marginY,
      _onBlur = _ref.onBlur,
      indeterminate = _ref.indeterminate,
      width = _ref.width,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$x);

  var _useState = useState(false),
      focus = _useState[0],
      setFocus = _useState[1];

  var checkbox = React__default.createElement(StyledCheckbox$1, Object.assign({}, rest, {
    checked: checked,
    checkedIcon: React__default.createElement(Icon, {
      className: "mr-3",
      name: "check_checked"
    }),
    className: "mw-100 check-indicator",
    color: "default",
    icon: React__default.createElement(Icon, {
      className: "mr-3",
      name: "check_unchecked"
    }),
    indeterminate: indeterminate && checked,
    indeterminateIcon: React__default.createElement(Icon, {
      className: "mr-3",
      name: "check_indeterminate"
    }),
    inputRef: ref,
    onBlur: function onBlur(e) {
      setFocus(false);
      _onBlur && _onBlur(e);
    },
    onFocusVisible: function onFocusVisible() {
      return !focus && setFocus(true);
    }
  }));
  return React__default.createElement(Box$1, {
    className: classNames(getMarginClasses({
      marginBottom: marginBottom,
      marginTop: marginTop,
      marginY: marginY
    }), className),
    display: "flex",
    flexDirection: "column"
  }, React__default.createElement(FormControlLabel, {
    control: checkbox,
    error: error,
    focus: focus,
    label: label,
    width: width
  }), helperText && React__default.createElement(StyledHelperText$1, null, helperText));
});
Checkbox.displayName = 'Checkbox';

var _excluded$y = ["checkbox", "checked", "className", "error", "focus", "icon", "invertedIcon", "label", "width"];

var _templateObject$u, _templateObject2$g;
var StyledTypography$2 = /*#__PURE__*/styled$1(Typography)(_templateObject$u || (_templateObject$u = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  line-height: normal;\n"])));
var IconWrapper = /*#__PURE__*/styled$1.div(_templateObject2$g || (_templateObject2$g = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  align-items: center;\n  display: flex;\n  height: 60px;\n  justify-content: center;\n  max-width: 100%;\n\n  & > * {\n    max-width: 100%;\n    max-height: 100%;\n  }\n"])));
/**
 * Common wrapper component form `Checkboxes` and `Radios`
 */

var ButtonFormControlLabel = function ButtonFormControlLabel(_ref) {
  var _label$props, _label$props$children;

  var checkbox = _ref.checkbox,
      checked = _ref.checked,
      className = _ref.className,
      error = _ref.error,
      focus = _ref.focus,
      icon = _ref.icon,
      invertedIcon = _ref.invertedIcon,
      label = _ref.label,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? defaultWidth : _ref$width,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$y);

  var classes = classNames('p-relative', {
    checked: checked,
    checkbox: checkbox
  });
  var labelContent = typeof label === 'string' ? React__default.createElement(StyledTypography$2, {
    className: classes,
    variant: "body2"
  }, label) : (label == null ? void 0 : label.type) === Fragment ? label == null ? void 0 : (_label$props = label.props) == null ? void 0 : (_label$props$children = _label$props.children) == null ? void 0 : _label$props$children.map(function (item, index) {
    return index === 0 ? cloneElement(item, {
      className: classNames(item.props.className, classes)
    }) : item;
  }) : React__default.createElement("span", {
    className: classes
  }, label);
  return React__default.createElement(StyledButtonFormControlLabel, Object.assign({}, rest, {
    className: classNames(getWidthClasses({
      width: width
    }), {
      'bg-primary': checked,
      checked: checked,
      error: error,
      focus: focus
    }, className),
    classes: {
      root: 'selection-control',
      disabled: 'disabled',
      label: 'label'
    },
    label: icon ? React__default.createElement(Box$1, {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 2
    }, React__default.createElement(IconWrapper, null, checked && invertedIcon || icon || null), labelContent) : labelContent
  }));
};
ButtonFormControlLabel.displayName = 'ButtonFormControlLabel';

var _excluded$z = ["checked", "className", "error", "helperText", "icon", "id", "invertedIcon", "label", "marginBottom", "marginTop", "marginY", "onBlur", "onFocus", "width"];
/**
 * Demos:
 *
 * - [Checkboxes](https://mui.com/components/checkboxes/)
 *
 * API:
 *
 * - [Checkbox API](https://mui.com/api/checkbox/)
 * - inherits [IconButton API](https://mui.com/api/icon-button/)
 */

var CheckButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var checked = _ref.checked,
      className = _ref.className,
      error = _ref.error,
      helperText = _ref.helperText,
      icon = _ref.icon,
      customId = _ref.id,
      invertedIcon = _ref.invertedIcon,
      label = _ref.label,
      marginBottom = _ref.marginBottom,
      marginTop = _ref.marginTop,
      marginY = _ref.marginY,
      _onBlur = _ref.onBlur,
      width = _ref.width,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$z);

  var _useState = useState(false),
      focus = _useState[0],
      setFocus = _useState[1];

  var id = useMemo(function () {
    return customId || nanoid();
  }, [customId]);
  var checkbox = React__default.createElement(StyledCheckbox$1, Object.assign({}, rest, {
    checked: checked,
    checkedIcon: React__default.createElement("span", null),
    className: "p-absolute",
    color: "default",
    icon: React__default.createElement("span", null),
    id: id,
    inputRef: ref,
    onBlur: function onBlur(e) {
      setFocus(false);
      _onBlur && _onBlur(e);
    },
    onFocusVisible: function onFocusVisible() {
      return !focus && setFocus(true);
    }
  }));
  return React__default.createElement(Box$1, {
    className: classNames(getMarginClasses({
      marginBottom: marginBottom,
      marginTop: marginTop,
      marginY: marginY
    }), className),
    display: "flex",
    flexDirection: "column"
  }, React__default.createElement(ButtonFormControlLabel, {
    checkbox: true,
    checked: checked,
    control: checkbox,
    error: error,
    focus: focus,
    icon: icon,
    invertedIcon: invertedIcon,
    label: label,
    width: width
  }), helperText && React__default.createElement(StyledHelperText$1, null, helperText));
});
CheckButton.displayName = 'CheckButton';

var _excluded$A = ["aria-describedby", "children", "className", "description", "HelperBoxProps", "helperText", "hiddenLabel", "label", "marginBottom", "marginTop", "marginY"];
/**
 * Component for easy rendering of `Radio` groups with some common attributes.
 * Renders correctly according to current a11y requirements.
 *
 * Accepts one or more `Radio`.
 *
 * Uses the following components from **Material-UI**:
 *
 * - [FormControl](https://mui.com/api/form-control/)
 * - [FormLabel](https://mui.com/api/form-label/)
 * - [RadioGroup](https://mui.com/api/radio-group/)
 * - [FormHelperText](https://mui.com/api/form-helper-text/)
 */

var SelectionGroup = function SelectionGroup(_ref) {
  var ariaDescribedby = _ref['aria-describedby'],
      children = _ref.children,
      className = _ref.className,
      description = _ref.description,
      HelperBoxProps = _ref.HelperBoxProps,
      helperText = _ref.helperText,
      hiddenLabel = _ref.hiddenLabel,
      label = _ref.label,
      marginBottom = _ref.marginBottom,
      marginTop = _ref.marginTop,
      marginY = _ref.marginY,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$A);

  var descriptionId = useMemo(function () {
    return description ? nanoid() : undefined;
  }, [description]);
  return React__default.createElement(FormControl, Object.assign({}, rest, {
    "aria-describedby": ariaDescribedby || descriptionId,
    className: classNames('mw-100', 'w-100', className, getMarginClasses({
      marginBottom: marginBottom,
      marginTop: marginTop,
      marginY: marginY
    })),
    component: 'fieldset'
  }), (label || HelperBoxProps) && React__default.createElement(Box$1, {
    display: "flex",
    alignItems: "baseline"
  }, label && React__default.createElement(StyledLabel, {
    className: classNames({
      'sr-only': hiddenLabel
    }),
    component: "legend"
  }, label), HelperBoxProps && React__default.createElement(HelperBox, Object.assign({
    className: "ml-2"
  }, HelperBoxProps))), description && React__default.createElement(StyledDescWrapper, {
    className: classNames('selection-group--desc', {
      disabled: rest.disabled
    })
  }, typeof description === 'string' ? React__default.createElement(Typography, {
    id: descriptionId,
    variant: "body2"
  }, description) : React__default.createElement("span", {
    id: descriptionId
  }, description)), children, helperText && React__default.createElement(StyledHelperText$1, {
    className: "mt-1",
    classes: {
      disabled: 'disabled',
      error: 'error'
    }
  }, helperText));
};
SelectionGroup.displayName = 'SelectionGroup';

var getSelectionGroupDisplayClasses = function getSelectionGroupDisplayClasses(hiddenLabel, row) {
  return {
    'dense-top': hiddenLabel,
    'f-row': row
  };
};

var _excluded$B = ["children", "row"];
/**
 * Component for easy rendering of `Checkbox` groups with some common attributes.
 * Renders correctly according to current a11y requirements.
 *
 * Accepts one or more `Checkboxes` as its children.
 *
 * Uses the following components from **Material-UI**:
 *
 * - [FormControl](https://mui.com/api/form-control/)
 * - [FormLabel](https://mui.com/api/form-label/)
 * - [FormGroup](https://mui.com/api/form-group/)
 * - [FormHelperText](https://mui.com/api/form-helper-text/)
 */

var CheckGroup = function CheckGroup(_ref) {
  var children = _ref.children,
      row = _ref.row,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$B);

  return React__default.createElement(SelectionGroup, Object.assign({}, rest), React__default.createElement(StyledCheckGroup, {
    className: classNames(getSelectionGroupDisplayClasses(rest.hiddenLabel, row))
  }, children));
};
CheckGroup.displayName = 'CheckGroup';

var TextField = /*#__PURE__*/forwardRef(function (props, ref) {
  return React__default.createElement(TextFieldBase, Object.assign({}, props, {
    ref: ref
  }));
});
TextField.displayName = 'TextField';

var _excluded$C = ["className", "decimalPrecision", "disabled", "error", "HelperBoxProps", "helperText", "id", "integer", "label", "marginBottom", "marginTop", "marginY", "narrow", "onValueChange", "prefix", "required", "suffix", "useThousandSeparator", "value", "allowLeadingZeros", "textAlign"];

var _templateObject$v, _templateObject2$h;
var NumberFieldWrapper = /*#__PURE__*/styledComponents__default(FormControl)(_templateObject$v || (_templateObject$v = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  max-width: 100%;\n\n  &.fullwidth {\n    width: 100%;\n  }\n"])));
var Suffix = /*#__PURE__*/styledComponents__default(Typography)(_templateObject2$h || (_templateObject2$h = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  &.disabled {\n    opacity: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.action.disabledOpacity;
});
var NumberField = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var _rest$decimalSeparato;

  var className = _ref2.className,
      decimalPrecision = _ref2.decimalPrecision,
      disabled = _ref2.disabled,
      error = _ref2.error,
      HelperBoxProps = _ref2.HelperBoxProps,
      helperText = _ref2.helperText,
      customId = _ref2.id,
      integer = _ref2.integer,
      label = _ref2.label,
      marginBottom = _ref2.marginBottom,
      marginTop = _ref2.marginTop,
      marginY = _ref2.marginY,
      narrow = _ref2.narrow,
      _onValueChange = _ref2.onValueChange,
      prefix = _ref2.prefix,
      required = _ref2.required,
      suffix = _ref2.suffix,
      useThousandSeparator = _ref2.useThousandSeparator,
      value = _ref2.value,
      allowLeadingZeros = _ref2.allowLeadingZeros,
      textAlign = _ref2.textAlign,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded$C);

  var id = useMemo(function () {
    return customId || nanoid();
  }, []);
  var helperTextId = useMemo(nanoid, [customId]);
  return React__default.createElement(NumberFieldWrapper, {
    className: classNames(getMarginClasses({
      marginBottom: marginBottom,
      marginTop: marginTop,
      marginY: marginY
    }), {
      fullwidth: rest.fullWidth
    }),
    disabled: disabled,
    error: error,
    required: required
  }, (label || HelperBoxProps) && React__default.createElement(Box$2, {
    display: "flex",
    alignItems: "baseline"
  }, label && React__default.createElement(StyledLabel, {
    htmlFor: id
  }, label), HelperBoxProps && React__default.createElement(HelperBox, Object.assign({
    className: "ml-2"
  }, HelperBoxProps))), React__default.createElement(Box$2, {
    display: "flex"
  }, React__default.createElement(NumberFormat, Object.assign({
    allowedDecimalSeparators: ['.', ','],
    "aria-describedby": helperText ? helperTextId : undefined,
    className: classNames(className, textAlign ? undefined : 'number-field'),
    customInput: TextField,
    decimalScale: !integer ? decimalPrecision === false ? undefined : decimalPrecision : 0,
    error: error,
    disabled: disabled,
    getInputRef: ref,
    id: id,
    inputProps: {
      inputMode: integer ? 'numeric' : 'decimal'
    },
    narrow: rest.fullWidth ? false : narrow,
    onValueChange: function onValueChange(values, e) {
      return e.source === 'event' && _onValueChange && _onValueChange(values, e);
    },
    prefix: prefix ? prefix + " " : undefined,
    thousandSeparator: useThousandSeparator ? ' ' : undefined,
    value: value != null ? value : '',
    allowLeadingZeros: allowLeadingZeros,
    decimalSeparator: (_rest$decimalSeparato = rest.decimalSeparator) != null ? _rest$decimalSeparato : ','
  }, rest)), suffix && React__default.createElement(Suffix, {
    "aria-hidden": true,
    className: classNames('d-flex', 'ai-center', 'ml-2', {
      disabled: disabled
    })
  }, suffix)), helperText && React__default.createElement(StyledHelperText, {
    className: classNames({
      error: error
    }),
    id: helperTextId
  }, helperText));
});
NumberField.displayName = 'NumberField';
NumberField.defaultProps = {
  allowNegative: false,
  decimalPrecision: 2,
  integer: false,
  narrow: true,
  useThousandSeparator: true
};

var _templateObject$w, _templateObject2$i, _templateObject3$a;
var StyledWrapper$1 = /*#__PURE__*/styled$1(Box$1)(_templateObject$w || (_templateObject$w = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  width: ", "px;\n\n  &.fullWidth {\n    width: 100%;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.size.inputWidth;
});
var StyledLabel$1 = /*#__PURE__*/styled$1(InputLabel)(_templateObject2$i || (_templateObject2$i = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), labelCSS);
var StyledInput = /*#__PURE__*/styled$1.input(_templateObject3$a || (_templateObject3$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: none;\n  border: none;\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  min-width: 4ch;\n  text-align: center;\n  width: ", ";\n\n  &:disabled {\n    color: ", ";\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.text.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.h4.fontSize;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.h4.fontWeight;
}, function (_ref5) {
  var value = _ref5.value,
      step = _ref5.step;
  return String(Math.floor(value)).length + 1 + (step % 2 !== 0 ? String(step % 2).length - 1 : 0) + "ch";
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.text.disabled;
});
var NumberPicker = function NumberPicker(_ref7) {
  var disabled = _ref7.disabled,
      error = _ref7.error,
      fullWidth = _ref7.fullWidth,
      HelperBoxProps = _ref7.HelperBoxProps,
      helperText = _ref7.helperText,
      customId = _ref7.id,
      label = _ref7.label,
      marginBottom = _ref7.marginBottom,
      marginTop = _ref7.marginTop,
      marginY = _ref7.marginY,
      max = _ref7.max,
      min = _ref7.min,
      onChange = _ref7.onChange,
      _ref7$step = _ref7.step,
      step = _ref7$step === void 0 ? 1 : _ref7$step,
      value = _ref7.value;
  var id = useMemo(function () {
    return customId || nanoid();
  }, [customId]);
  var helperTextId = useMemo(nanoid, [customId]);
  useEffect(function () {
    if (min != null && max != null && min > max) console.error('Minimum value cannot be greater than maximum value.');
    if (min != null && value < min) console.error('Provided value is less than minimum allowed value.');
    if (max != null && value > max) console.error('Provided value is greater than maximum allowed value.');
  }, [min, max, value]);
  return React__default.createElement(StyledWrapper$1, {
    className: classNames({
      fullWidth: fullWidth
    }, getMarginClasses({
      marginBottom: marginBottom,
      marginTop: marginTop,
      marginY: marginY
    })),
    display: "flex",
    flexDirection: "column"
  }, React__default.createElement(Box$1, {
    display: "flex",
    alignItems: "baseline"
  }, React__default.createElement(StyledLabel$1, {
    disabled: disabled,
    htmlFor: id
  }, label), HelperBoxProps && React__default.createElement(HelperBox, Object.assign({
    className: "ml-2"
  }, HelperBoxProps))), React__default.createElement(Box$1, {
    display: "flex",
    justifyContent: "flex-start",
    maxWidth: 1
  }, React__default.createElement(IconButton, {
    "aria-controls": id,
    "aria-label": "decrement value by " + step,
    className: "mr-1",
    disabled: disabled || min != null && value <= min,
    icon: "minus",
    onClick: function onClick() {
      var newVal = value - step;
      onChange(min != null && newVal < min ? min : newVal);
    },
    size: "small"
  }), React__default.createElement(StyledInput, {
    "aria-describedby": helperText ? helperTextId : undefined,
    disabled: disabled,
    id: id,
    inputMode: "numeric",
    onFocus: function onFocus(e) {
      return e.currentTarget.blur();
    },
    readOnly: true,
    step: step,
    tabIndex: -1,
    value: value
  }), React__default.createElement(IconButton, {
    "aria-controls": id,
    "aria-label": "increment value by " + step,
    className: "ml-1",
    disabled: disabled || max != null && value >= max,
    icon: "plus",
    onClick: function onClick() {
      var newVal = value + step;
      onChange(max != null && newVal > max ? max : newVal);
    },
    size: "small"
  })), helperText && React__default.createElement(StyledHelperText$1, {
    className: classNames({
      disabled: disabled,
      error: error
    }),
    id: helperTextId
  }, helperText));
};

var _excluded$D = ["className", "error", "helperText", "label", "marginBottom", "marginTop", "marginY", "onBlur", "onFocus", "width"];
/**
 * Demos:
 *
 * - [Checkboxes](https://mui.com/components/checkboxes/)
 *
 * API:
 *
 * - [Checkbox API](https://mui.com/api/checkbox/)
 * - inherits [IconButton API](https://mui.com/api/icon-button/)
 */

var Radio = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
      error = _ref.error,
      helperText = _ref.helperText,
      label = _ref.label,
      marginBottom = _ref.marginBottom,
      marginTop = _ref.marginTop,
      marginY = _ref.marginY,
      _onBlur = _ref.onBlur,
      width = _ref.width,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$D);

  var _useState = useState(false),
      focus = _useState[0],
      setFocus = _useState[1];

  var radio = React__default.createElement(StyledRadio, Object.assign({}, rest, {
    checkedIcon: React__default.createElement(Icon, {
      className: "mr-3",
      name: "radio_checked"
    }),
    className: "check-indicator",
    color: "default",
    icon: React__default.createElement(Icon, {
      className: "mr-3",
      name: "radio_unchecked"
    }),
    inputRef: ref,
    onBlur: function onBlur(e) {
      setFocus(false);
      _onBlur && _onBlur(e);
    },
    onFocusVisible: function onFocusVisible() {
      return !focus && setFocus(true);
    }
  }));
  return React__default.createElement(Box$1, {
    className: classNames(getMarginClasses({
      marginBottom: marginBottom,
      marginTop: marginTop,
      marginY: marginY
    }), className),
    display: "flex",
    flexDirection: "column"
  }, React__default.createElement(FormControlLabel, {
    control: radio,
    error: error,
    focus: focus,
    label: label,
    width: width
  }), helperText && React__default.createElement(StyledHelperText$1, null, helperText));
});
Radio.displayName = 'Radio';

var _excluded$E = ["checked", "className", "error", "helperText", "icon", "id", "invertedIcon", "label", "marginBottom", "marginTop", "marginY", "onBlur", "onFocus", "width"];
/**
 * Demos:
 *
 * - [Radioes](https://mui.com/components/radios/)
 *
 * API:
 *
 * - [Radio API](https://mui.com/api/radio/)
 * - inherits [IconButton API](https://mui.com/api/icon-button/)
 */

var RadioButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var checked = _ref.checked,
      className = _ref.className,
      error = _ref.error,
      helperText = _ref.helperText,
      icon = _ref.icon,
      customId = _ref.id,
      invertedIcon = _ref.invertedIcon,
      label = _ref.label,
      marginBottom = _ref.marginBottom,
      marginTop = _ref.marginTop,
      marginY = _ref.marginY,
      _onBlur = _ref.onBlur,
      width = _ref.width,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$E);

  var _useState = useState(false),
      focus = _useState[0],
      setFocus = _useState[1];

  var id = useMemo(function () {
    return customId || nanoid();
  }, [customId]);
  var radioGroup = useRadioGroup();
  var isChecked = !!(checked || rest.value != null && (radioGroup == null ? void 0 : radioGroup.value) === rest.value);
  var radio = React__default.createElement(StyledRadio, Object.assign({}, rest, {
    checked: isChecked,
    checkedIcon: React__default.createElement("span", null),
    className: "p-absolute",
    color: "default",
    icon: React__default.createElement("span", null),
    id: id,
    inputRef: ref,
    onBlur: function onBlur(e) {
      setFocus(false);
      _onBlur && _onBlur(e);
    },
    onFocusVisible: function onFocusVisible() {
      return !focus && setFocus(true);
    }
  }));
  return React__default.createElement(Box$1, {
    className: classNames(getMarginClasses({
      marginBottom: marginBottom,
      marginTop: marginTop,
      marginY: marginY
    }), className),
    display: "flex",
    flexDirection: "column"
  }, React__default.createElement(ButtonFormControlLabel, {
    checked: isChecked,
    className: className,
    control: radio,
    error: error,
    focus: focus,
    icon: icon,
    invertedIcon: invertedIcon,
    label: label,
    width: width
  }), helperText && React__default.createElement(StyledHelperText$1, null, helperText));
});
RadioButton.displayName = 'RadioButton';

var _excluded$F = ["children", "defaultValue", "id", "name", "onBlur", "onChange", "onFocus", "row", "value"];
/**
 * Component for easy rendering of `Radio` groups with some common attributes.
 * Renders correctly according to current a11y requirements.
 *
 * Accepts one or more `Radio`.
 *
 * Uses the following components from **Material-UI**:
 *
 * - [FormControl](https://mui.com/api/form-control/)
 * - [FormLabel](https://mui.com/api/form-label/)
 * - [RadioGroup](https://mui.com/api/radio-group/)
 * - [FormHelperText](https://mui.com/api/form-helper-text/)
 */

var RadioGroup = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      defaultValue = _ref.defaultValue,
      id = _ref.id,
      name = _ref.name,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      row = _ref.row,
      value = _ref.value,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$F);

  return React__default.createElement(SelectionGroup, Object.assign({}, rest), React__default.createElement(StyledRadioGroup, {
    className: classNames(getSelectionGroupDisplayClasses(rest.hiddenLabel, row)),
    defaultValue: defaultValue,
    id: id,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    ref: ref,
    value: value
  }, children));
});
RadioGroup.displayName = 'RadioGroup';

var _excluded$G = ["options"],
    _excluded2$3 = ["label", "value"],
    _excluded3 = ["label", "value"];

var _templateObject$x;
var StyledSelect = /*#__PURE__*/styled$1(TextFieldBase)(_templateObject$x || (_templateObject$x = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  select {\n    padding-right: ", " !important;\n  }\n\n  option {\n    font-weight: 300;\n  }\n\n  svg {\n    color: inherit;\n    position: absolute;\n    right: ", ";\n\n    path {\n      fill: currentColor;\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(8);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(2);
});
var Select = /*#__PURE__*/forwardRef(function (props, ref) {
  var options = props.options,
      rest = _objectWithoutPropertiesLoose(props, _excluded$G);

  return React__default.createElement(StyledSelect, Object.assign({}, rest, {
    select: true,
    SelectProps: {
      "native": true,
      IconComponent: function IconComponent() {
        return React__default.createElement(Icon, {
          name: "chevron_down"
        });
      }
    },
    ref: ref
  }), options.map(function (item) {
    if (item.hasOwnProperty('groupName')) {
      var groupName = item.groupName,
          _options = item.options;
      return React__default.createElement("optgroup", {
        key: groupName,
        label: groupName
      }, _options.map(function (_ref3) {
        var label = _ref3.label,
            value = _ref3.value,
            rest = _objectWithoutPropertiesLoose(_ref3, _excluded2$3);

        return React__default.createElement("option", Object.assign({
          key: value,
          value: value
        }, rest), label);
      }));
    }

    var label = item.label,
        value = item.value,
        rest = _objectWithoutPropertiesLoose(item, _excluded3);

    return React__default.createElement("option", Object.assign({
      "aria-selected": value === props.value,
      key: value,
      value: value
    }, rest), label);
  }));
});
Select.displayName = 'Select';

var TextArea = /*#__PURE__*/forwardRef(function (props, ref) {
  return React__default.createElement(TextFieldBase, Object.assign({}, props, {
    multiline: true,
    ref: ref,
    rows: 7
  }));
});
TextArea.displayName = 'TextArea';

var _excluded$H = ["error", "HelperBoxProps", "helperText", "highVizFocus", "inputFormat", "marginBottom", "marginTop", "marginY", "mask", "value", "required", "placeholder"];

var formatDate = function formatDate(dateString) {
  if (!dateString) return undefined;
  var date = new Date(dateString);
  return format(date, 'yyyy-MM-dd');
};

var DatePicker = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var error = _ref.error,
      HelperBoxProps = _ref.HelperBoxProps,
      helperText = _ref.helperText,
      highVizFocus = _ref.highVizFocus,
      _ref$inputFormat = _ref.inputFormat,
      inputFormat = _ref$inputFormat === void 0 ? 'dd.MM.yyyy' : _ref$inputFormat,
      marginBottom = _ref.marginBottom,
      marginTop = _ref.marginTop,
      marginY = _ref.marginY,
      _ref$mask = _ref.mask,
      mask = _ref$mask === void 0 ? '__.__.____' : _ref$mask,
      value = _ref.value,
      required = _ref.required,
      placeholder = _ref.placeholder,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$H);

  var textFieldProps = {
    error: error,
    HelperBoxProps: HelperBoxProps,
    helperText: helperText,
    highVizFocus: highVizFocus,
    label: rest.label,
    marginBottom: marginBottom,
    marginTop: marginTop,
    marginY: marginY
  };
  var inputRef = useRef();

  if (['iPad Simulator', 'iPad', 'iPhone Simulator', 'iPhone', 'iPod Simulator', 'iPod'].includes(navigator.platform)) {
    var getMaxDate = function getMaxDate() {
      var dates = [].concat(rest.disableFuture ? [new Date().getTime()] : [], rest.maxDate ? [new Date(rest.maxDate).getTime()] : []);
      return dates.length > 0 ? formatDate(Math.min.apply(null, dates)) : undefined;
    };

    var getMinDate = function getMinDate() {
      var dates = [].concat(rest.disablePast ? [new Date().getTime()] : [], rest.minDate ? [new Date(rest.minDate).getTime()] : []);
      return dates.length > 0 ? formatDate(Math.max.apply(null, dates)) : undefined;
    };

    var inputProps = {
      max: getMaxDate(),
      min: getMinDate()
    };
    var val = formatDate(value) || '';
    var invalidDate = !!(val && inputProps.min && isBefore(new Date(val), new Date(inputProps.min)) || val && inputProps.max && isAfter(new Date(val), new Date(inputProps.max)));

    var changeHandler = function changeHandler(e) {
      var newValue = e.currentTarget.value;
      rest.onChange(newValue ? new Date(newValue) : null);
    };

    textFieldProps = _extends({}, textFieldProps, {
      error: error != null ? error : invalidDate,
      inputProps: inputProps,
      onChange: changeHandler,
      value: val
    });
    return React__default.createElement(TextField, Object.assign({}, textFieldProps, {
      ref: ref,
      type: "date"
    }));
  }

  return React__default.createElement(MuiDatePicker, Object.assign({}, rest, {
    PopperProps: {
      placement: 'bottom-end',
      anchorEl: inputRef.current
    },
    inputFormat: inputFormat,
    mask: mask,
    renderInput: function renderInput(params) {
      return React__default.createElement(TextFieldBase, Object.assign({
        required: required
      }, textFieldProps, params, error ? {
        error: true
      } : {}, {
        inputProps: _extends({}, params.inputProps, {
          placeholder: placeholder
        }),
        inputRef: inputRef
      }));
    },
    value: value || null
  }));
});
DatePicker.displayName = 'DatePicker';

var _excluded$I = ["className", "onSubmit"];
var Form = function Form(_ref) {
  var className = _ref.className,
      _onSubmit = _ref.onSubmit,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$I);

  return React__default.createElement("form", Object.assign({
    className: classNames('EfcForm--root', className)
  }, rest, {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      _onSubmit && _onSubmit(e);
    }
  }));
};
Form.Autocomplete = Autocomplete;
Form.Checkbox = Checkbox;
Form.CheckButton = CheckButton;
Form.CheckGroup = CheckGroup;
Form.DatePicker = DatePicker;
Form.Message = FormMessage;
Form.NumberField = NumberField;
Form.NumberPicker = NumberPicker;
Form.Radio = Radio;
Form.RadioButton = RadioButton;
Form.RadioGroup = RadioGroup;
Form.Select = Select;
Form.TextArea = TextArea;
Form.TextField = TextField;
Form.displayName = 'Form';

var _excluded$J = ["disabled", "onSearch"];

var _templateObject$y, _templateObject2$j;
var SearchButtonWrapper = /*#__PURE__*/styled$1.div(_templateObject$y || (_templateObject$y = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-right: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(-1);
});
var StyledTextFieldBase = /*#__PURE__*/styled$1(TextFieldBase)(_templateObject2$j || (_templateObject2$j = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  input::placeholder {\n    opacity: 1;\n    font-style: italic;\n  }\n"])));
var SearchField = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var disabled = _ref2.disabled,
      onSearch = _ref2.onSearch,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded$J);

  return React__default.createElement("form", {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      onSearch();
    }
  }, React__default.createElement(StyledTextFieldBase, Object.assign({}, rest, {
    disabled: disabled,
    InputProps: {
      endAdornment: React__default.createElement(InputAdornment, {
        position: "end"
      }, React__default.createElement(SearchButtonWrapper, null, React__default.createElement(Divider__default, {
        orientation: "vertical",
        flexItem: true,
        className: "mr-2"
      }), React__default.createElement(IconButton, {
        "aria-label": "Search",
        color: "inherit",
        disabled: disabled,
        icon: "search",
        type: "submit",
        size: "large"
      })))
    },
    ref: ref,
    role: "search"
  })));
});
SearchField.displayName = 'SearchField';

var _templateObject$z, _templateObject2$k, _templateObject3$b;
var StyledFooter = /*#__PURE__*/styled$1.footer(_templateObject$z || (_templateObject$z = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: ", ";\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.primary.main;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.background.paper;
});
var FooterLink = /*#__PURE__*/styled$1(Link$1)(_templateObject2$k || (_templateObject2$k = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  color: ", ";\n  cursor: pointer;\n  font-size: 17px;\n  font-weight: 500;\n  text-decoration: none;\n\n  :hover {\n    text-decoration: underline;\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.greys.grey1;
});
var FooterCategoryHeader = /*#__PURE__*/styled$1(Typography$1)(_templateObject3$b || (_templateObject3$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: 14px;\n  font-weight: 600;\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.greys.grey1;
});
var Footer = function Footer(props) {
  return React__default.createElement(StyledFooter, Object.assign({}, props));
};
Footer.Link = FooterLink;
Footer.CategoryHeader = FooterCategoryHeader;
Footer.displayName = 'Footer';

var _excluded$K = ["className"],
    _excluded2$4 = ["ContainerProps"];

var _templateObject$A;
var StyledMain = /*#__PURE__*/styled$1.main(_templateObject$A || (_templateObject$A = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding-top: ", "px;\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.mixins.toolbar.minHeight;
}, function (_ref2) {
  var theme = _ref2.theme;
  return Object.entries(theme.mixins.toolbar).filter(function (_ref3) {
    var obj = _ref3[1];
    return typeof obj === 'object';
  }).map(function (_ref4) {
    var key = _ref4[0],
        value = _ref4[1];
    return key + " {\n          padding-top: " + value.minHeight + "px;\n      }";
  });
});
var Main = function Main(_ref5) {
  var _ref5$ContainerProps = _ref5.ContainerProps;
  _ref5$ContainerProps = _ref5$ContainerProps === void 0 ? {} : _ref5$ContainerProps;

  var className = _ref5$ContainerProps.className,
      ContainerProps = _objectWithoutPropertiesLoose(_ref5$ContainerProps, _excluded$K),
      rest = _objectWithoutPropertiesLoose(_ref5, _excluded2$4);

  return React__default.createElement(StyledMain, Object.assign({}, ContainerProps, {
    className: classNames(className, 'f-fill')
  }), React__default.createElement("div", Object.assign({}, rest)));
};
Main.displayName = 'Main';

var _templateObject$B;
var StyledLayout = /*#__PURE__*/styled$1.div(_templateObject$B || (_templateObject$B = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n"])));
var Layout = function Layout(props) {
  return React__default.createElement(StyledLayout, Object.assign({}, props));
};
Layout.AppBar = AppBar;
Layout.Footer = Footer;
Layout.Main = Main;
Layout.displayName = 'Layout';

var _excluded$L = ["transparentBackground"],
    _excluded2$5 = ["button", "className", "color", "component", "targetBlank", "variant"];

var _templateObject$C;
var LinkVariants = /*#__PURE__*/[].concat(TypographyVariants, ['inherit']);
var StyledLink = /*#__PURE__*/styled$1(function (_ref) {
  var rest = _objectWithoutPropertiesLoose(_ref, _excluded$L);

  return React__default.createElement(MuiLink, Object.assign({}, rest));
})(_templateObject$C || (_templateObject$C = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  text-underline-position: under;\n  vertical-align: baseline;\n  text-decoration-color: initial;\n  background-color: ", ";\n\n  .EfcIcon {\n    font-size: inherit;\n    vertical-align: middle;\n  }\n\n  .EfcLargeIcon {\n    font-size: 150%;\n    vertical-align: middle;\n    margin: ", ";\n  }\n"])), focusVisibleBoxShadowRounded, function (props) {
  return props.transparentBackground ? 'transparent' : props.theme.palette.lightGreen;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(0, 2);
});
/**
 * #### Security
 *
 * When you use `target="_blank"` with Links, it is [recommended](https://developers.google.com/web/tools/lighthouse/audits/noopener) to always set `rel="noopener"` or `rel="noreferrer"` when linking to third party content.
 *
 * - `rel="noopener"` prevents the new page from being able to access the `window.opener` property and ensures it runs in a separate process. Without this, the target page can potentially redirect your page to a malicious URL.
 * - `rel="noreferrer"` has the same effect, but also prevents the _Referer_ header from being sent to the new page. ⚠️ Removing the referrer header will affect analytics.
 *
 * #### Accessibility
 *
 * (WAI-ARIA: https://www.w3.org/TR/wai-aria-practices/#link)
 *
 * - When providing the content for the link, avoid generic descriptions like "click here" or "go to". Instead, use [specific descriptions](https://developers.google.com/web/tools/lighthouse/audits/descriptive-link-text).
 * - For the best user experience, links should stand out from the text on the page.
 * - If a link doesn't have a meaningful href, [it should be rendered using a `<button>` element](https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/anchor-is-valid.md).
 */

var Link = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var button = _ref3.button,
      className = _ref3.className,
      _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? 'primary' : _ref3$color,
      component = _ref3.component,
      targetBlank = _ref3.targetBlank,
      _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? 'body1' : _ref3$variant,
      rest = _objectWithoutPropertiesLoose(_ref3, _excluded2$5);

  return React__default.createElement(StyledLink, Object.assign({}, rest, {
    component: component || !rest.href && button ? 'button' : 'a'
  }, {
    className: classNames('EfcLink', className),
    color: color,
    ref: ref,
    target: targetBlank ? '_blank' : undefined,
    underline: "always",
    variant: variant
  }));
});
Link.displayName = 'Link';

var MenuContext = /*#__PURE__*/createContext({
  anchorEl: null,
  onOpen: function onOpen() {
    return true;
  },
  onClose: function onClose() {
    return true;
  }
});

var MenuProvider = function MenuProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(null),
      anchorEl = _useState[0],
      setAnchorEl = _useState[1];

  var onOpen = function onOpen(e) {
    return setAnchorEl(e.currentTarget);
  };

  var onClose = function onClose() {
    anchorEl == null ? void 0 : anchorEl.focus();
    setAnchorEl(null);
  };

  var values = {
    anchorEl: anchorEl,
    onOpen: onOpen,
    onClose: onClose
  };
  return React__default.createElement(MenuContext.Provider, {
    value: values
  }, children);
};

var useMenu = function useMenu() {
  return useContext(MenuContext);
};

var _excluded$M = ["onClick", "children", "component", "dropdownIcon"];

var _templateObject$D;
var StyledIcon = /*#__PURE__*/styled$1(Icon)(_templateObject$D || (_templateObject$D = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  transform: rotate(0);\n  margin: ", ";\n\n  &.rotate {\n    transform: rotate(-180deg);\n  }\n"])), /*#__PURE__*/fastTransition('transform'), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(0, -1, 0, 1);
});
var MenuButton = function MenuButton(_ref2) {
  var _onClick = _ref2.onClick,
      children = _ref2.children,
      _ref2$component = _ref2.component,
      Component = _ref2$component === void 0 ? Button : _ref2$component,
      dropdownIcon = _ref2.dropdownIcon,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded$M);

  var _useMenu = useMenu(),
      anchorEl = _useMenu.anchorEl,
      onOpen = _useMenu.onOpen;

  return React__default.createElement(Component, Object.assign({
    onClick: function onClick(e) {
      _onClick && _onClick(e);
      onOpen(e);
    }
  }, rest), children, dropdownIcon && React__default.createElement(StyledIcon, {
    className: classNames('menu-button--dropdown-icon', {
      rotate: !!anchorEl
    }),
    name: "arrow_dropdown"
  }));
};

var _excluded$N = ["children", "disablePortal", "placement", "title", "autoFocusItem"];

var _templateObject$E, _templateObject2$l, _templateObject3$c;
var StyledPaper$1 = /*#__PURE__*/styled$1(Paper$1)(_templateObject$E || (_templateObject$E = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  border: 1px solid ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.divider;
});
var StyledPopper$1 = /*#__PURE__*/styled$1(Popper)(_templateObject2$l || (_templateObject2$l = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  z-index: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.zIndex.appBar + 1;
});
var StyledMenuList = /*#__PURE__*/styled$1(MenuList)(_templateObject3$c || (_templateObject3$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding: 0;\n"])));
var MenuContent = function MenuContent(_ref3) {
  var children = _ref3.children,
      disablePortal = _ref3.disablePortal,
      _ref3$placement = _ref3.placement,
      placement = _ref3$placement === void 0 ? 'bottom-end' : _ref3$placement,
      title = _ref3.title,
      autoFocusItem = _ref3.autoFocusItem,
      rest = _objectWithoutPropertiesLoose(_ref3, _excluded$N);

  var _useMenu = useMenu(),
      anchorEl = _useMenu.anchorEl,
      onClose = _useMenu.onClose;

  function handleListKeyDown(e) {
    if (e.key === 'Tab' || e.key === 'Escape') {
      e.preventDefault();
      onClose();
    }
  }

  return React__default.createElement(StyledPopper$1, {
    anchorEl: anchorEl,
    disablePortal: disablePortal,
    open: !!anchorEl,
    placement: placement
  }, React__default.createElement(Grow, {
    "in": !!anchorEl
  }, React__default.createElement(StyledPaper$1, Object.assign({}, rest), React__default.createElement(ClickAwayListener, {
    onClickAway: onClose
  }, React__default.createElement("div", null, title, React__default.createElement(StyledMenuList, {
    autoFocusItem: autoFocusItem != null ? autoFocusItem : !!anchorEl,
    onKeyDown: handleListKeyDown
  }, children))))));
};

var _excluded$O = ["divider", "keepMounted", "onClick"];

var _templateObject$F, _templateObject2$m;
var MenuItemCSS = /*#__PURE__*/css(_templateObject$F || (_templateObject$F = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n\n  &:active {\n    background: ", ";\n  }\n"])), focusVisibleInsetBoxShadow, function (_ref) {
  var theme = _ref.theme;
  return theme.palette.action.focus;
});
var StyledMenuItem = /*#__PURE__*/styled$1(MuiMenuItem)(_templateObject2$m || (_templateObject2$m = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), MenuItemCSS);
var MenuItem = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var divider = _ref2.divider,
      keepMounted = _ref2.keepMounted,
      _onClick = _ref2.onClick,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded$O);

  var _useMenu = useMenu(),
      onClose = _useMenu.onClose;

  return React__default.createElement(Fragment, null, React__default.createElement(StyledMenuItem, Object.assign({}, rest, {
    ref: ref,
    onClick: function onClick(e) {
      _onClick && _onClick(e);
      !keepMounted && onClose();
    }
  })), divider && React__default.createElement(Divider__default, {
    className: "m-0"
  }));
});
MenuItem.displayName = 'MenuItem';

var _excluded$P = ["onClick", "keepMounted"];
var MenuListItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _onClick = _ref.onClick,
      keepMounted = _ref.keepMounted,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$P);

  var _useMenu = useMenu(),
      onClose = _useMenu.onClose;

  return React__default.createElement(ListItem, Object.assign({}, rest, {
    ref: ref,
    onClick: function onClick(e) {
      _onClick && _onClick(e);
      !keepMounted && onClose();
    }
  }));
});
MenuListItem.displayName = 'MenuListItem';

/**
 * The menu component supports whatever you want as markup for the button and content.
 *
 * You can either use the `Menu.Item` component for default styling in each item or use whatever markup you need.
 *
 * The open menu will take 300px width as default, but can be overridden with your own style.
 */

var Menu = function Menu(_ref) {
  var children = _ref.children;
  return React__default.createElement(MenuProvider, null, children);
};
Menu.Button = MenuButton;
Menu.Content = MenuContent;
Menu.Item = MenuItem;
Menu.ListItem = MenuListItem;

var _excluded$Q = ["label", "active", "done", "component", "onClick"];

var _templateObject$G, _templateObject2$n, _templateObject3$d, _templateObject4$7;
var stepIndicatorSize = 1.25; // rem

var stepIndicatorBorderWidth = 2; // px

var StepWrapper = /*#__PURE__*/styled$1(Box$1)(_templateObject$G || (_templateObject$G = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  align-items: flex-start;\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n\n  &:not(:last-child) {\n    padding-bottom: 0.75rem;\n\n    &:before {\n      background: ", ";\n      bottom: 0;\n      content: '';\n      position: absolute;\n      top: ", "rem;\n      right: calc(\n        ", "rem -\n          ", "px\n      );\n      width: ", "px;\n      z-index: 0;\n    }\n  }\n\n  &:not(:first-child) {\n    margin-top: -0.25rem;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.greys.grey2;
}, stepIndicatorSize / 2, stepIndicatorSize / stepIndicatorBorderWidth, stepIndicatorBorderWidth / 2, stepIndicatorBorderWidth);
var StepLabel = /*#__PURE__*/styled$1(Typography)(_templateObject2$n || (_templateObject2$n = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  flex: 1;\n  overflow-wrap: anywhere;\n"])));
var StepIndicator = /*#__PURE__*/styled$1.div(_templateObject3$d || (_templateObject3$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  align-items: center;\n  background: ", ";\n  border-radius: 50%;\n  display: flex;\n  height: ", "rem;\n  justify-content: center;\n  margin-top: 4px;\n  width: ", "rem;\n  min-width: ", "rem;\n  z-index: 1;\n\n  &.active:not(.done) {\n    border: ", "px solid\n      ", ";\n    height: calc(", "rem + ", "px);\n    margin-bottom: ", "px;\n    margin-right: ", "px;\n    margin-top: ", "px;\n    margin-left: ", ";\n    min-width: calc(", "rem + ", "px);\n    width: calc(", "rem + ", "px);\n  }\n\n  &.done {\n    background: ", ";\n    color: ", ";\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.greys.grey2;
}, stepIndicatorSize, stepIndicatorSize, stepIndicatorSize, stepIndicatorBorderWidth, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.primary.main;
}, stepIndicatorSize, stepIndicatorBorderWidth, stepIndicatorBorderWidth * -0.5, stepIndicatorBorderWidth * -0.5, 4 + stepIndicatorBorderWidth * -0.5, function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacing();
}, stepIndicatorSize, stepIndicatorBorderWidth, stepIndicatorSize, stepIndicatorBorderWidth, function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.primary.main;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.getContrastText(theme.palette.primary.main);
});
var ButtonLink = /*#__PURE__*/styled$1.button(_templateObject4$7 || (_templateObject4$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  all: unset;\n\n  &:hover {\n    text-decoration: underline;\n    cursor: pointer;\n  }\n"])));

var getLabel = function getLabel(props) {
  var active = props.active,
      label = props.label,
      onClick = props.onClick;

  if (active) {
    return React__default.createElement("strong", null, label);
  }

  if (onClick) {
    return React__default.createElement(ButtonLink, {
      onClick: onClick
    }, label);
  }

  return label;
};

var Step = function Step(_ref7) {
  var label = _ref7.label,
      active = _ref7.active,
      done = _ref7.done,
      _ref7$component = _ref7.component,
      component = _ref7$component === void 0 ? 'li' : _ref7$component,
      onClick = _ref7.onClick,
      rest = _objectWithoutPropertiesLoose(_ref7, _excluded$Q);

  var stepLabel = getLabel({
    active: active,
    label: label,
    onClick: onClick
  });
  return React__default.createElement(StepWrapper, Object.assign({
    key: label,
    component: component
  }, rest), React__default.createElement(StepLabel, null, stepLabel), React__default.createElement(StepIndicator, {
    className: classNames({
      done: done,
      active: active
    })
  }, done && React__default.createElement(Icon, {
    fontSize: "small",
    name: "check",
    color: "inherit"
  })));
};
Step.displayName = 'Step';

var _excluded$R = ["children", "component", "padding", "margin"];

var _templateObject$H;
var StepperWrapper = /*#__PURE__*/styled$1(Box$1)(_templateObject$H || (_templateObject$H = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n"])));
/**
 * Wrapper component for `Steps`.
 */

var Stepper = function Stepper(_ref) {
  var children = _ref.children,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'ol' : _ref$component,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 0 : _ref$padding,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? 0 : _ref$margin,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$R);

  return React__default.createElement(StepperWrapper, Object.assign({}, rest, {
    component: component,
    margin: margin,
    padding: padding
  }), children);
};
Stepper.Step = Step;
Stepper.displayName = 'Stepper';

var CONTENT_WIDTH = {
  xs: 960,
  lg: 1180,
  xl: 1360
};
var CONTENT_WIDTH_NARROW = 460;
var CONTENT_PADDING = {
  xs: 4,
  md: 8
};

var _excluded$S = ["children", "padding"];
var MainContentBox = function MainContentBox(_ref) {
  var children = _ref.children,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 'all' : _ref$padding,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$S);

  return React__default.createElement(Box$1, Object.assign({
    margin: "0 auto",
    maxWidth: CONTENT_WIDTH,
    pl: CONTENT_PADDING,
    pr: CONTENT_PADDING,
    pt: ['all', 'xtOnly'].includes(padding) ? CONTENT_PADDING : undefined,
    pb: ['all', 'xbOnly'].includes(padding) ? CONTENT_PADDING : undefined,
    width: 1
  }, rest), children);
};

var Tab = function Tab(props) {
  return React__default.createElement("div", Object.assign({}, props));
};
Tab.displayName = 'Tab';

var tabPanelId = function tabPanelId(identifier) {
  return "nav-tabpanel-" + identifier;
};

var tabId = function tabId(identifier) {
  return "nav-tab-" + identifier;
};

var a11yPropsTab = function a11yPropsTab(identifier) {
  return {
    'aria-controls': tabPanelId(identifier),
    id: tabId(identifier)
  };
};
var a11yPropsTabPanel = function a11yPropsTabPanel(identifier) {
  return {
    'aria-labelledby': tabId(identifier),
    id: tabPanelId(identifier)
  };
};

var _excluded$T = ["children", "identifier", "value"];
var TabPanel = function TabPanel(_ref) {
  var children = _ref.children,
      identifier = _ref.identifier,
      value = _ref.value,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$T);

  return React__default.createElement("div", Object.assign({}, rest, a11yPropsTabPanel(identifier), {
    hidden: value !== identifier,
    role: "tabpanel"
  }), value === identifier && children);
};
TabPanel.displayName = 'TabPanel';

var _excluded$U = ["className", "hideDivider"];
var TabsBase = /*#__PURE__*/withStyles(function (theme) {
  return createStyles$1({
    root: {
      position: 'relative',
      marginBottom: 0,
      '&.divider::after': {
        content: '""',
        position: 'absolute',
        height: 1,
        background: theme.palette.divider,
        left: theme.spacing(2.4),
        right: theme.spacing(2.4),
        bottom: 0
      },
      '& .scroll-button': {
        background: theme.palette.background["default"],
        border: theme.shape.borderRadius,
        bottom: 0,
        opacity: 1,
        position: 'absolute',
        top: 0,
        zIndex: 100,
        '&::before': {
          background: theme.palette.background["default"],
          borderRadius: theme.shape.borderRadius,
          bottom: 0,
          content: '""',
          display: 'block',
          left: 0,
          position: 'absolute',
          right: 0,
          top: 0
        },
        '& svg': {
          zIndex: 100
        },
        '&:first-child': {
          left: 0
        },
        '&:last-child': {
          right: 0
        },
        '&:hover:not(:active)': {
          opacity: 1,
          '&::before': {
            background: theme.palette.action.hover
          }
        },
        '&:active': {
          opacity: 1,
          '&::before': {
            background: theme.palette.action.focus
          }
        }
      },
      '& .scroll-button--hidden': {
        opacity: 0,
        overflow: 'hidden',
        width: 0
      }
    },
    indicator: {
      backgroundColor: 'transparent',
      bottom: 8,
      display: 'flex',
      height: 4,
      justifyContent: 'center',
      '& > span': {
        background: theme.palette.fjordGreen,
        borderRadius: 2,
        height: '100%',
        transform: 'rotate(180deg)',
        width: 'calc(100% - 24px)'
      }
    }
  });
})(function (_ref) {
  var className = _ref.className,
      hideDivider = _ref.hideDivider,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$U);

  return React__default.createElement(MuiTabs, Object.assign({}, rest, {
    textColor: "inherit",
    className: classNames({
      divider: !hideDivider
    }, className),
    TabIndicatorProps: {
      children: React__default.createElement("span", null)
    }
  }));
});

var _templateObject$I;
var StyledTab = /*#__PURE__*/styled$1(MuiTab)(_templateObject$I || (_templateObject$I = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), focusVisibleInsetBoxShadow);
var TabTitle = /*#__PURE__*/withStyles(function (theme) {
  return createStyles$1({
    root: {
      borderRadius: theme.shape.borderRadius,
      fontWeight: theme.typography.fontWeightRegular,
      marginLeft: theme.spacing(3),
      marginRight: theme.spacing(3),
      maxWidth: 'none',
      minHeight: 0,
      minWidth: 0,
      display: 'flex',
      color: theme.palette.text.primary,
      flexDirection: 'row',
      opacity: 1,
      paddingBottom: theme.spacing(3),
      paddingTop: theme.spacing(3),
      textTransform: 'none',
      zIndex: 1,
      '&:hover': {
        background: theme.palette.action.hover
      },
      '&:active': {
        background: theme.palette.action.focus
      },
      '&:first-child': {
        marginLeft: 0
      }
    },
    selected: {
      fontWeight: theme.typography.fontWeightBold
    },
    wrapper: {
      flexDirection: 'row'
    }
  });
})(function (props) {
  return React__default.createElement(StyledTab, Object.assign({
    wrapped: false
  }, props));
});

var _excluded$V = ["aria-label", "children", "contained", "defaultTab", "dense", "hideDivider", "onChange", "selectedTab"],
    _excluded2$6 = ["identifier", "tabTitle"];

var _templateObject$J, _templateObject2$o;
var TabMenuButton = /*#__PURE__*/styled$1(Menu.Button)(_templateObject$J || (_templateObject$J = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-weight: bold;\n\n  *:not(.badge) {\n    font-size: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.body2.fontSize;
});
var TabMenuListItem = /*#__PURE__*/styled$1(Menu.ListItem)(_templateObject2$o || (_templateObject2$o = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  .primary,\n  .primary *:not(.badge) {\n    font-size: ", ";\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.body2.fontSize;
});
var Tabs = function Tabs(_ref3) {
  var _children$props, _content$, _content$$props, _content$find, _content$find$props;

  var ariaLabel = _ref3['aria-label'],
      children = _ref3.children,
      contained = _ref3.contained,
      defaultTab = _ref3.defaultTab,
      dense = _ref3.dense,
      hideDivider = _ref3.hideDivider,
      _onChange = _ref3.onChange,
      selectedTab = _ref3.selectedTab,
      rest = _objectWithoutPropertiesLoose(_ref3, _excluded$V);

  var content = (Array.isArray(children) ? children : children.type === Fragment ? ((_children$props = children.props) == null ? void 0 : _children$props.children) || [] : []).filter(function (item) {
    var _item$props, _item$props2;

    return (item == null ? void 0 : (_item$props = item.props) == null ? void 0 : _item$props.tabTitle) && (item == null ? void 0 : (_item$props2 = item.props) == null ? void 0 : _item$props2.children);
  });
  if (selectedTab != null && !content.some(function (item, index) {
    var _item$props3;

    return (item == null ? void 0 : (_item$props3 = item.props) == null ? void 0 : _item$props3.identifier) === selectedTab || index === selectedTab;
  })) console.error('Selected tab does not correspond to identifier or index of any provided tab.');
  if (selectedTab == null && defaultTab != null && !content.some(function (item, index) {
    var _item$props4;

    return (item == null ? void 0 : (_item$props4 = item.props) == null ? void 0 : _item$props4.identifier) === defaultTab || index === defaultTab;
  })) console.error('Default tab does not correspond to identifier or index of any provided tab.');

  var _useState = useState(selectedTab != null ? selectedTab : defaultTab != null ? defaultTab : ((_content$ = content[0]) == null ? void 0 : (_content$$props = _content$.props) == null ? void 0 : _content$$props.identifier) || 0),
      value = _useState[0],
      setValue = _useState[1];

  useEffect(function () {
    var _content$2;

    return setValue(selectedTab != null ? selectedTab : ((_content$2 = content[0]) == null ? void 0 : _content$2.props.identifier) || 0);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [selectedTab]);

  var _useEnovaContext = useEnovaContext(),
      theme = _useEnovaContext.theme,
      setTheme = _useEnovaContext.setTheme;

  useLayoutEffect(function () {
    return setTheme(theme);
  });
  var containedContentBoxProps = contained ? {
    pl: 0,
    pr: 0,
    margin: 0
  } : {};
  return React__default.createElement(Fragment, null, React__default.createElement(Hidden, {
    smUp: true
  }, React__default.createElement(MainContentBox, Object.assign({}, containedContentBoxProps, {
    display: "flex",
    flexDirection: "column",
    pb: 2
  }), React__default.createElement(Menu, null, React__default.createElement(TabMenuButton, {
    dropdownIcon: true,
    variant: "secondary"
  }, React__default.createElement("div", {
    className: "f-fill text-start"
  }, (_content$find = content.find(function (_ref4, index) {
    var identifier = _ref4.props.identifier;
    return [identifier, index].includes(value);
  })) == null ? void 0 : (_content$find$props = _content$find.props) == null ? void 0 : _content$find$props.tabTitle)), React__default.createElement(Menu.Content, null, content.map(function (_ref5, index) {
    var _ref5$props = _ref5.props,
        tabTitle = _ref5$props.tabTitle,
        identifier = _ref5$props.identifier;
    return React__default.createElement(TabMenuListItem, Object.assign({
      button: true,
      divider: index !== content.length - 1,
      key: identifier != null ? identifier : index,
      onClick: function onClick(e) {
        setValue(identifier || index);
        _onChange && _onChange(e, identifier || index);
      },
      selected: [identifier, index].includes(value)
    }, a11yPropsTab(identifier || index)), tabTitle);
  }))))), React__default.createElement(Hidden, {
    smDown: true
  }, React__default.createElement(MainContentBox, Object.assign({}, containedContentBoxProps, {
    pb: dense ? 0 : 2,
    pt: 2
  }), React__default.createElement(TabsBase, Object.assign({}, rest, {
    "aria-label": ariaLabel,
    hideDivider: true,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: function onChange(e, newValue) {
      setValue(newValue);
      _onChange && _onChange(e, newValue);
    },
    scrollButtons: "auto",
    TabScrollButtonProps: {
      'aria-label': 'Scroll',
      classes: {
        disabled: 'scroll-button--hidden',
        root: 'scroll-button'
      },
      role: 'button'
    },
    value: value,
    variant: "scrollable"
  }), content.map(function (_ref6, index) {
    var _ref6$props = _ref6.props;
    _ref6$props = _ref6$props === void 0 ? {} : _ref6$props;
    var tabTitle = _ref6$props.tabTitle,
        identifier = _ref6$props.identifier;
    return React__default.createElement(TabTitle, Object.assign({
      key: identifier != null ? identifier : index,
      label: tabTitle,
      value: identifier || index
    }, a11yPropsTab(identifier || index)));
  }))), !hideDivider && React__default.createElement(Divider__default, null)), React__default.createElement(MainContentBox, Object.assign({}, containedContentBoxProps, {
    pt: dense ? 0 : 2
  }), content.map(function (item, index) {
    var _item$props5 = item.props,
        identifier = _item$props5.identifier,
        props = _objectWithoutPropertiesLoose(_item$props5, _excluded2$6);

    return React__default.createElement(TabPanel, {
      identifier: identifier != null ? identifier : index,
      key: identifier != null ? identifier : index,
      value: value
    }, createElement(item.type, props));
  })));
};
Tabs.Tab = Tab;
Tabs.displayName = 'Tabs';

var Pagination = function Pagination(_ref) {
  var currentPage = _ref.currentPage,
      onChange = _ref.onChange,
      pageCount = _ref.pageCount;
  return React__default.createElement(Pagination$1, {
    count: pageCount,
    page: currentPage,
    onChange: onChange
  });
};

var _templateObject$K;
var StyledAccordion = /*#__PURE__*/withStyles({
  root: {
    background: 'transparent',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 'auto'
    }
  },
  expanded: {}
})(MuiAccordion);
var AccordionSummary = /*#__PURE__*/withStyles(function (theme) {
  return {
    root: {
      background: 'transparent',
      border: 0,
      borderTop: "thin solid " + theme.palette.divider,
      marginBottom: -1,
      paddingTop: theme.spacing(4.4),
      paddingRight: theme.spacing(3),
      paddingBottom: theme.spacing(4.4),
      paddingLeft: theme.spacing(3),
      '&:hover': {
        textDecoration: 'underline',
        background: theme.palette.action.hover
      },
      '&:focus-visible': {
        zIndex: 10,
        borderRadius: 1,
        boxShadow: "0 0 0 0.1rem " + (theme.palette.mode === 'dark' ? theme.palette.common.black : theme.palette.common.white) + ", 0 0 0 0.25rem " + (theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black)
      }
    },
    content: {
      alignItems: 'center',
      '& p': {
        lineHeight: 1
      },
      margin: 0,
      '&$expanded': {
        margin: 0
      }
    },
    expanded: {}
  };
})(MuiAccordionSummary);
var AccordionIcon = /*#__PURE__*/styled$1(Icon)(_templateObject$K || (_templateObject$K = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n\n  &.rotate {\n    transform: rotate(-180deg);\n  }\n"])), /*#__PURE__*/fastTransition());
var AccordionDetails = /*#__PURE__*/withStyles(function (theme) {
  return {
    root: {
      paddingBottom: theme.spacing(6.4),
      paddingTop: theme.spacing(2.4),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3)
    }
  };
})(MuiAccordionDetails);
var AccordionItem = function AccordionItem(_ref) {
  var children = _ref.children,
      ExpandableAreaProps = _ref.ExpandableAreaProps,
      HeaderProps = _ref.HeaderProps,
      initExpanded = _ref.initExpanded,
      title = _ref.title,
      unmountOnExit = _ref.unmountOnExit;

  var _useState = useState(!!initExpanded),
      expanded = _useState[0],
      setExpanded = _useState[1];

  var id = useMemo(function () {
    return nanoid();
  }, []);
  return React__default.createElement(StyledAccordion, {
    expanded: expanded,
    onChange: function onChange() {
      return setExpanded(function (prev) {
        return !prev;
      });
    },
    square: true,
    TransitionProps: {
      unmountOnExit: unmountOnExit
    }
  }, React__default.createElement(AccordionSummary, Object.assign({}, HeaderProps, {
    "aria-controls": "panel-content-" + id,
    id: "panel-header-" + id
  }), typeof title === 'string' ? React__default.createElement(Typography, {
    bold: true
  }, title) : title, React__default.createElement(AccordionIcon, {
    className: classNames('ml-auto', {
      rotate: expanded
    }),
    name: "chevron_down"
  })), React__default.createElement(AccordionDetails, Object.assign({}, ExpandableAreaProps), typeof children === 'string' ? React__default.createElement(Typography, null, children) : children));
};
AccordionItem.displayName = 'AccordionItem';

var _excluded$W = ["children", "className"];
var Accordion = function Accordion(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$W);

  return React__default.createElement("div", Object.assign({
    className: classNames('EfcAccordion', className)
  }, rest), children);
};
Accordion.Item = AccordionItem;
Accordion.displayName = 'Accordion';

var _templateObject$L, _templateObject2$p;

var _excluded$X = ["bold", "color", "variant"],
    _excluded2$7 = ["children", "dense", "error", "title", "TitleProps"];
var FactBoxTitle = function FactBoxTitle(_ref) {
  var _ref$bold = _ref.bold,
      bold = _ref$bold === void 0 ? true : _ref$bold,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'inherit' : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'h3' : _ref$variant,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$X);

  return React__default.createElement(Typography, Object.assign({
    variant: variant,
    bold: bold,
    color: color
  }, rest));
};
var TitleWrapper = /*#__PURE__*/styled$1(Box$1)(_templateObject$L || (_templateObject$L = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  border-top-left-radius: ", "px;\n  border-top-right-radius: ", "px;\n\n  * {\n    color: inherit;\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.shape.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.shape.borderRadius;
});
var ContentWrapper$2 = /*#__PURE__*/styled$1(Box$1)(_templateObject2$p || (_templateObject2$p = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: ", ";\n  border-bottom-left-radius: ", "px;\n  border-bottom-right-radius: ", "px;\n  border: thin solid ", ";\n  border-top: none;\n  margin: 0;\n  overflow: hidden;\n\n  &.error {\n    border-color: ", ";\n  }\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.background.paper;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.shape.borderRadius;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.shape.borderRadius;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.palette.divider;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.palette.error.main;
});
var FactBox = function FactBox(_ref9) {
  var children = _ref9.children,
      dense = _ref9.dense,
      error = _ref9.error,
      title = _ref9.title,
      TitleProps = _ref9.TitleProps,
      rest = _objectWithoutPropertiesLoose(_ref9, _excluded2$7);

  return React__default.createElement(Box$1, Object.assign({}, rest), React__default.createElement(TitleWrapper, {
    className: "bg-primary",
    padding: 4
  }, typeof title === 'string' ? React__default.createElement(FactBoxTitle, Object.assign({}, TitleProps), title) : title), React__default.createElement(ContentWrapper$2, Object.assign({}, dense ? {} : {
    paddingX: 4,
    paddingY: 5
  }, {
    className: classNames({
      error: error
    })
  }), typeof children === 'string' ? React__default.createElement(Typography, null, children) : children));
};
FactBox.Title = FactBoxTitle;
FactBox.displayName = 'FactBox';

var _excluded$Y = ["children", "dense", "error", "ExpandableAreaProps", "HeaderProps", "initExpanded", "title", "TitleProps", "unmountOnExit"];

var _templateObject$M;
var StyledAccordion$1 = /*#__PURE__*/withStyles(function (theme) {
  return {
    root: {
      background: 'transparent',
      boxShadow: 'none',
      borderRadius: theme.shape.borderRadius,
      '&:not(:last-child)': {
        borderBottom: 0
      },
      '&:before': {
        display: 'none'
      },
      '&.expanded': {
        margin: 'auto'
      }
    }
  };
})(MuiAccordion);
var AccordionSummary$1 = /*#__PURE__*/withStyles(function (theme) {
  return {
    root: {
      background: 'transparent',
      border: 0,
      borderRadius: theme.shape.borderRadius,
      marginBottom: -1,
      padding: theme.spacing(4),
      '&:hover': {
        background: theme.palette.primary.dark
      },
      '&:focus-visible': {
        zIndex: 10,
        background: theme.palette.primary.dark,
        borderBottomLeftRadius: theme.shape.borderRadius + "px !important",
        borderBottomRightRadius: theme.shape.borderRadius + "px !important",
        boxShadow: "0 0 0 0.1rem " + (theme.palette.mode === 'dark' ? theme.palette.common.black : theme.palette.common.white) + ", 0 0 0 0.25rem " + (theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black)
      },
      '&$expanded': {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        margin: 0
      }
    },
    content: {
      alignItems: 'center',
      margin: 0,
      '&$expanded': {
        margin: 0
      }
    },
    expanded: {}
  };
})(MuiAccordionSummary);
var AccordionIcon$1 = /*#__PURE__*/styled$1(Icon)(_templateObject$M || (_templateObject$M = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n\n  &.rotate {\n    transform: rotate(-180deg);\n  }\n"])), /*#__PURE__*/fastTransition());
var AccordionDetails$1 = /*#__PURE__*/withStyles(function (theme) {
  return {
    root: {
      background: theme.palette.background.paper,
      border: "thin solid " + theme.palette.divider,
      borderBottomLeftRadius: theme.shape.borderRadius,
      borderBottomRightRadius: theme.shape.borderRadius,
      borderTop: 'none',
      flexDirection: 'column',
      overflow: 'hidden',
      padding: theme.spacing(5, 4),
      position: 'relative',
      '&.error': {
        borderColor: theme.palette.error.main
      },
      '&.dense': {
        padding: 0
      }
    }
  };
})(MuiAccordionDetails);
var CollapsibleFactBox = function CollapsibleFactBox(_ref) {
  var children = _ref.children,
      dense = _ref.dense,
      error = _ref.error,
      ExpandableAreaProps = _ref.ExpandableAreaProps,
      HeaderProps = _ref.HeaderProps,
      initExpanded = _ref.initExpanded,
      title = _ref.title,
      TitleProps = _ref.TitleProps,
      unmountOnExit = _ref.unmountOnExit,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$Y);

  var _useState = useState(!!initExpanded),
      expanded = _useState[0],
      setExpanded = _useState[1];

  var id = useMemo(function () {
    return nanoid();
  }, []);
  return React__default.createElement(StyledAccordion$1, Object.assign({
    className: classNames({
      expanded: expanded
    }),
    expanded: expanded,
    onChange: function onChange() {
      return setExpanded(function (prev) {
        return !prev;
      });
    },
    square: true,
    TransitionProps: {
      unmountOnExit: unmountOnExit
    }
  }, rest), React__default.createElement(AccordionSummary$1, Object.assign({}, HeaderProps, {
    "aria-controls": "panel-content-" + id,
    className: classNames('bg-primary', HeaderProps == null ? void 0 : HeaderProps.className),
    id: "panel-header-" + id
  }), typeof title === 'string' ? React__default.createElement(FactBoxTitle, Object.assign({}, TitleProps), title) : title, React__default.createElement(AccordionIcon$1, {
    className: classNames('ml-auto', {
      rotate: expanded
    }),
    name: "chevron_down"
  })), React__default.createElement(AccordionDetails$1, Object.assign({}, ExpandableAreaProps, {
    className: classNames(ExpandableAreaProps == null ? void 0 : ExpandableAreaProps.className, {
      dense: dense,
      error: error
    })
  }), typeof children === 'string' ? React__default.createElement(Typography$1, null, children) : children));
};
CollapsibleFactBox.Title = FactBoxTitle;
CollapsibleFactBox.displayName = 'CollapsibleFactBox';

var _excluded$Z = ["children"];

var Box = function Box(_ref) {
  var children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$Z);

  return React__default.createElement(Box$1, Object.assign({}, rest), children);
};

Box.displayName = 'Box';

var _excluded$_ = ["children"];

var Collapse = function Collapse(_ref) {
  var children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$_);

  return React__default.createElement(Collapse$1, Object.assign({}, rest), children);
};

Collapse.displayName = 'Collapse';

export { Accordion, AppBar, Autocomplete, Badge, Box, Button, CONTENT_PADDING, CONTENT_WIDTH, CONTENT_WIDTH_NARROW, CheckButton, CheckGroup, Checkbox, Chip, Collapse, CollapsibleFactBox, ContentWrapper$2 as ContentWrapper, DatePicker, DefaultTheme, Dialog, DialogActions, DialogContent, DialogTitle, Drawer, DrawerSizingCSS, EnergyGrade, EnergyGrades, EnergyRating, EnergyRating2D, EnergyRatingIndicator, EnovaContextProvider, FactBox, FactBoxTitle, Footer, Form, FormMessage, FullScreenLoader, Grid, GridSpacingOptions, HeatingGrade, HeatingGrades, HelperBox, Icon, IconButton, IconButtonCSS, IconOptions, InfoBox, LargeIcon, LargeIconOptions, Layout, LineArt, LineArtOptions, Link, LinkVariants, List, ListItem, Loader, Logo, Main, MainContentBox, Menu, MenuContext, MenuProvider, Notification, NumberField, NumberPicker, Pagination, Paper, Radio, RadioButton, RadioGroup, RowsPerPage, SearchField, Select, Shape, ShapeOptions, Step, Stepper, StylizedButton, Table, Tabs, TextArea, TextField, ThemeProvider, TitleWrapper, ToggleButton, Typography, TypographyComponents, TypographyVariants, UserBox, bgGradient, bgGradientSecondary, bgGradientSecondaryVertical, bgGradientVertical, createEnovaTheme, createGlobalStyle, css, efcDarken, efcLighten, getGradient, getGradientSecondary, getGradientSecondaryVertical, getGradientVertical, gradient, keyframes, reservedKeys, roofSize, styled$1 as styled, useEnovaContext, useLocalStorage, useMenu, useSnack };
//# sourceMappingURL=enova-frontend-components.esm.js.map
